import {
  Unit_instanceat14thlj150z as Unit_instance,
  compareTo3ankvs086tmwq as compareTo,
  coerceIn10f36k81le1mm as coerceIn,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  StringBuildermazzzhj6kkai as StringBuilder,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Enum3alwj03lh1n41 as Enum,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  equals2au1ep9vhcato as equals,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lazy2hsh8ze7j6ikd as lazy,
  binarySearchyyczvdessj07 as binarySearch,
  first58ocm7j58k3q as first,
  last1vo29oleiqj36 as last,
  getOrNull1go7ef9ldk0df as getOrNull,
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfvhqybd2zx248 as listOf,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  contentEquals5p44wfjhu6ta as contentEquals,
  contentHashCodem24x0wy7gjt7 as contentHashCode,
  contentToString28hodxfcotn0 as contentToString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  until1jbpn0z3f8lbg as until,
  createThis2j2avj17cvnv2 as createThis,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  listOf1jh22dvmctj1r as listOf_0,
  last3s1sh0kl8j0vf as last_0,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  plus310ted5e4i90h as plus,
  distinct10qe1scfdvu5k as distinct,
  toIntArray2d4xwvtjb01mq as toIntArray,
  sortedArray2m4d4tn4pbwoi as sortedArray,
  toList383f556t1dixk as toList,
  Paire9pteg33gng7 as Pair,
  step18s9qzr5xwxat as step,
  get_sign1dnxi33u9vk0c as get_sign,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  numberToDouble210hrknaofnhf as numberToDouble,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  toString30pk9tzaqopn as toString_0,
  Comparable198qfk8pnblz0 as Comparable,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  replaceqbix900hl8kl as replace,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  KProperty02ce7r476m8633 as KProperty0,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IntArrayList3liuagbdnwmna as IntArrayList,
  _BSearchResult___init__impl__em6zam3kgjdixysmohf as _BSearchResult___init__impl__em6zam,
  _BSearchResult___get_found__impl__om04iz3bh6o9yjop0o as _BSearchResult___get_found__impl__om04iz,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  getCyclic28wvgqye98jqx as getCyclic,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  sort23bpsawysis6n as sort,
  pointArrayListOf7rbgdbqf3x4b as pointArrayListOf,
  pointArrayListOf2s9je3njyg83l as pointArrayListOf_0,
  pointArrayListOf36sb9r6prgwk4 as pointArrayListOf_1,
  binarySearch1lxbagta5e4q4 as binarySearch_0,
  _BSearchResult___get_index__impl__b5kraz2d2rlh08ytgci as _BSearchResult___get_index__impl__b5kraz,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  getCyclic18d9063nmuul as getCyclic_0,
  swap3upf401qn4fc8 as swap,
  rotateRight96vk8nw2c6nx as rotateRight,
  SortOps3rp25tm4jbjru as SortOps,
  genericSort3vhmyxbppxo3h as genericSort,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  get_size3oaoh8cpamcqc as get_size,
  Pool1zbsw0zhvh8ca as Pool,
  PointIntArrayList1s7gare9hr1oh as PointIntArrayList,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance,
  Companion_getInstance3rze5babd97ff as Companion_getInstance_0,
  _Angle___init__impl__g23q1m36yxttgnpy5tv as _Angle___init__impl__g23q1m,
  adjustFromUp1ak85cceintt4 as adjustFromUp,
  Angle__minus_impl_xeau7ko02ca30grn4a as Angle__minus_impl_xeau7k,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__plus_impl_26v37karx983dsduoy as Angle__plus_impl_26v37k,
  _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle as _Angle___get_absoluteValue__impl__4qoakv,
  Angle__umod_impl_4wilf71vq5gai237g1r as Angle__umod_impl_4wilf7,
  Angle__compareTo_impl_a0hfds24obl4qqhxk1t as Angle__compareTo_impl_a0hfds,
  _Angle___get_ratio__impl__ap3on435dv91f5cbp85 as _Angle___get_ratio__impl__ap3on4,
  interpolatewhd2sgxffql5 as interpolate,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__cosine_impl_bgvzun1b2925dagclby as Angle__cosine_impl_bgvzun,
  Angle__sine_impl_3l11xv3pgl8zzgp52i0 as Angle__sine_impl_3l11xv,
  interpolateAngleDenormalized1hkwzk523mo1c as interpolateAngleDenormalized,
  transformY3ktoxhxwkzwk1 as transformY,
  transformX33nszy4vzqsfy as transformX,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_1,
  Line2D2pf35pcx71ncp as Line2D,
  Angle2itorpob18n08 as Angle,
  outerCircle30hn5vvbpz9gu as outerCircle,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_2,
  _Angle___get_normalized__impl__9s30ys1q15xt9x23bx as _Angle___get_normalized__impl__9s30ys,
  _Angle___get_radians__impl__n00yt518seywpfbf9fr as _Angle___get_radians__impl__n00yt5,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle__div_impl_ut2btd1qmy7ftoy1opp as Angle__div_impl_ut2btd,
  _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq as _Angle___get_cosine__impl__vprvmu,
  _Angle___get_sine__impl__15nmyi39oh4tio4auz1 as _Angle___get_sine__impl__15nmyi,
  _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg as _Angle___get_tangent__impl__vushdy,
  Size2Dum5ayuyhhau7 as Size2D,
  Rectangle3q03woyn9k8x1 as Rectangle,
  Companion_getInstancenbeyvbsm21qs as Companion_getInstance_3,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Companion_getInstance2yu48324co92b as Companion_getInstance_4,
  _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Vector2I2k5512l4eeahb as Vector2I,
  toIntu0rc68akxu7a as toInt,
  Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp as Angle__unaryPlus_impl_eyi5pl,
  Angle__unaryMinus_impl_7901fruk5m76f5kg06 as Angle__unaryMinus_impl_7901fr,
  BoundsBuilder162uwsje56mvu as BoundsBuilder,
  BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm as BoundsBuilder__plus_impl_cz7f7x_0,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_5,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_6,
  _Ratio___get_absoluteValue__impl__92ozif2q8z2akxn3hd8 as _Ratio___get_absoluteValue__impl__92ozif,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  toRatioClampedeq87m2alw3kr as toRatioClamped,
  toRatioa3v13oich5q as toRatio,
  toRatio1hooqit5gulhr as toRatio_0,
  Ratio136tf4z2t0p2d as Ratio,
  clamp1qclpmpfxm7xb as clamp,
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  convertRange139vj18oahy2c as convertRange,
  Ratio__minus_impl_s1uwyg39ebtqskl4ycn as Ratio__minus_impl_s1uwyg,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  Ratio__times_impl_ucdh7yuy2trpt4sqvt as Ratio__times_impl_ucdh7y_0,
  _Ratio___get_value__impl__57cli6w1n0arietzij as _Ratio___get_value__impl__57cli6,
  normalizeZero2ksfd6bzt4qwz as normalizeZero,
  isAlmostEquals18m8qk24p7w0q as isAlmostEquals,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals_0,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  Ratio__toString_impl_mfgt3e2iqv27qr9i5ak as Ratio__toString_impl_mfgt3e,
  Ratio__hashCode_impl_quhc2v2f99yx2uv51mf as Ratio__hashCode_impl_quhc2v,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  isAlmostZero7baqs51et9hm as isAlmostZero,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  convertRange1a6ancvyn151r as convertRange_0,
  interpolate2g7wzskc23f1q as interpolate_0,
  interpolate35pbs3ac913y4 as interpolate_1,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2_0,
  umod164hvijxhfi8p as umod,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  insert2fz5125p2hdyd as insert_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  clamp31lhm66c28ic8 as clamp_0,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_7,
  invoke3idfsdzzpzmqq as invoke,
  invoke1y68e7g1lbvl5 as invoke_0,
  Easing3266vfl8a4o75 as Easing,
  toRatiolga1a9coidva as toRatio_1,
  clampdicp8njiht45 as clamp_1,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  hasExtra1969mplo13qgb as hasExtra,
  Property1m5vulkepgwzd as Property,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class IntSegmentSet {
  constructor() {
    this.u37_1 = IntArrayList.n2j(16);
    this.v37_1 = IntArrayList.n2j(16);
  }
  e1() {
    return this.u37_1.e1();
  }
  g1() {
    return this.e1() === 0;
  }
  o27() {
    return this.e1() > 0;
  }
  zg() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.clear.<anonymous>' call
    this.u37_1.h3();
    this.v37_1.h3();
    return this;
  }
  w37() {
    return this.o27() ? this.u37_1.qx(0) : 0;
  }
  x37() {
    return this.o27() ? this.v37_1.qx(this.v37_1.e1() - 1 | 0) : 0;
  }
  y37(x) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = this.e1() - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findNearIndex.<anonymous>' call
        var min = this.u37_1.qx(mid);
        var max = this.v37_1.qx(mid);
        var mval = x < min ? 1 : x > max ? -1 : 0;
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearch.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  z37(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchLeft' call
    var toIndex = this.e1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findLeftBound.<anonymous>' call
        var mval = compareTo(this.u37_1.qx(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchLeft.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.min' call
      var b = high;
      var tmp$ret$2 = Math.min(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.e1() - 1 | 0);
  }
  a38(x) {
    // Inline function 'korlibs.math.segment.genericBinarySearchRight' call
    var toIndex = this.e1();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = 0;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.findRightBound.<anonymous>' call
        var mval = compareTo(this.v37_1.qx(mid), x);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.math.segment.genericBinarySearchRight.<anonymous>' call
      var low_0 = low;
      // Inline function 'kotlin.math.max' call
      var b = high;
      var tmp$ret$2 = Math.max(low_0, b);
      tmp$ret$1 = coerceIn(tmp$ret$2, 0, toIndex - 1 | 0);
    }
    var tmp$ret$4 = tmp$ret$1;
    return coerceIn(tmp$ret$4, 0, this.e1() - 1 | 0);
  }
  x2r(min, max) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    $l$block_0: {
      // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(min <= max)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.w4(toString(message));
      }
      if (this.g1()) {
        insertAt(this, this.e1(), min, max);
      } else if (min === this.x37()) {
        this.v37_1.a2k(this.v37_1.e1() - 1 | 0, max);
      } else if (max === this.w37()) {
        this.u37_1.a2k(0, min);
      } else {
        var removeStart = -1;
        var removeCount = -1;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (this.g1()) {
            break $l$block;
          }
          var nmin = this.z37(min);
          var nmax = this.a38(max);
          var inductionVariable = nmin;
          if (inductionVariable <= nmax)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.add.<anonymous>.<anonymous>' call
              var n_0 = n;
              var x1 = this.u37_1.qx(n);
              var x2 = this.v37_1.qx(n);
              if (this.b38(x1, x2, min, max)) {
                if (removeStart === -1)
                  removeStart = n_0;
                var tmp = removeStart;
                // Inline function 'kotlin.math.min' call
                var a = this.u37_1.qx(removeStart);
                // Inline function 'kotlin.math.min' call
                var b = Math.min(x1, min);
                var tmp$ret$3 = Math.min(a, b);
                this.u37_1.a2k(tmp, tmp$ret$3);
                var tmp_0 = removeStart;
                // Inline function 'kotlin.math.max' call
                var a_0 = this.v37_1.qx(removeStart);
                // Inline function 'kotlin.math.max' call
                var b_0 = Math.max(x2, max);
                var tmp$ret$5 = Math.max(a_0, b_0);
                this.v37_1.a2k(tmp_0, tmp$ret$5);
                removeCount = removeCount + 1 | 0;
              }
            }
             while (!(n === nmax));
        }
        if (removeCount !== 0)
          if (removeCount > 0) {
            removeAt(this, removeStart + 1 | 0, removeCount);
          } else if (max < this.w37()) {
            insertAt(this, 0, min, max);
          } else if (min > this.x37()) {
            insertAt(this, this.e1(), min, max);
          } else {
            var inductionVariable_0 = coerceAtLeast(this.z37(min), 1);
            var last = this.a38(max);
            if (inductionVariable_0 <= last)
              do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var prevMax = this.v37_1.qx(m - 1 | 0);
                var currMin = this.u37_1.qx(m);
                if (min > prevMax && max < currMin) {
                  insertAt(this, m, min, max);
                  break $l$block_0;
                }
              }
               while (!(m === last));
            // Inline function 'kotlin.error' call
            var message_0 = 'Unexpected';
            throw IllegalStateException.w4(toString(message_0));
          }
      }
    }
    return this;
  }
  cp(v) {
    return _BSearchResult___get_found__impl__om04iz(this.y37(v));
  }
  c38(a, b) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>' call
    var aSmaller = a.e1() < b.e1();
    var av = aSmaller ? a : b;
    var bv = aSmaller ? b : a;
    // Inline function 'kotlin.also' call
    this.zg();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = av.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>' call
        var x1 = av.u37_1.qx(n);
        // Inline function 'korlibs.math.segment.IntSegmentSet.intersection' call
        var max = av.v37_1.qx(n);
        var count = 0;
        $l$block: {
          // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEachInterestingRange' call
          if (bv.g1()) {
            break $l$block;
          }
          var nmin = bv.z37(x1);
          var nmax = bv.a38(max);
          var inductionVariable_0 = nmin;
          if (inductionVariable_0 <= nmax)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              // Inline function 'korlibs.math.segment.IntSegmentSet.intersection.<anonymous>' call
              var x1_0 = bv.u37_1.qx(n_0);
              var x2 = bv.v37_1.qx(n_0);
              if (bv.b38(x1_0, x2, x1, max)) {
                // Inline function 'korlibs.math.segment.IntSegmentSet.setToIntersect.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.math.max' call
                var min = Math.max(x1_0, x1);
                // Inline function 'kotlin.math.min' call
                var max_0 = Math.min(x2, max);
                this.x2r(min, max_0);
                count = count + 1 | 0;
              }
            }
             while (!(n_0 === nmax));
        }
      }
       while (inductionVariable < last);
    return this;
  }
  b38(x1, x2, y1, y2) {
    return x2 >= y1 && y2 >= x1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>' call
    this_0.ob('[');
    // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.segment.IntSegmentSet.toString.<anonymous>.<anonymous>' call
        var min = this.u37_1.qx(n);
        var max = this.v37_1.qx(n);
        var first = n === 0;
        if (!first) {
          this_0.ob(', ');
        }
        this_0.ob('' + min + '-' + max);
      }
       while (inductionVariable < last);
    this_0.ob(']');
    return this_0.toString();
  }
}
class StrokePointsMode extends Enum {}
class StrokePointsBuilder {
  constructor(width, mode, generateDebug) {
    mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
    generateDebug = generateDebug === VOID ? false : generateDebug;
    this.m38_1 = width;
    this.n38_1 = mode;
    this.o38_1 = generateDebug;
    this.p38_1 = 20;
    var tmp = this;
    var tmp_0;
    switch (this.n38_1.n3_1) {
      case 0:
        tmp_0 = 6;
        break;
      case 1:
        tmp_0 = 2;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.q38_1 = new DoubleVectorArrayList(tmp_0);
    this.r38_1 = new PointArrayList();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.s38_1 = ArrayList.h1();
  }
  u38() {
    return this.q38_1;
  }
  toString() {
    return 'StrokePointsBuilder(' + this.m38_1 + ', ' + this.q38_1.toString() + ')';
  }
  v38(pos, normal, width, maxWidth) {
    switch (this.n38_1.n3_1) {
      case 0:
        // Inline function 'kotlin.math.absoluteValue' call

        var tmp$ret$0 = Math.abs(maxWidth);
        this.q38_1.q2k(pos.e25_1, pos.f25_1, normal.e25_1, normal.f25_1, width, tmp$ret$0);
        break;
      case 1:
        this.q38_1.o2k(pos.e25_1 + normal.e25_1 * width, pos.f25_1 + normal.f25_1 * width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  w38(pos, normal, width, maxWidth, $super) {
    maxWidth = maxWidth === VOID ? width : maxWidth;
    var tmp;
    if ($super === VOID) {
      this.v38(pos, normal, width, maxWidth);
      tmp = Unit_instance;
    } else {
      tmp = $super.v38.call(this, pos, normal, width, maxWidth);
    }
    return tmp;
  }
  x38(center, pos, sign) {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var dist = Vector2D.n27(pos.e25_1 - center.e25_1, pos.f25_1 - center.f25_1);
    var tmp;
    if (sign < 0.0) {
      // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
      tmp = Vector2D.n27(-dist.e25_1, -dist.f25_1);
    } else {
      tmp = dist;
    }
    var normal = tmp;
    this.w38(center, normal.y2g(), dist.a() * sign);
  }
  y38(center, pos, sign, $super) {
    sign = sign === VOID ? 1.0 : sign;
    var tmp;
    if ($super === VOID) {
      this.x38(center, pos, sign);
      tmp = Unit_instance;
    } else {
      tmp = $super.x38.call(this, center, pos, sign);
    }
    return tmp;
  }
  z38(pos, normal, width) {
    this.w38(pos, normal, width);
    this.w38(pos, normal, -width);
  }
  a39(curr, next, kind, miterLimitRatio) {
    var commonPoint = curr.b39(Companion_getInstance_6().nx_1);
    var currTangent = curr.c39(Companion_getInstance_6().nx_1);
    var currNormal = curr.d39(Companion_getInstance_6().nx_1);
    var nextTangent = next.c39(Companion_getInstance_6().kx_1);
    var nextNormal = next.d39(Companion_getInstance_6().kx_1);
    var tmp = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = this.m38_1;
    var that = Vector2D.n27(currNormal.e25_1 * scale, currNormal.f25_1 * scale);
    var tmp$ret$1 = Vector2D.n27(commonPoint.e25_1 + that.e25_1, commonPoint.f25_1 + that.f25_1);
    var currLine0 = tmp.e39(tmp$ret$1, currTangent);
    var tmp_0 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_0 = -this.m38_1;
    var that_0 = Vector2D.n27(currNormal.e25_1 * scale_0, currNormal.f25_1 * scale_0);
    var tmp$ret$3 = Vector2D.n27(commonPoint.e25_1 + that_0.e25_1, commonPoint.f25_1 + that_0.f25_1);
    var currLine1 = tmp_0.e39(tmp$ret$3, currTangent);
    var tmp_1 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_1 = this.m38_1;
    var that_1 = Vector2D.n27(nextNormal.e25_1 * scale_1, nextNormal.f25_1 * scale_1);
    var tmp$ret$5 = Vector2D.n27(commonPoint.e25_1 + that_1.e25_1, commonPoint.f25_1 + that_1.f25_1);
    var nextLine0 = tmp_1.e39(tmp$ret$5, nextTangent);
    var tmp_2 = Companion_instance_19;
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale_2 = -this.m38_1;
    var that_2 = Vector2D.n27(nextNormal.e25_1 * scale_2, nextNormal.f25_1 * scale_2);
    var tmp$ret$7 = Vector2D.n27(commonPoint.e25_1 + that_2.e25_1, commonPoint.f25_1 + that_2.f25_1);
    var nextLine1 = tmp_2.e39(tmp$ret$7, nextTangent);
    var intersection0 = lineIntersectionPoint(Companion_instance_19, currLine0, nextLine0);
    var intersection1 = lineIntersectionPoint(Companion_instance_19, currLine1, nextLine1);
    if (intersection0 == null || intersection1 == null) {
      this.z38(commonPoint, currNormal, this.m38_1);
      return Unit_instance;
    }
    var direction = Companion_getInstance().t2g(currTangent, nextTangent);
    var miterLength = Companion_getInstance().q2g(intersection0, intersection1);
    var miterLimit = miterLimitRatio * this.m38_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up = Companion_getInstance().k25_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x = nextTangent.e25_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_0 = nextTangent.f25_1;
    var radians = Math.atan2(x, x_0);
    var tmp$ret$9 = _Angle___init__impl__g23q1m(radians);
    var tmp_3 = adjustFromUp(tmp$ret$9, up);
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().k25_1;
    // Inline function 'korlibs.math.geom.Companion.atan2' call
    var x_1 = currTangent.e25_1;
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    // Inline function 'kotlin.math.atan2' call
    var x_2 = currTangent.f25_1;
    var radians_0 = Math.atan2(x_1, x_2);
    var tmp$ret$13 = _Angle___init__impl__g23q1m(radians_0);
    var tmp$ret$15 = adjustFromUp(tmp$ret$13, up_0);
    var angle = Angle__minus_impl_xeau7k(tmp_3, tmp$ret$15);
    if (!kind.equals(LineJoin_MITER_getInstance()) || miterLength > miterLimit) {
      var p1 = direction <= 0.0 ? projectedPoint(currLine0, commonPoint) : projectedPoint(nextLine1, commonPoint);
      var p2 = direction <= 0.0 ? projectedPoint(nextLine0, commonPoint) : projectedPoint(currLine1, commonPoint);
      var p3 = direction <= 0.0 ? lineIntersectionPoint(Companion_instance_19, currLine1, nextLine1) : lineIntersectionPoint(Companion_instance_19, currLine0, nextLine0);
      var p4Line = direction < 0.0 ? nextLine1 : nextLine0;
      var p4 = projectedPoint(p4Line, commonPoint);
      if (p3 == null) {
        p3 = p4;
      }
      var angleB = _Angle___get_absoluteValue__impl__4qoakv(Angle__plus_impl_26v37k(angle, get_degrees(180)));
      var angle2 = _Angle___get_absoluteValue__impl__4qoakv(Angle__umod_impl_4wilf7(angle, get_degrees(180)));
      var angle3 = Angle__compareTo_impl_a0hfds(angle2, get_degrees(90)) >= 0 ? Angle__minus_impl_xeau7k(get_degrees(180), angle2) : angle2;
      var ratio = toRatioClamped(Ratio__times_impl_ucdh7y(_Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle3)), 4.0));
      var p5 = interpolate(toRatio(ratio), p4, ensureNotNull(p3));
      if (this.o38_1) {
        this.s38_1.h(nextLine1.h39(1000.0).sx());
        this.s38_1.h(currLine1.h39(1000.0).sx());
        this.s38_1.h(nextLine0.h39(1000.0).sx());
        this.s38_1.h(currLine0.h39(1000.0).sx());
        this.s38_1.h(Companion_instance_19.e39(commonPoint, currTangent).h39(1000.0).sx());
        this.s38_1.h(Companion_instance_19.e39(commonPoint, nextTangent).h39(1000.0).sx());
        this.r38_1.i2r(p3);
        this.r38_1.i2r(p4);
        this.r38_1.i2r(p5);
      }
      var p6 = p5;
      if (direction < 0.0) {
        this.y38(commonPoint, p1);
        this.x38(commonPoint, p6, -1.0);
        this.y38(commonPoint, p2);
        this.x38(commonPoint, p6, -1.0);
      } else {
        this.y38(commonPoint, p6);
        this.x38(commonPoint, p2, -1.0);
        this.y38(commonPoint, p6);
        this.x38(commonPoint, p1, -1.0);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d0 = Vector2D.n27(intersection0.e25_1 - commonPoint.e25_1, intersection0.f25_1 - commonPoint.f25_1);
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var d1 = Vector2D.n27(commonPoint.e25_1 - intersection1.e25_1, commonPoint.f25_1 - intersection1.f25_1);
    var tmp_4 = d0.y2g();
    var tmp_5 = d0.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = d0.a();
    var tmp$ret$18 = Math.abs(this_0);
    this.v38(commonPoint, tmp_4, tmp_5, tmp$ret$18);
    var tmp_6 = d1.y2g();
    var tmp_7 = -d1.a();
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = d1.a();
    var tmp$ret$19 = Math.abs(this_1);
    this.v38(commonPoint, tmp_6, tmp_7, tmp$ret$19);
  }
  i39(curr, ratio, kind) {
    switch (kind.n3_1) {
      case 1:
      case 2:
        // Inline function 'kotlin.let' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCap.<anonymous>' call

        var it = curr.d39(ratio).z2g();
        var tmp;
        if (equals(ratio, Companion_getInstance_6().nx_1)) {
          // Inline function 'korlibs.math.geom.Vector2D.unaryMinus' call
          tmp = Vector2D.n27(-it.e25_1, -it.f25_1);
        } else {
          tmp = it;
        }

        var derivate = tmp;
        switch (kind.n3_1) {
          case 1:
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            var this_0 = curr.b39(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale = this.m38_1;
            var that = Vector2D.n27(derivate.e25_1 * scale, derivate.f25_1 * scale);
            var tmp$ret$4 = Vector2D.n27(this_0.e25_1 + that.e25_1, this_0.f25_1 + that.f25_1);
            this.z38(tmp$ret$4, curr.d39(ratio), this.m38_1);
            break;
          case 2:
            var mid = curr.b39(ratio);
            var normal = curr.d39(ratio);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_0 = this.m38_1;
            var that_0 = Vector2D.n27(normal.e25_1 * scale_0, normal.f25_1 * scale_0);
            var p0 = Vector2D.n27(mid.e25_1 + that_0.e25_1, mid.f25_1 + that_0.f25_1);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call

            // Inline function 'korlibs.math.geom.Vector2D.times' call

            var scale_1 = -this.m38_1;
            var that_1 = Vector2D.n27(normal.e25_1 * scale_1, normal.f25_1 * scale_1);
            var p3 = Vector2D.n27(mid.e25_1 + that_1.e25_1, mid.f25_1 + that_1.f25_1);
            var a = equals(ratio, Companion_getInstance_6().kx_1) ? p0 : p3;
            var b = equals(ratio, Companion_getInstance_6().kx_1) ? p3 : p0;
            this.j39(a, b, ratio, mid);
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't happen";
            throw IllegalStateException.w4(toString(message));
        }

        break;
      case 0:
        this.z38(curr.b39(ratio), curr.d39(ratio), this.m38_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  k39(p0, p3, ratio, mid, nsteps) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up = Companion_getInstance().k25_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = mid.e25_1;
    var y0 = mid.f25_1;
    var x1 = p0.e25_1;
    var y1 = p0.f25_1;
    var angleStart = Angle_between(x0, y0, x1, y1, up);
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var up_0 = Companion_getInstance().k25_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0_0 = mid.e25_1;
    var y0_0 = mid.f25_1;
    var x1_0 = p3.e25_1;
    var y1_0 = p3.f25_1;
    var angleEnd = Angle_between(x0_0, y0_0, x1_0, y1_0, up_0);
    if (equals(ratio, Companion_getInstance_6().nx_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_1 = Companion_getInstance().k25_1;
      var tmp$ret$8 = Vector2D.n27(0.0 + Angle__cosine_impl_bgvzun(angleEnd, up_1) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleEnd, up_1) * 1.0);
      this.z38(mid, tmp$ret$8, this.m38_1);
    }
    var addAngle = Companion_getInstance().t2g(p0, p3) <= 0.0 ? Companion_getInstance_0().v24_1 : Companion_getInstance_0().x24_1;
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio_0 = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePointsCap.<anonymous>' call
        var it = toRatio_0(ratio_0);
        var angle = interpolateAngleDenormalized(it, angleStart, angleEnd);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var this_0 = Companion_getInstance();
        var angle_0 = Angle__plus_impl_26v37k(angle, addAngle);
        // Inline function 'korlibs.math.geom.Companion.polar' call
        var up_2 = this_0.k25_1;
        var dir = Vector2D.n27(0.0 + Angle__cosine_impl_bgvzun(angle_0, up_2) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angle_0, up_2) * 1.0);
        this.v38(mid, dir, 0.0, this.m38_1);
        this.v38(mid, dir, this.m38_1, this.m38_1);
      }
       while (!(n === end));
    if (equals(ratio, Companion_getInstance_6().kx_1)) {
      // Inline function 'korlibs.math.geom.Companion.polar' call
      // Inline function 'korlibs.math.geom.Companion.polar' call
      var up_3 = Companion_getInstance().k25_1;
      var tmp$ret$12 = Vector2D.n27(0.0 + Angle__cosine_impl_bgvzun(angleStart, up_3) * 1.0, 0.0 + Angle__sine_impl_3l11xv(angleStart, up_3) * 1.0);
      this.z38(mid, tmp$ret$12, this.m38_1);
    }
  }
  j39(p0, p3, ratio, mid, nsteps, $super) {
    var tmp;
    if (mid === VOID) {
      // Inline function 'korlibs.math.geom.Companion.middle' call
      Companion_getInstance();
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var this_0 = Vector2D.n27(p0.e25_1 + p3.e25_1, p0.f25_1 + p3.f25_1);
      tmp = Vector2D.n27(this_0.e25_1 * 0.5, this_0.f25_1 * 0.5);
    } else {
      tmp = mid;
    }
    mid = tmp;
    nsteps = nsteps === VOID ? this.p38_1 : nsteps;
    var tmp_0;
    if ($super === VOID) {
      this.k39(p0, p3, ratio, mid, nsteps);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.k39.call(this, p0, p3, new Ratio(ratio), mid, nsteps);
    }
    return tmp_0;
  }
  l39(curr, nsteps) {
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = nsteps - 1 | 0;
    var NSd = NS;
    var start = false ? 0 : 1;
    var end = false ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.StrokePointsBuilder.addCurvePoints.<anonymous>' call
        var it = toRatio_0(ratio);
        this.z38(curr.b39(it), curr.d39(it), this.m38_1);
      }
       while (!(n === end));
  }
  m39(curr, nsteps, $super) {
    nsteps = nsteps === VOID ? numberToInt(clamp(curr.a() / 10.0, 10.0, 100.0)) : nsteps;
    var tmp;
    if ($super === VOID) {
      this.l39(curr, nsteps);
      tmp = Unit_instance;
    } else {
      tmp = $super.l39.call(this, curr, nsteps);
    }
    return tmp;
  }
  t38(curves, join, startCap, endCap, miterLimit, forceClosed) {
    var closed = forceClosed == null ? curves.p39_1 : forceClosed;
    var curves_0 = curves.o39_1;
    var inductionVariable = 0;
    var last = curves_0.e1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = getCyclic(curves_0, n + 0 | 0);
        var next = getCyclic(curves_0, n + 1 | 0);
        if (n === 0) {
          if (closed) {
            this.a39(getCyclic(curves_0, n - 1 | 0), curr, join, miterLimit);
          } else {
            this.i39(curr, Companion_getInstance_6().kx_1, startCap);
          }
        }
        if (!(curr.f3a() === 1)) {
          this.m39(curr);
        }
        if (n < (curves_0.e1() - 1 | 0)) {
          this.a39(curr, next, join, miterLimit);
        } else {
          if (closed) {
            this.a39(curr, next, join, miterLimit);
          } else {
            this.i39(curr, Companion_getInstance_6().nx_1, endCap);
          }
        }
      }
       while (inductionVariable <= last);
  }
}
class CurveInfo {
  constructor(index, curve, startLength, endLength, bounds) {
    this.g3a_1 = index;
    this.h3a_1 = curve;
    this.i3a_1 = startLength;
    this.j3a_1 = endLength;
    this.k3a_1 = bounds;
  }
  w2k(length) {
    var containsLower = this.i3a_1;
    return length <= this.j3a_1 ? containsLower <= length : false;
  }
  a() {
    return this.j3a_1 - this.i3a_1;
  }
  toString() {
    return 'CurveInfo(index=' + this.g3a_1 + ', curve=' + this.h3a_1.toString() + ', startLength=' + this.i3a_1 + ', endLength=' + this.j3a_1 + ', bounds=' + this.k3a_1.toString() + ')';
  }
  hashCode() {
    var result = this.g3a_1;
    result = imul(result, 31) + this.h3a_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.i3a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j3a_1) | 0;
    result = imul(result, 31) + this.k3a_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CurveInfo ? other : THROW_CCE();
    if (!(this.g3a_1 === tmp0_other_with_cast.g3a_1))
      return false;
    if (!this.h3a_1.equals(tmp0_other_with_cast.h3a_1))
      return false;
    if (!equals(this.i3a_1, tmp0_other_with_cast.i3a_1))
      return false;
    if (!equals(this.j3a_1, tmp0_other_with_cast.j3a_1))
      return false;
    if (!this.k3a_1.equals(tmp0_other_with_cast.k3a_1))
      return false;
    return true;
  }
}
class Curves {
  constructor(beziers, closed) {
    this.n39_1 = new Mixin();
    this.o39_1 = beziers;
    this.p39_1 = closed;
    this.q39_1 = false;
    var tmp = this;
    tmp.r39_1 = lazy(Curves$contiguous$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s39_1 = lazy(Curves$infos$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.t39_1 = lazy(Curves$length$delegate$lambda(this));
  }
  vx(_set____db54di) {
    this.n39_1.vx(_set____db54di);
  }
  wx() {
    return this.n39_1.wx();
  }
  m3a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s39_1;
    infos$factory();
    return this_0.r1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t39_1;
    length$factory();
    return this_0.r1();
  }
  n3a(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.i3a_1 / this.a());
  }
  o3a(_this__u8e3s4) {
    return _Ratio___init__impl__9mwvn2(_this__u8e3s4.j3a_1 / this.a());
  }
  p3a(t) {
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var tmp = this.m3a();
    var index = binarySearch(tmp, VOID, VOID, Curves$findInfo$lambda(pos));
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().kx_1) < 0)
      return first(this.m3a());
    if (Ratio__compareTo_impl_z2ienc(t, Companion_getInstance_6().nx_1) > 0)
      return last(this.m3a());
    var tmp0_elvis_lhs = getOrNull(this.m3a(), index);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.w4(toString('OUTSIDE'));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  b39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.p3a(t);
    var posInCurve = pos - info.i3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.calc.<anonymous>' call
    return info.h3a_1.b39(toRatio(ratioInCurve));
  }
  d39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.p3a(t);
    var posInCurve = pos - info.i3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.normal.<anonymous>' call
    return info.h3a_1.d39(ratioInCurve);
  }
  c39(t) {
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t, this.a());
    var info = this.p3a(t);
    var posInCurve = pos - info.i3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.tangent.<anonymous>' call
    return info.h3a_1.c39(ratioInCurve);
  }
  q3a(length) {
    if (length <= 0.0)
      return Companion_getInstance_6().kx_1;
    if (length >= this.a())
      return Companion_getInstance_6().nx_1;
    var tmp = this.m3a();
    var curveIndex = binarySearch(tmp, VOID, VOID, Curves$ratioFromLength$lambda(length));
    var index = curveIndex < 0 ? (-curveIndex | 0) + 1 | 0 : curveIndex;
    if (curveIndex < 0) {
      return Companion_getInstance_6().ox_1;
    }
    var info = this.m3a().d1(index);
    var lengthInCurve = length - info.i3a_1;
    var ratioInCurve = info.h3a_1.q3a(lengthInCurve);
    return convertRange(ratioInCurve, Companion_getInstance_6().kx_1, Companion_getInstance_6().nx_1, this.n3a(info), this.o3a(info));
  }
  r3a(len0, len1) {
    return this.s3a(this.q3a(len0), this.q3a(len1));
  }
  s3a(t0, t1) {
    if (Ratio__compareTo_impl_z2ienc(t0, t1) > 0)
      return this.s3a(t1, t0);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(Ratio__compareTo_impl_z2ienc(t0, t1) <= 0)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString(message));
    }
    if (equals(t0, t1))
      return new Curves(emptyList(), false);
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos = Ratio__times_impl_ucdh7y(t0, this.a());
    var info = this.p3a(t0);
    var posInCurve = pos - info.i3a_1;
    var ratioInCurve = _Ratio___init__impl__9mwvn2(posInCurve / info.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>' call
    // Inline function 'korlibs.math.geom.bezier.Curves.findTInCurve' call
    var pos_0 = Ratio__times_impl_ucdh7y(t1, this.a());
    var info_0 = this.p3a(t1);
    var posInCurve_0 = pos_0 - info_0.i3a_1;
    var ratioInCurve_0 = _Ratio___init__impl__9mwvn2(posInCurve_0 / info_0.a());
    // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>' call
    var tmp;
    if (info.g3a_1 === info_0.g3a_1) {
      tmp = listOf(info.h3a_1.s3a(ratioInCurve, ratioInCurve_0).t3a_1);
    } else {
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList.h1();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.bezier.Curves.split.<anonymous>.<anonymous>.<anonymous>' call
      if (!equals(ratioInCurve, Companion_getInstance_6().nx_1)) {
        this_0.h(info.h3a_1.x3a(ratioInCurve).t3a_1);
      }
      var inductionVariable = info.g3a_1 + 1 | 0;
      var last = info_0.g3a_1;
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.h(this.m3a().d1(index).h3a_1);
        }
         while (inductionVariable < last);
      if (!equals(ratioInCurve_0, Companion_getInstance_6().kx_1)) {
        this_0.h(info_0.h3a_1.y3a(ratioInCurve_0).t3a_1);
      }
      tmp = this_0.u7();
    }
    var tmp$ret$7 = tmp;
    return new Curves(tmp$ret$7, false);
  }
  toString() {
    return 'Curves(beziers=' + toString(this.o39_1) + ', closed=' + this.p39_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.o39_1);
    result = imul(result, 31) + getBooleanHashCode(this.p39_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Curves))
      return false;
    var tmp0_other_with_cast = other instanceof Curves ? other : THROW_CCE();
    if (!equals(this.o39_1, tmp0_other_with_cast.o39_1))
      return false;
    if (!(this.p39_1 === tmp0_other_with_cast.p39_1))
      return false;
    return true;
  }
}
class ProjectedPoint {
  constructor(p, t, dSq) {
    p = p === VOID ? Vector2D.y27() : p;
    t = t === VOID ? Companion_getInstance_6().kx_1 : t;
    dSq = dSq === VOID ? 0.0 : dSq;
    this.m3b_1 = p;
    this.n3b_1 = t;
    this.o3b_1 = dSq;
  }
  q3b(other, epsilon) {
    return this.m3b_1.a2h(other.m3b_1, epsilon) && isAlmostEquals(this.n3b_1, other.n3b_1, toRatio_0(epsilon)) && isAlmostEquals_0(this.o3b_1, other.o3b_1, epsilon);
  }
  ax(other, epsilon) {
    return this.q3b(other instanceof ProjectedPoint ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return 'ProjectedPoint(p=' + this.m3b_1.toString() + ', t=' + Ratio__toString_impl_mfgt3e(this.n3b_1) + ', dSq=' + this.o3b_1 + ')';
  }
  hashCode() {
    var result = this.m3b_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.n3b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o3b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProjectedPoint))
      return false;
    var tmp0_other_with_cast = other instanceof ProjectedPoint ? other : THROW_CCE();
    if (!this.m3b_1.equals(tmp0_other_with_cast.m3b_1))
      return false;
    if (!equals(this.n3b_1, tmp0_other_with_cast.n3b_1))
      return false;
    if (!equals(this.o3b_1, tmp0_other_with_cast.o3b_1))
      return false;
    return true;
  }
}
class Extrema {
  constructor(xt, yt) {
    this.z3a_1 = xt;
    this.a3b_1 = yt;
    var tmp = this;
    tmp.b3b_1 = lazy(Bezier$Extrema$allt$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.c3b_1 = lazy(Bezier$Extrema$xt01$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.d3b_1 = lazy(Bezier$Extrema$yt01$delegate$lambda(this));
  }
  r3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3b_1;
    xt01$factory();
    return this_0.r1();
  }
  s3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3b_1;
    yt01$factory();
    return this_0.r1();
  }
  k3b(index) {
    return index === 0 ? this.r3b() : this.s3b();
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Extrema) {
      tmp_0 = contentEquals(this.z3a_1, other.z3a_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.a3b_1, other.a3b_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.z3a_1) + imul(contentHashCode(this.a3b_1), 7) | 0;
  }
  toString() {
    return 'Extrema(x=' + contentToString(this.z3a_1) + ', y=' + contentToString(this.a3b_1) + ')';
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.e3b_1 = new Float64Array([-0.06405689286260563, 0.06405689286260563, -0.1911188674736163, 0.1911188674736163, -0.3150426796961634, 0.3150426796961634, -0.4337935076260451, 0.4337935076260451, -0.5454214713888396, 0.5454214713888396, -0.6480936519369755, 0.6480936519369755, -0.7401241915785544, 0.7401241915785544, -0.820001985973903, 0.820001985973903, -0.8864155270044011, 0.8864155270044011, -0.9382745520027328, 0.9382745520027328, -0.9747285559713095, 0.9747285559713095, -0.9951872199970213, 0.9951872199970213]);
    var tmp_0 = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp_0.f3b_1 = new Float64Array([0.12793819534675216, 0.12793819534675216, 0.1258374563468283, 0.1258374563468283, 0.12167047292780339, 0.12167047292780339, 0.1155056680537256, 0.1155056680537256, 0.10744427011596563, 0.10744427011596563, 0.09761865210411388, 0.09761865210411388, 0.08619016153195327, 0.08619016153195327, 0.0733464814110803, 0.0733464814110803, 0.05929858491543678, 0.05929858491543678, 0.04427743881741981, 0.04427743881741981, 0.028531388628933663, 0.028531388628933663, 0.0123412297999872, 0.0123412297999872]);
    this.g3b_1 = 6.283185307179586;
    this.h3b_1 = Line2D.z27(0, 0, 1, 0);
    this.i3b_1 = new Float64Array(0);
  }
  t3b(p0, p1, p2, p3, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.cubicCalc' call
    var x0 = p0.e25_1;
    var y0 = p0.f25_1;
    var x1 = p1.e25_1;
    var y1 = p1.f25_1;
    var x2 = p2.e25_1;
    var y2 = p2.f25_1;
    var cx = 3.0 * (x1 - x0);
    var bx = 3.0 * (x2 - x1) - cx;
    var ax = p3.e25_1 - x0 - cx - bx;
    var cy = 3.0 * (y1 - y0);
    var by = 3.0 * (y2 - y1) - cy;
    var ay = p3.f25_1 - y0 - cy - by;
    var tSquared = Ratio__times_impl_ucdh7y_0(t, t);
    var tCubed = Ratio__times_impl_ucdh7y_0(tSquared, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp = ax * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_0 = tmp + bx * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var x = tmp_0 + cx * _Ratio___get_value__impl__57cli6(t) + x0;
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_1 = ay * _Ratio___get_value__impl__57cli6(tCubed);
    // Inline function 'korlibs.math.interpolation.times' call
    var tmp_2 = tmp_1 + by * _Ratio___get_value__impl__57cli6(tSquared);
    // Inline function 'korlibs.math.interpolation.times' call
    var y = tmp_2 + cy * _Ratio___get_value__impl__57cli6(t) + y0;
    out = Vector2D.n27(x, y);
    return out;
  }
  u3b(p, c, a, t) {
    var out;
    // Inline function 'korlibs.math.geom.bezier.Companion.quadCalc' call
    var x0 = p.e25_1;
    var y0 = p.f25_1;
    var xc = c.e25_1;
    var yc = c.f25_1;
    var x1 = a.e25_1;
    var y1 = a.f25_1;
    var t1 = 1 - Ratio__toDouble_impl_o7epze(t);
    var a_0 = t1 * t1;
    var c_0 = Ratio__times_impl_ucdh7y_0(t, t);
    // Inline function 'korlibs.math.interpolation.times' call
    var b = 2 * t1 * _Ratio___get_value__impl__57cli6(t);
    var x = a_0 * x0 + b * xc + Ratio__times_impl_ucdh7y(c_0, x1);
    var y = a_0 * y0 + b * yc + Ratio__times_impl_ucdh7y(c_0, y1);
    out = Vector2D.n27(x, y);
    return out;
  }
  v3b(a, b) {
    return a + (b - a) * (2.0 / 3.0);
  }
  w3b(a, b) {
    return b + (a - b) * (2.0 / 3.0);
  }
}
class Bezier {
  static c3c(points, dummy) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.u39_1 = points;
    if ($this.u39_1.e1() > 4) {
      // Inline function 'kotlin.error' call
      var message = 'Only supports quad and cubic beziers';
      throw IllegalStateException.w4(toString(message));
    }
    var tmp = $this;
    tmp.v39_1 = lazy(Bezier$aligned$delegate$lambda($this));
    var tmp_0 = $this;
    tmp_0.w39_1 = lazy(Bezier$dpoints$delegate$lambda($this));
    var tmp_1 = $this;
    tmp_1.x39_1 = lazy(Bezier$direction$delegate$lambda($this));
    var tmp_2 = $this;
    tmp_2.y39_1 = lazy(Bezier$extrema$delegate$lambda($this));
    var tmp_3 = $this;
    tmp_3.z39_1 = lazy(Bezier$outerCircle$delegate$lambda($this));
    var tmp_4 = $this;
    tmp_4.a3a_1 = lazy(Bezier$boundingBox$delegate$lambda($this));
    var tmp_5 = $this;
    tmp_5.b3a_1 = lazy(Bezier$length$delegate$lambda($this));
    var tmp_6 = $this;
    tmp_6.c3a_1 = lazy(Bezier$lut$delegate$lambda($this));
    var tmp_7 = $this;
    tmp_7.d3a_1 = lazy(Bezier$isLinear$delegate$lambda($this));
    var tmp_8 = $this;
    tmp_8.e3a_1 = lazy(Bezier$isSimple$delegate$lambda($this));
    return $this;
  }
  static d3c() {
    Companion_getInstance_8();
    return this.e3c(Vector2D.g2a(0.0, 0.0), Vector2D.g2a(0.0, 0.0));
  }
  static e3c(p0, p1) {
    Companion_getInstance_8();
    return this.c3c(pointArrayListOf(p0, p1), Unit_instance);
  }
  static f3c(p0, p1, p2) {
    Companion_getInstance_8();
    return this.c3c(pointArrayListOf_0(p0, p1, p2), Unit_instance);
  }
  static g3c(p0, p1, p2, p3) {
    Companion_getInstance_8();
    return this.c3c(pointArrayListOf_1(p0, p1, p2, p3), Unit_instance);
  }
  static h3c(points) {
    Companion_getInstance_8();
    return this.c3c(points.g2r(), Unit_instance);
  }
  i3c(other, epsilon) {
    if (!(this.u39_1.e1() === other.u39_1.e1()))
      return false;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = until(0, this.u39_1.e1());
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var inductionVariable = this_0.a2_1;
      var last = this_0.b2_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.math.geom.bezier.Bezier.isAlmostEquals.<anonymous>' call
          var it = element;
          if (!this.u39_1.d1(it).a2h(other.u39_1.d1(it), epsilon)) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  ax(other, epsilon) {
    return this.i3c(other instanceof Bezier ? other : THROW_CCE(), epsilon);
  }
  l3b(t) {
    return this.j3c(t);
  }
  l3a() {
    return this.z3b();
  }
  k3c(m) {
    return _getBoundingBox(this, m);
  }
  b39(t) {
    return this.j3c(t);
  }
  equals(other) {
    var tmp;
    if (other instanceof Bezier) {
      tmp = equals(this.u39_1, other.u39_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.u39_1);
  }
  toString() {
    return 'Bezier(' + toString(this.u39_1) + ')';
  }
  x3b() {
    return 2;
  }
  f3a() {
    return this.u39_1.e1() - 1 | 0;
  }
  y3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w39_1;
    dpoints$factory();
    return this_0.r1();
  }
  j3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y39_1;
    extrema$factory();
    return this_0.r1();
  }
  l3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z39_1;
    outerCircle$factory();
    return this_0.r1();
  }
  z3b() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a3a_1;
    boundingBox$factory();
    return this_0.r1();
  }
  a() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b3a_1;
    length$factory_0();
    return this_0.r1();
  }
  m3c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3a_1;
    lut$factory();
    return this_0.r1();
  }
  q3a(length) {
    return this.m3c().u3c(length).o3c_1;
  }
  v3c(steps, out) {
    out.h3();
    // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
    Companion_getInstance_6();
    var NS = (steps + 1 | 0) - 1 | 0;
    var NSd = NS;
    var start = true ? 0 : 1;
    var end = true ? NS : NS - 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ratio = n / NSd;
        // Inline function 'korlibs.math.geom.bezier.Bezier.getLUT.<anonymous>' call
        var t = toRatio_0(ratio);
        out.w3c(t, this.j3c(t));
      }
       while (!(n === end));
    return out;
  }
  b3c(steps, out, $super) {
    steps = steps === VOID ? 100 : steps;
    out = out === VOID ? CurveLUT.x3c(this, steps + 1 | 0) : out;
    return $super === VOID ? this.v3c(steps, out) : $super.v3c.call(this, steps, out);
  }
  y3c(point, out) {
    out.p3b_1 = this;
    if (this.u39_1.e1() === 2) {
      var p0 = this.u39_1.d1(0);
      var p1 = this.u39_1.d1(1);
      return findNearestLine(this, point.e25_1, point.f25_1, p0.e25_1, p0.f25_1, p1.e25_1, p1.f25_1, out);
    }
    var LUT = this.m3c();
    var l = LUT.z3c();
    var closest = LUT.a3d(point);
    var mpos = closest.c3d_1;
    var t1 = (mpos - 1 | 0) / l;
    var t2 = (mpos + 1 | 0) / l;
    var step = 0.1 / l;
    var mdistSq = closest.b3d_1;
    var t = t1;
    var ft = t;
    mdistSq = mdistSq + 1;
    while (t < t2 + step) {
      var p = this.j3c(toRatio_0(t));
      var d = Companion_getInstance().w26(point, p);
      if (d < mdistSq) {
        mdistSq = d;
        ft = t;
        out.m3b_1 = p;
      }
      t = t + step;
    }
    out.m3b_1 = this.j3c(toRatio_0(ft));
    out.n3b_1 = ft < 0 ? Companion_getInstance_6().kx_1 : ft > 1 ? Companion_getInstance_6().nx_1 : toRatio_0(ft);
    out.o3b_1 = mdistSq;
    return out;
  }
  d3d() {
    if (this.u39_1.e1() < 4)
      return Companion_getInstance_8().i3b_1;
    var p = _get_aligned__7fjidv(this);
    var p1 = p.d1(1);
    var p2 = p.d1(2);
    var p3 = p.d1(3);
    var a = p2.e25_1 * p1.f25_1;
    var b = p3.e25_1 * p1.f25_1;
    var c = p1.e25_1 * p2.f25_1;
    var d = p3.e25_1 * p2.f25_1;
    var v1 = 18.0 * (-3.0 * a + 2.0 * b + 3.0 * c - d);
    var v2 = 18.0 * (3.0 * a - b - 3.0 * c);
    var v3 = 18.0 * (c - a);
    if (isAlmostZero(v1)) {
      if (!isAlmostZero(v2)) {
        var t = -v3 / v2;
        if (0.0 <= t ? t <= 1.0 : false) {
          // Inline function 'kotlin.doubleArrayOf' call
          return new Float64Array([t]);
        }
      }
      return Companion_getInstance_8().i3b_1;
    }
    var d2 = 2.0 * v1;
    if (isAlmostEquals_0(d2, 0.0))
      return Companion_getInstance_8().i3b_1;
    var trm = v2 * v2 - 4.0 * v1 * v3;
    if (trm < 0)
      return Companion_getInstance_8().i3b_1;
    // Inline function 'kotlin.math.sqrt' call
    var sq = Math.sqrt(trm);
    var out0 = (sq - v2) / d2;
    var out1 = -(v2 + sq) / d2;
    var out = DoubleArrayList.j2k(2);
    if (0.0 <= out0 ? out0 <= 1.0 : false) {
      out.nz(out0);
    }
    if (0.0 <= out1 ? out1 <= 1.0 : false) {
      out.nz(out1);
    }
    return out.rx();
  }
  j3c(t) {
    return compute(Companion_getInstance_8(), t, this.u39_1);
  }
  e3d(t, normalize) {
    var out = compute(Companion_getInstance_8(), t, this.y3b().d1(0));
    if ((equals(t, Companion_getInstance_6().kx_1) || equals(t, Companion_getInstance_6().nx_1)) && isAlmostZero(out.w2g())) {
      var inductionVariable = 0;
      if (inductionVariable < 10)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.math.pow' call
          var n_0 = -(10 - n | 0) | 0;
          var newT = Math.pow(10.0, n_0);
          var nt = equals(t, Companion_getInstance_6().nx_1) ? 1.0 - newT : newT;
          out = compute(Companion_getInstance_8(), _Ratio___init__impl__9mwvn2(nt), this.y3b().d1(0));
          if (!isAlmostZero(out.w2g()))
            break $l$loop;
        }
         while (inductionVariable < 10);
    }
    if (normalize)
      out = out.y2g();
    return out;
  }
  a3c(t, normalize, $super) {
    normalize = normalize === VOID ? false : normalize;
    return $super === VOID ? this.e3d(t, normalize) : $super.e3d.call(this, new Ratio(t), normalize);
  }
  f3d(t, normalize) {
    return this.e3d(t, normalize).z2g();
  }
  d39(t) {
    return this.f3d(t, true);
  }
  c39(t) {
    return this.e3d(t, true);
  }
  g3d(t, out) {
    if (this.f3a() < 2)
      return null;
    var p = this.u39_1;
    out.l2r(p, 0);
    out.l2r(p, 1);
    out.l2r(p, 2);
    if (this.f3a() === 3) {
      out.l2r(p, 3);
    }
    while (p.e1() > 1) {
      var next = new PointArrayList();
      var inductionVariable = 0;
      var last = p.e1() - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var p_0 = interpolate(toRatio(t), p.d1(i), p.d1(i + 1 | 0));
          out.i2r(p_0);
          next.i2r(p_0);
        }
         while (inductionVariable < last);
      p = next;
    }
    return out;
  }
  h3d(t, out, $super) {
    out = out === VOID ? new PointArrayList() : out;
    return $super === VOID ? this.g3d(t, out) : $super.g3d.call(this, new Ratio(t), out);
  }
  s3a(t0, t1) {
    return SubBezier.i3d(this.x3a(t0).y3a(map(Companion_getInstance_8(), t1, t0, Companion_getInstance_6().nx_1, Companion_getInstance_6().kx_1, Companion_getInstance_6().nx_1)).t3a_1, t0, t1, this);
  }
  y3a(t) {
    return SubBezier.j3d(this).y3a(t);
  }
  x3a(t) {
    return SubBezier.j3d(this).x3a(t);
  }
  k3d() {
    return Line2D.w27(this.u39_1.d1(0), this.u39_1.d1(this.f3a()));
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_0 = new Int32Array([0, 3, 5]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$1 = new Int32Array([0, 4, 7, 9]);
    tmp.l3d_1 = listOf_0([null, null, tmp_0, tmp$ret$1]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp_2 = new Int32Array([5, 4, 2]);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$3 = new Int32Array([9, 8, 6, 3]);
    tmp_1.m3d_1 = listOf_0([null, null, tmp_2, tmp$ret$3]);
  }
}
class SubBezier {
  static i3d(curve, t1, t2, parent) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.t3a_1 = curve;
    $this.u3a_1 = t1;
    $this.v3a_1 = t2;
    $this.w3a_1 = parent;
    return $this;
  }
  static j3d(curve) {
    Companion_getInstance_9();
    return this.i3d(curve, Companion_getInstance_6().kx_1, Companion_getInstance_6().nx_1, null);
  }
  b39(t) {
    return this.t3a_1.b39(convertRange(t, this.u3a_1, this.v3a_1, Companion_getInstance_6().kx_1, Companion_getInstance_6().nx_1));
  }
  y3a(t) {
    return _splitLeft$default(this, t);
  }
  x3a(t) {
    return _splitRight$default(this, t);
  }
  toString() {
    return 'SubBezier[' + get_niceStr(Ratio__toDouble_impl_o7epze(this.u3a_1)) + '..' + get_niceStr(Ratio__toDouble_impl_o7epze(this.v3a_1)) + '](' + this.t3a_1.toString() + ')';
  }
}
class ClosestResult {
  constructor(mdistSq, mpos) {
    this.b3d_1 = mdistSq;
    this.c3d_1 = mpos;
  }
}
class Estimation {
  constructor(point, ratio, length) {
    point = point === VOID ? Vector2D.y27() : point;
    ratio = ratio === VOID ? Companion_getInstance_6().kx_1 : ratio;
    length = length === VOID ? 0.0 : length;
    this.n3c_1 = point;
    this.o3c_1 = ratio;
    this.p3c_1 = length;
  }
  toString() {
    return 'Estimation(point=' + this.n3c_1.b2h() + ', ratio=' + get_niceStr_0(this.o3c_1) + ', length=' + get_niceStr(this.p3c_1) + ')';
  }
  hashCode() {
    var result = this.n3c_1.hashCode();
    result = imul(result, 31) + Ratio__hashCode_impl_quhc2v(this.o3c_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p3c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Estimation))
      return false;
    var tmp0_other_with_cast = other instanceof Estimation ? other : THROW_CCE();
    if (!this.n3c_1.equals(tmp0_other_with_cast.n3c_1))
      return false;
    if (!equals(this.o3c_1, tmp0_other_with_cast.o3c_1))
      return false;
    if (!equals(this.p3c_1, tmp0_other_with_cast.p3c_1))
      return false;
    return true;
  }
}
class CurveLUT {
  static p3d(curve, points, ts, _estimatedLengths) {
    var $this = createThis(this);
    $this.q3c_1 = curve;
    $this.r3c_1 = points;
    $this.s3c_1 = ts;
    $this.t3c_1 = _estimatedLengths;
    return $this;
  }
  static x3c(curve, capacity) {
    return this.p3d(curve, new PointArrayList(capacity), DoubleArrayList.j2k(capacity), DoubleArrayList.j2k(capacity));
  }
  o3d() {
    if (this.t3c_1.g1()) {
      this.t3c_1.nz(0.0);
    }
    while (this.t3c_1.e1() < this.e1()) {
      var pos = this.t3c_1.e1();
      var prev = last_0(this.t3c_1);
      this.t3c_1.nz(prev + Companion_getInstance().q2g(this.r3c_1.d1(pos - 1 | 0), this.r3c_1.d1(pos)));
    }
    return this.t3c_1;
  }
  z3c() {
    return this.r3c_1.e1() - 1 | 0;
  }
  e1() {
    return this.r3c_1.e1();
  }
  h3() {
    this.r3c_1.zg();
    this.s3c_1.h3();
    this.t3c_1.h3();
  }
  w3c(t, p) {
    this.r3c_1.i2r(p);
    this.s3c_1.nz(Ratio__toDouble_impl_o7epze(t));
  }
  a3d(point) {
    var mdistSq = Infinity;
    var mpos = 0;
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = Companion_getInstance().w26(this.r3c_1.d1(n), point);
        if (d < mdistSq) {
          mdistSq = d;
          mpos = n;
        }
      }
       while (inductionVariable < last);
    return new ClosestResult(mdistSq, mpos);
  }
  n3d(_this__u8e3s4, index, ratio) {
    var ratio0 = toRatio_0(this.s3c_1.d1(index));
    var length0 = this.o3d().d1(index);
    var point0 = this.r3c_1.d1(index);
    if (ratio === 0.0) {
      _this__u8e3s4.o3c_1 = ratio0;
      _this__u8e3s4.p3c_1 = length0;
      _this__u8e3s4.n3c_1 = point0;
    } else {
      var ratio1 = toRatio_0(this.s3c_1.d1(index + 1 | 0));
      var length1 = this.o3d().d1(index + 1 | 0);
      var point1 = this.r3c_1.d1(index + 1 | 0);
      _this__u8e3s4.o3c_1 = interpolate_0(toRatio_0(ratio), ratio0, ratio1);
      _this__u8e3s4.p3c_1 = interpolate_1(toRatio_0(ratio), length0, length1);
      _this__u8e3s4.n3c_1 = interpolate(toRatio_0(ratio), point0, point1);
    }
    return _this__u8e3s4;
  }
  q3d(length, out) {
    return estimateAt(this, this.o3d(), length, out);
  }
  u3c(length, out, $super) {
    out = out === VOID ? new Estimation() : out;
    return $super === VOID ? this.q3d(length, out) : $super.q3d.call(this, length, out);
  }
  toString() {
    var tmp = toString(this.q3c_1);
    var tmp_0 = until(0, this.e1());
    return 'CurveLUT[' + tmp + '](' + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, CurveLUT$toString$lambda(this)) + ')';
  }
  hashCode() {
    var result = hashCode(this.q3c_1);
    result = imul(result, 31) + this.r3c_1.hashCode() | 0;
    result = imul(result, 31) + this.s3c_1.hashCode() | 0;
    result = imul(result, 31) + this.t3c_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveLUT))
      return false;
    var tmp0_other_with_cast = other instanceof CurveLUT ? other : THROW_CCE();
    if (!equals(this.q3c_1, tmp0_other_with_cast.q3c_1))
      return false;
    if (!this.r3c_1.equals(tmp0_other_with_cast.r3c_1))
      return false;
    if (!this.s3c_1.equals(tmp0_other_with_cast.s3c_1))
      return false;
    if (!this.t3c_1.equals(tmp0_other_with_cast.t3c_1))
      return false;
    return true;
  }
}
class Arc {
  constructor() {
    this.r3d_1 = 0.5522847498307933;
    this.s3d_1 = 6.283185307179586;
  }
  t3d(out, center, r, start, end, counterclockwise) {
    var x = center.fl();
    var y = center.gl();
    var startAngle = _Angle___get_normalized__impl__9s30ys(start);
    var endAngle1 = _Angle___get_normalized__impl__9s30ys(end);
    var endAngle = Angle__compareTo_impl_a0hfds(endAngle1, startAngle) < 0 ? Angle__plus_impl_26v37k(endAngle1, Companion_getInstance_0().z24_1) : endAngle1;
    // Inline function 'korlibs.math.geom.min' call
    var a = Companion_getInstance_0().z24_1;
    // Inline function 'korlibs.math.geom.abs' call
    var angle = Angle__minus_impl_xeau7k(endAngle, startAngle);
    var b = _Angle___get_absoluteValue__impl__4qoakv(angle);
    // Inline function 'kotlin.math.min' call
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var a_0 = _Angle___get_radians__impl__n00yt5(a);
    // Inline function 'korlibs.math.geom.Angle.internal' call
    var b_0 = _Angle___get_radians__impl__n00yt5(b);
    var tmp$ret$3 = Math.min(a_0, b_0);
    var remainingAngle = _Angle___init__impl__g23q1m(tmp$ret$3);
    if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().u24_1) < 0 && !equals(start, end))
      remainingAngle = Companion_getInstance_0().z24_1;
    var sgn1 = Angle__compareTo_impl_a0hfds(startAngle, endAngle) < 0 ? 1 : -1;
    var sgn = counterclockwise ? -sgn1 | 0 : sgn1;
    if (counterclockwise) {
      remainingAngle = Angle__minus_impl_xeau7k(Companion_getInstance_0().z24_1, remainingAngle);
      if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(remainingAngle), Companion_getInstance_0().u24_1) < 0 && !equals(start, end))
        remainingAngle = Companion_getInstance_0().z24_1;
    }
    var a1 = startAngle;
    var index = 0;
    while (Angle__compareTo_impl_a0hfds(remainingAngle, Companion_getInstance_0().u24_1) > 0) {
      var tmp = a1;
      // Inline function 'korlibs.math.geom.min' call
      var a_1 = remainingAngle;
      var b_1 = Companion_getInstance_0().w24_1;
      // Inline function 'kotlin.math.min' call
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var a_2 = _Angle___get_radians__impl__n00yt5(a_1);
      // Inline function 'korlibs.math.geom.Angle.internal' call
      var b_2 = _Angle___get_radians__impl__n00yt5(b_1);
      var tmp$ret$7 = Math.min(a_2, b_2);
      var tmp$ret$8 = _Angle___init__impl__g23q1m(tmp$ret$7);
      var a2 = Angle__plus_impl_26v37k(tmp, Angle__times_impl_v3s9y2(tmp$ret$8, sgn));
      var a_3 = Angle__div_impl_ut2btd(Angle__minus_impl_xeau7k(a2, a1), 2.0);
      var x4 = r * _Angle___get_cosine__impl__vprvmu(a_3);
      var y4 = r * _Angle___get_sine__impl__15nmyi(a_3);
      var x1 = x4;
      var y1 = -y4;
      var f = 0.5522847498307933 * _Angle___get_tangent__impl__vushdy(a_3);
      var x2 = x1 + f * y4;
      var y2 = y1 + f * x4;
      var x3 = x2;
      var y3 = -y2;
      var ar = Angle__plus_impl_26v37k(a_3, a1);
      var cos_ar = _Angle___get_cosine__impl__vprvmu(ar);
      var sin_ar = _Angle___get_sine__impl__15nmyi(ar);
      if (index === 0) {
        out.u3d(Vector2D.n27(x + r * _Angle___get_cosine__impl__vprvmu(a1), y + r * _Angle___get_sine__impl__15nmyi(a1)));
      }
      out.v3d(Vector2D.n27(x + x2 * cos_ar - y2 * sin_ar, y + x2 * sin_ar + y2 * cos_ar), Vector2D.n27(x + x3 * cos_ar - y3 * sin_ar, y + x3 * sin_ar + y3 * cos_ar), Vector2D.n27(x + r * _Angle___get_cosine__impl__vprvmu(a2), y + r * _Angle___get_sine__impl__15nmyi(a2)));
      index = index + 1 | 0;
      var tmp_0 = remainingAngle;
      // Inline function 'korlibs.math.geom.abs' call
      var angle_0 = Angle__minus_impl_xeau7k(a2, a1);
      var tmp$ret$9 = _Angle___get_absoluteValue__impl__4qoakv(angle_0);
      remainingAngle = Angle__minus_impl_xeau7k(tmp_0, tmp$ret$9);
      a1 = a2;
    }
    if (equals(startAngle, endAngle) && !(index === 0)) {
      out.c6();
    }
  }
}
class Companion_1 {
  k3e(width, height, algo) {
    return new BinPacker(Size2D.b2e(width, height), algo);
  }
  l3e(width, height, algo) {
    return Companion_instance_1.k3e(width, height, algo);
  }
  m3e(width, height, algo, $super) {
    algo = algo === VOID ? MaxRects.o3e(width, height) : algo;
    return $super === VOID ? this.l3e(width, height, algo) : $super.l3e.call(this, width, height, algo);
  }
}
class ImageDoNotFitException extends Error {
  static t3e(width, height, packer) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this, "Size '" + width + 'x' + height + "' doesn't fit in '" + packer.m2i() + 'x' + packer.n2i() + "'");
    captureStack($this, $this.s3e_1);
    $this.p3e_1 = width;
    $this.q3e_1 = height;
    $this.r3e_1 = packer;
    return $this;
  }
}
class BinPacker {
  constructor(size, algo) {
    algo = algo === VOID ? MaxRects.x3e(size) : algo;
    this.u3e_1 = size;
    this.v3e_1 = algo;
    this.w3e_1 = FastArrayList.ny();
  }
  m2i() {
    return this.u3e_1.j26_1;
  }
  n2i() {
    return this.u3e_1.k26_1;
  }
  h2r(width, height) {
    var tmp0_elvis_lhs = this.y3e(width, height);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw ImageDoNotFitException.t3e(width, height, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  y3e(width, height) {
    var tmp0_elvis_lhs = this.v3e_1.z3e(Size2D.b2e(width, height));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rect = tmp;
    // Inline function 'kotlin.collections.plusAssign' call
    this.w3e_1.h(rect);
    return rect;
  }
}
class MaxRects {
  static x3e(maxSize) {
    var $this = createThis(this);
    $this.n3e_1 = fastArrayListOf([Companion_getInstance_1().m26(Companion_getInstance().g25_1, maxSize)]);
    return $this;
  }
  static o3e(width, height) {
    return this.x3e(Size2D.b2e(width, height));
  }
  z3e(size) {
    return this.a3f(size);
  }
  a3f(size) {
    var width = size.fl();
    var height = size.gl();
    if (width <= 0.0 && height <= 0.0)
      return Companion_getInstance_1().u2d(0, 0, 0, 0);
    var newNode = quickFindPositionForNewNodeBestAreaFit(this, width, height);
    if (newNode.r25_1 === 0.0)
      return null;
    var numRectanglesToProcess = this.n3e_1.e1();
    var i = 0;
    while (i < numRectanglesToProcess) {
      if (splitFreeNode(this, this.n3e_1.d1(i), newNode)) {
        this.n3e_1.l3(i);
        numRectanglesToProcess = numRectanglesToProcess - 1 | 0;
        i = i - 1 | 0;
      }
      i = i + 1 | 0;
    }
    pruneFreeList(this);
    return newNode;
  }
}
class Companion_2 {}
class HitTestDirection extends Enum {}
class Convex {
  j3e(curves) {
    var tmp0_elvis_lhs = toNonCurveSimplePointList(curves);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var points = tmp;
    return this.b3f(points);
  }
  b3f(vertices) {
    var base = 0;
    var n = vertices.e1();
    var TWO_PI = 3.141592653589793 * 2;
    if (n <= 3)
      return true;
    if (vertices.k27(base) === vertices.k27(n - 1 | 0) && vertices.l27(base) === vertices.l27(n - 1 | 0)) {
      n = n - 1 | 0;
    }
    var old_x = vertices.k27(n - 2 | 0);
    var old_y = vertices.l27(n - 2 | 0);
    var new_x = vertices.k27(n - 1 | 0);
    var new_y = vertices.l27(n - 1 | 0);
    // Inline function 'kotlin.math.atan2' call
    var y = new_y - old_y;
    var x = new_x - old_x;
    var new_direction = Math.atan2(y, x);
    var old_direction;
    var angle_sum = Companion_getInstance_0().v24_1;
    var orientation = 0.0;
    var inductionVariable = 0;
    var last = n;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        old_x = new_x;
        old_y = new_y;
        old_direction = new_direction;
        var _unary__edvuaz = base;
        base = _unary__edvuaz + 1 | 0;
        var p = _unary__edvuaz;
        new_x = vertices.k27(p);
        new_y = vertices.l27(p);
        // Inline function 'kotlin.math.atan2' call
        var y_0 = new_y - old_y;
        var x_0 = new_x - old_x;
        new_direction = Math.atan2(y_0, x_0);
        if (old_x === new_x && old_y === new_y) {
          return false;
        }
        var angle = new_direction - old_direction;
        if (angle <= -3.141592653589793)
          angle = angle + TWO_PI;
        else if (angle > 3.141592653589793)
          angle = angle - TWO_PI;
        if (i === 0) {
          if (angle === 0.0) {
            return false;
          }
          orientation = angle > 0 ? 1.0 : -1.0;
        } else if (orientation * angle < 0.0) {
          return false;
        }
        var tmp = angle_sum;
        // Inline function 'korlibs.math.geom.Companion.fromRadians' call
        Companion_getInstance_0();
        var radians = angle;
        var tmp$ret$2 = _Angle___init__impl__g23q1m(radians);
        angle_sum = Angle__plus_impl_26v37k(tmp, tmp$ret$2);
      }
       while (inductionVariable < last);
    return isAlmostEquals(Companion_getInstance_6().nx_1, _Ratio___get_absoluteValue__impl__92ozif(_Angle___get_ratio__impl__ap3on4(angle_sum)));
  }
}
class AbstractShape2D {}
class Companion_3 {
  constructor() {
    Companion_instance_3 = this;
    this.c3f_1 = values();
  }
  d1(index) {
    return this.c3f_1[umod(index, 4)];
  }
}
class SliceRotation extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.f3f_1 = imul(this.n3_1, 90);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(8), null);
    while (tmp_0 < 8) {
      var tmp_2 = tmp_0;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var this_0 = new Int32Array([0, 1, 2, 3]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.INDICES.<anonymous>' call
      var orientation = _SliceOrientation___init__impl__ewylib(tmp_2);
      if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
        swap(this_0, 0, 1);
        swap(this_0, 3, 2);
      }
      rotateRight(this_0, _SliceOrientation___get_rotation__impl__m65r0o(orientation).n3_1);
      tmp_1[tmp_2] = this_0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.g3f_1 = tmp_1;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(8), null);
    while (tmp_4 < 8) {
      var tmp_6 = tmp_4;
      var orientation_0 = _SliceOrientation___init__impl__ewylib(tmp_6);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder.f();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.slice.Companion.NAMES.<anonymous>' call
      this_1.ob(_SliceOrientation___get_flipX__impl__lgb7bx(orientation_0) ? 'MIRROR_HORIZONTAL_ROTATE_' : 'ROTATE_');
      this_1.sg(_SliceOrientation___get_rotation__impl__m65r0o(orientation_0).f3f_1);
      tmp_5[tmp_6] = this_1.toString();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.h3f_1 = tmp_5;
    var tmp_7 = this;
    var tmp39_rotation = SliceRotation_R0_getInstance();
    tmp_7.i3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp39_rotation, false);
    var tmp_8 = this;
    var tmp40_rotation = SliceRotation_R90_getInstance();
    tmp_8.j3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp40_rotation, false);
    var tmp_9 = this;
    var tmp41_rotation = SliceRotation_R180_getInstance();
    tmp_9.k3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp41_rotation, false);
    var tmp_10 = this;
    var tmp42_rotation = SliceRotation_R270_getInstance();
    tmp_10.l3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp42_rotation, false);
    this.m3f_1 = _SliceOrientation___init__impl__ewylib_0(VOID, true);
    var tmp_11 = this;
    var tmp43_rotation = SliceRotation_R90_getInstance();
    tmp_11.n3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp43_rotation, true);
    var tmp_12 = this;
    var tmp44_rotation = SliceRotation_R180_getInstance();
    tmp_12.o3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp44_rotation, true);
    var tmp_13 = this;
    var tmp45_rotation = SliceRotation_R270_getInstance();
    tmp_13.p3f_1 = _SliceOrientation___init__impl__ewylib_0(tmp45_rotation, true);
    this.q3f_1 = listOf_0([new SliceOrientation(this.i3f_1), new SliceOrientation(this.j3f_1), new SliceOrientation(this.k3f_1), new SliceOrientation(this.l3f_1), new SliceOrientation(this.m3f_1), new SliceOrientation(this.n3f_1), new SliceOrientation(this.o3f_1), new SliceOrientation(this.p3f_1)]);
  }
}
class SliceOrientation {
  constructor(raw) {
    Companion_getInstance_13();
    this.r3f_1 = raw;
  }
  toString() {
    return SliceOrientation__toString_impl_tdph6r(this.r3f_1);
  }
  hashCode() {
    return SliceOrientation__hashCode_impl_7mjkdw(this.r3f_1);
  }
  equals(other) {
    return SliceOrientation__equals_impl_h4gywg(this.r3f_1, other);
  }
}
class SliceCoords {}
function x(index) {
  switch (index) {
    case 0:
      return this.m3h();
    case 1:
      return this.o3h();
    case 2:
      return this.q3h();
    case 3:
      return this.s3h();
    default:
      return NaN;
  }
}
function y(index) {
  switch (index) {
    case 0:
      return this.n3h();
    case 1:
      return this.p3h();
    case 2:
      return this.r3h();
    case 3:
      return this.t3h();
    default:
      return NaN;
  }
}
class SliceCoordsWithBase {}
function get_frameOffsetX() {
  return this.d3h().t28_1;
}
function get_frameOffsetY() {
  return this.d3h().q28_1;
}
function get_frameWidth() {
  return this.m2i() + this.d3h().n28() | 0;
}
function get_frameHeight() {
  return this.n2i() + this.d3h().o28() | 0;
}
class SliceCoordsWithBaseAndRect {}
function get_left() {
  return this.c3h().v25();
}
function get_top() {
  return this.c3h().x25();
}
function get_right() {
  return this.c3h().w25();
}
function get_bottom() {
  return this.c3h().y25();
}
function get_area() {
  return this.c3h().i2f();
}
class RectSlice {
  constructor(base, rect, orientation, padding, name) {
    orientation = orientation === VOID ? Companion_getInstance_13().i3f_1 : orientation;
    padding = padding === VOID ? Companion_getInstance_3().p28_1 : padding;
    name = name === VOID ? null : name;
    this.s3f_1 = base;
    this.t3f_1 = rect;
    this.u3f_1 = orientation;
    this.v3f_1 = padding;
    this.w3f_1 = name;
    this.x3f_1 = this.s3f_1.e1().i2g_1;
    this.y3f_1 = this.s3f_1.e1().j2g_1;
    this.z3f_1 = this.t3f_1.s2e_1;
    this.a3g_1 = this.t3f_1.t2e_1;
    this.b3g_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.u3f_1) ? this.t3f_1.s2e_1 : this.t3f_1.t2e_1;
    this.c3g_1 = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(this.u3f_1) ? this.t3f_1.t2e_1 : this.t3f_1.s2e_1;
    this.d3g_1 = this.b3g_1 + this.v3f_1.n28() | 0;
    this.e3g_1 = this.c3g_1 + this.v3f_1.o28() | 0;
    this.f3g_1 = this.t3f_1.v25() / this.x3f_1;
    this.g3g_1 = this.t3f_1.w25() / this.x3f_1;
    this.h3g_1 = this.t3f_1.x25() / this.y3f_1;
    this.i3g_1 = this.t3f_1.y25() / this.y3f_1;
    this.j3g_1 = new RectCoords(this.f3g_1, this.h3g_1, this.g3g_1, this.h3g_1, this.g3g_1, this.i3g_1, this.f3g_1, this.i3g_1);
    this.k3g_1 = transformed_1(this.j3g_1, this.u3f_1);
    this.l3g_1 = this.k3g_1.t3g_1;
    this.m3g_1 = this.k3g_1.u3g_1;
    this.n3g_1 = this.k3g_1.v3g_1;
    this.o3g_1 = this.k3g_1.w3g_1;
    this.p3g_1 = this.k3g_1.x3g_1;
    this.q3g_1 = this.k3g_1.y3g_1;
    this.r3g_1 = this.k3g_1.z3g_1;
    this.s3g_1 = this.k3g_1.a3h_1;
  }
  b3h() {
    return this.s3f_1;
  }
  c3h() {
    return this.t3f_1;
  }
  d3h() {
    return this.v3f_1;
  }
  m2i() {
    return this.b3g_1;
  }
  n2i() {
    return this.c3g_1;
  }
  e3h() {
    return this.d3g_1;
  }
  f3h() {
    return this.e3g_1;
  }
  g3h(left, top, right, bottom, name, clamped, orientation) {
    var tmp = this.t3f_1.j2f(left, top, right, bottom, clamped);
    return new RectSlice(this.s3f_1, tmp, orientation, this.v3f_1, name == null ? this.w3f_1 : name);
  }
  h3h(left, top, right, bottom, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.u3f_1 : orientation;
    return $super === VOID ? this.g3h(left, top, right, bottom, name, clamped, orientation) : $super.g3h.call(this, left, top, right, bottom, name, clamped, new SliceOrientation(orientation));
  }
  i3h(x, y, width, height, name, clamped, orientation) {
    return this.g3h(x, y, x + width | 0, y + height | 0, name, clamped, orientation);
  }
  j3h(x, y, width, height, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.u3f_1 : orientation;
    return $super === VOID ? this.i3h(x, y, width, height, name, clamped, orientation) : $super.i3h.call(this, x, y, width, height, name, clamped, new SliceOrientation(orientation));
  }
  k3h(rect, name, clamped, orientation) {
    return this.g3h(rect.v25(), rect.x25(), rect.w25(), rect.y25(), name, clamped, orientation);
  }
  l3h(rect, name, clamped, orientation, $super) {
    name = name === VOID ? null : name;
    clamped = clamped === VOID ? true : clamped;
    orientation = orientation === VOID ? this.u3f_1 : orientation;
    return $super === VOID ? this.k3h(rect, name, clamped, orientation) : $super.k3h.call(this, rect, name, clamped, new SliceOrientation(orientation));
  }
  m3h() {
    return this.l3g_1;
  }
  n3h() {
    return this.m3g_1;
  }
  o3h() {
    return this.n3g_1;
  }
  p3h() {
    return this.o3g_1;
  }
  q3h() {
    return this.p3g_1;
  }
  r3h() {
    return this.q3g_1;
  }
  s3h() {
    return this.r3g_1;
  }
  t3h() {
    return this.s3g_1;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.slice.RectSlice.toString.<anonymous>' call
    this_0.ob('RectSlice(');
    this_0.ob(this.w3f_1);
    this_0.ob(':');
    this_0.nb(this.t3f_1);
    if (!(this.u3f_1 === Companion_getInstance_13().i3f_1)) {
      this_0.ob(':');
      this_0.nb(new SliceOrientation(this.u3f_1));
    }
    if (this.v3f_1.w28()) {
      this_0.ob(':');
      this_0.nb(this.v3f_1);
    }
    this_0.ob(')');
    return this_0.toString();
  }
  hashCode() {
    var result = hashCode(this.s3f_1);
    result = imul(result, 31) + this.t3f_1.hashCode() | 0;
    result = imul(result, 31) + SliceOrientation__hashCode_impl_7mjkdw(this.u3f_1) | 0;
    result = imul(result, 31) + this.v3f_1.hashCode() | 0;
    result = imul(result, 31) + (this.w3f_1 == null ? 0 : getStringHashCode(this.w3f_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectSlice))
      return false;
    var tmp0_other_with_cast = other instanceof RectSlice ? other : THROW_CCE();
    if (!equals(this.s3f_1, tmp0_other_with_cast.s3f_1))
      return false;
    if (!this.t3f_1.equals(tmp0_other_with_cast.t3f_1))
      return false;
    if (!(this.u3f_1 === tmp0_other_with_cast.u3f_1))
      return false;
    if (!this.v3f_1.equals(tmp0_other_with_cast.v3f_1))
      return false;
    if (!(this.w3f_1 == tmp0_other_with_cast.w3f_1))
      return false;
    return true;
  }
}
class Companion_5 {
  y3h(base, coords, name, flippedWidthHeight) {
    return new SliceCoordsImpl(base, coords, name, flippedWidthHeight);
  }
  z3h(base, coords, name, flippedWidthHeight, $super) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    return $super === VOID ? this.y3h(base, coords, name, flippedWidthHeight) : $super.y3h.call(this, base, coords, name, flippedWidthHeight);
  }
}
class SliceCoordsImpl {
  constructor(base, coords, name, flippedWidthHeight) {
    name = name === VOID ? null : name;
    flippedWidthHeight = flippedWidthHeight === VOID ? false : flippedWidthHeight;
    this.a3i_1 = base;
    this.b3i_1 = coords;
    this.c3i_1 = name;
    this.d3i_1 = flippedWidthHeight;
    this.e3i_1 = Companion_getInstance_3().p28_1;
    this.f3i_1 = !this.d3i_1 ? this.a3i_1.e1().i2g_1 : this.a3i_1.e1().j2g_1;
    this.g3i_1 = !this.d3i_1 ? this.a3i_1.e1().j2g_1 : this.a3i_1.e1().i2g_1;
    this.h3i_1 = numberToInt(Companion_getInstance().o2g(this.b3i_1.m3h(), this.b3i_1.n3h(), this.b3i_1.o3h(), this.b3i_1.p3h()) * this.f3i_1);
    this.i3i_1 = numberToInt(Companion_getInstance().o2g(this.b3i_1.m3h(), this.b3i_1.n3h(), this.b3i_1.s3h(), this.b3i_1.t3h()) * this.g3i_1);
    this.j3i_1 = this.h3i_1 + this.e3i_1.n28() | 0;
    this.k3i_1 = this.i3i_1 + this.e3i_1.o28() | 0;
  }
  b3h() {
    return this.a3i_1;
  }
  d3h() {
    return this.e3i_1;
  }
  m2i() {
    return this.h3i_1;
  }
  n2i() {
    return this.i3i_1;
  }
  e3h() {
    return this.j3i_1;
  }
  f3h() {
    return this.k3i_1;
  }
  m3h() {
    return this.b3i_1.m3h();
  }
  n3h() {
    return this.b3i_1.n3h();
  }
  o3h() {
    return this.b3i_1.o3h();
  }
  p3h() {
    return this.b3i_1.p3h();
  }
  q3h() {
    return this.b3i_1.q3h();
  }
  r3h() {
    return this.b3i_1.r3h();
  }
  s3h() {
    return this.b3i_1.s3h();
  }
  t3h() {
    return this.b3i_1.t3h();
  }
  toString() {
    return 'SliceCoordsImpl(base=' + toString(this.a3i_1) + ', coords=' + toString(this.b3i_1) + ', name=' + this.c3i_1 + ', flippedWidthHeight=' + this.d3i_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.a3i_1);
    result = imul(result, 31) + hashCode(this.b3i_1) | 0;
    result = imul(result, 31) + (this.c3i_1 == null ? 0 : getStringHashCode(this.c3i_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d3i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SliceCoordsImpl))
      return false;
    var tmp0_other_with_cast = other instanceof SliceCoordsImpl ? other : THROW_CCE();
    if (!equals(this.a3i_1, tmp0_other_with_cast.a3i_1))
      return false;
    if (!equals(this.b3i_1, tmp0_other_with_cast.b3i_1))
      return false;
    if (!(this.c3i_1 == tmp0_other_with_cast.c3i_1))
      return false;
    if (!(this.d3i_1 === tmp0_other_with_cast.d3i_1))
      return false;
    return true;
  }
}
class RectCoords {
  constructor(tlX, tlY, trX, trY, brX, brY, blX, blY) {
    this.t3g_1 = tlX;
    this.u3g_1 = tlY;
    this.v3g_1 = trX;
    this.w3g_1 = trY;
    this.x3g_1 = brX;
    this.y3g_1 = brY;
    this.z3g_1 = blX;
    this.a3h_1 = blY;
  }
  m3h() {
    return this.t3g_1;
  }
  n3h() {
    return this.u3g_1;
  }
  o3h() {
    return this.v3g_1;
  }
  p3h() {
    return this.w3g_1;
  }
  q3h() {
    return this.x3g_1;
  }
  r3h() {
    return this.y3g_1;
  }
  s3h() {
    return this.z3g_1;
  }
  t3h() {
    return this.a3h_1;
  }
  toString() {
    return 'RectCoords(tlX=' + this.t3g_1 + ', tlY=' + this.u3g_1 + ', trX=' + this.v3g_1 + ', trY=' + this.w3g_1 + ', brX=' + this.x3g_1 + ', brY=' + this.y3g_1 + ', blX=' + this.z3g_1 + ', blY=' + this.a3h_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.t3g_1);
    result = imul(result, 31) + getNumberHashCode(this.u3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z3g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a3h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCoords))
      return false;
    var tmp0_other_with_cast = other instanceof RectCoords ? other : THROW_CCE();
    if (!equals(this.t3g_1, tmp0_other_with_cast.t3g_1))
      return false;
    if (!equals(this.u3g_1, tmp0_other_with_cast.u3g_1))
      return false;
    if (!equals(this.v3g_1, tmp0_other_with_cast.v3g_1))
      return false;
    if (!equals(this.w3g_1, tmp0_other_with_cast.w3g_1))
      return false;
    if (!equals(this.x3g_1, tmp0_other_with_cast.x3g_1))
      return false;
    if (!equals(this.y3g_1, tmp0_other_with_cast.y3g_1))
      return false;
    if (!equals(this.z3g_1, tmp0_other_with_cast.z3g_1))
      return false;
    if (!equals(this.a3h_1, tmp0_other_with_cast.a3h_1))
      return false;
    return true;
  }
}
class Companion_6 {}
class Item {
  constructor(index) {
    this.l3i_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6(this.l3i_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p(this.l3i_1);
  }
  equals(other) {
    return Item__equals_impl_qczid(this.l3i_1, other);
  }
}
class FTrapezoidsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.m3i_1 = false;
    this.n3i_1 = IntArrayList.n2j(imul(capacity, 7));
  }
  e1() {
    return this.n3i_1.e1() / 6 | 0;
  }
  o3i(index) {
    return _Item___init__impl__hhk1le(index);
  }
  toString() {
    return 'FTrapezoidsInt[' + this.e1() + ']';
  }
  p3i(x, y, assumeSorted) {
    // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside' call
    var iterations = 0;
    var iterations2 = 0;
    var found = false;
    if (assumeSorted) {
      var size = this.e1();
      // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
      var toIndex = size - 1 | 0;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.genericBinarySearch' call
        var low = 0;
        var high = toIndex - 1 | 0;
        while (low <= high) {
          var mid = (low + high | 0) / 2 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside.<anonymous>' call
          iterations2 = iterations2 + 1 | 0;
          var mval = compareTo(this.r3i(_Item___init__impl__hhk1le(mid)), y);
          if (mval < 0)
            low = mid + 1 | 0;
          else if (mval > 0)
            high = mid - 1 | 0;
          else {
            tmp$ret$1 = mid;
            break $l$block;
          }
        }
        // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
        tmp$ret$1 = (-low | 0) - 1 | 0;
      }
      var result = _BSearchResult___init__impl__em6zam(tmp$ret$1);
      var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
      $l$loop: while (0 <= index ? index < size : false) {
        var item = _Item___init__impl__hhk1le(index);
        if (y > this.s3i(item))
          break $l$loop;
        iterations = iterations + 1 | 0;
        index = index - 1 | 0;
      }
      index = index + 1 | 0;
      var inductionVariable = index;
      if (inductionVariable < size)
        $l$loop_1: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          iterations = iterations + 1 | 0;
          var item_0 = _Item___init__impl__hhk1le(n);
          var inside = this.q3i(item_0, x, y);
          if (inside) {
            found = true;
            break $l$loop_1;
          }
          if (this.r3i(item_0) > y)
            break $l$loop_1;
        }
         while (inductionVariable < size);
    } else {
      var inductionVariable_0 = 0;
      var last = this.e1();
      if (inductionVariable_0 < last)
        $l$loop_2: do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          iterations = iterations + 1 | 0;
          var it = this.o3i(n_0);
          if (this.q3i(it, x, y)) {
            found = true;
            // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.pointInside.<anonymous>' call
            break $l$loop_2;
          }
        }
         while (inductionVariable_0 < last);
    }
    if (!(null == null)) {
      null.u3i_1 = iterations;
      null.v3i_1 = iterations2;
      null.w3i_1 = this.e1();
      null.t3i_1 = found;
    }
    return found;
  }
  x3i(x, y, assumeSorted, $super) {
    assumeSorted = assumeSorted === VOID ? this.m3i_1 : assumeSorted;
    return $super === VOID ? this.p3i(x, y, assumeSorted) : $super.p3i.call(this, x, y, assumeSorted);
  }
  y3i(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 0 | 0);
  }
  z3i(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 1 | 0);
  }
  r3i(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 2 | 0);
  }
  a3j(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 3 | 0);
  }
  b3j(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 4 | 0);
  }
  s3i(_this__u8e3s4) {
    return this.n3i_1.d1(imul(_Item___get_index__impl__lpanhd(_this__u8e3s4), 6) + 5 | 0);
  }
  q3i(_this__u8e3s4, x, y) {
    return Companion_instance_8.c3j(this.y3i(_this__u8e3s4), this.z3i(_this__u8e3s4), this.r3i(_this__u8e3s4), this.a3j(_this__u8e3s4), this.b3j(_this__u8e3s4), this.s3i(_this__u8e3s4), x, y);
  }
  d3j(x0a, x0b, y0, x1a, x1b, y1) {
    // Inline function 'kotlin.also' call
    var this_0 = new Item(_Item___init__impl__hhk1le(this.e1()));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FTrapezoidsInt.add.<anonymous>' call
    this_0.l3i_1;
    this.n3i_1.v2j(x0a, x0b, y0, x1a, x1b, y1);
    return this_0.l3i_1;
  }
}
class Companion_7 {}
class SortOps_0 extends SortOps {
  constructor(gen) {
    super();
    this.f3j_1 = gen;
  }
  g3j(subject, l, r) {
    // Inline function 'kotlin.compareTo' call
    var this_0 = this.f3j_1(subject, new Item_0(_Item___init__impl__hhk1le_0(l)));
    var other = this.f3j_1(subject, new Item_0(_Item___init__impl__hhk1le_0(r)));
    return compareTo(this_0, other);
  }
  z2k(subject, l, r) {
    return this.g3j(subject instanceof FSegmentsInt ? subject : THROW_CCE(), l, r);
  }
  h3j(subject, indexL, indexR) {
    return subject.j3j(_Item___init__impl__hhk1le_0(indexL), _Item___init__impl__hhk1le_0(indexR));
  }
  b2l(subject, indexL, indexR) {
    return this.h3j(subject instanceof FSegmentsInt ? subject : THROW_CCE(), indexL, indexR);
  }
}
class Item_0 {
  constructor(index) {
    this.e3j_1 = index;
  }
  toString() {
    return Item__toString_impl_d711m6_0(this.e3j_1);
  }
  hashCode() {
    return Item__hashCode_impl_8k4v6p_0(this.e3j_1);
  }
  equals(other) {
    return Item__equals_impl_qczid_0(this.e3j_1, other);
  }
}
class FSegmentsInt {
  constructor(capacity) {
    capacity = capacity === VOID ? 5 : capacity;
    this.i3j_1 = IntArrayList.n2j(imul(capacity, 4));
  }
  e1() {
    return this.i3j_1.e1() / 4 | 0;
  }
  sx() {
    // Inline function 'kotlin.also' call
    var this_0 = new FSegmentsInt(this.e1());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.clone.<anonymous>' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.clone.<anonymous>.<anonymous>' call
        var it = this.k3j(n);
        this_0.p3j(this.l3j(it), this.m3j(it), this.n3j(it), this.o3j(it));
      }
       while (inductionVariable < last);
    return this_0;
  }
  q3j(gen) {
    // Inline function 'kotlin.also' call
    var this_0 = this.sx();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.sortedBy.<anonymous>' call
    this_0.r3j(gen);
    return this_0;
  }
  r3j(gen) {
    genericSort(this, 0, this.e1() - 1 | 0, new SortOps_0(gen));
  }
  j3j(a, b) {
    var ax0 = this.l3j(a);
    var ay0 = this.m3j(a);
    var ax1 = this.n3j(a);
    var ay1 = this.o3j(a);
    this.s3j(a, this.l3j(b), this.m3j(b), this.n3j(b), this.o3j(b));
    this.s3j(b, ax0, ay0, ax1, ay1);
  }
  k3j(index) {
    return _Item___init__impl__hhk1le_0(index);
  }
  t3j(index) {
    return (0 <= index ? index < this.e1() : false) ? this.k3j(index) : null;
  }
  u3j(_this__u8e3s4, value) {
    this.i3j_1.a2k(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0, value);
  }
  l3j(_this__u8e3s4) {
    return this.i3j_1.d1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 0 | 0);
  }
  v3j(_this__u8e3s4, value) {
    this.i3j_1.a2k(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0, value);
  }
  m3j(_this__u8e3s4) {
    return this.i3j_1.d1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 1 | 0);
  }
  w3j(_this__u8e3s4, value) {
    this.i3j_1.a2k(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0, value);
  }
  n3j(_this__u8e3s4) {
    return this.i3j_1.d1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 2 | 0);
  }
  x3j(_this__u8e3s4, value) {
    this.i3j_1.a2k(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0, value);
  }
  o3j(_this__u8e3s4) {
    return this.i3j_1.d1(imul(_Item___get_index__impl__lpanhd_0(_this__u8e3s4), 4) + 3 | 0);
  }
  s3j(_this__u8e3s4, x0, y0, x1, y1) {
    this.u3j(_this__u8e3s4, x0);
    this.v3j(_this__u8e3s4, y0);
    this.w3j(_this__u8e3s4, x1);
    this.x3j(_this__u8e3s4, y1);
  }
  y3j(_this__u8e3s4) {
    return this.n3j(_this__u8e3s4) - this.l3j(_this__u8e3s4) | 0;
  }
  z3j(_this__u8e3s4) {
    return this.o3j(_this__u8e3s4) - this.m3j(_this__u8e3s4) | 0;
  }
  a3k(_this__u8e3s4) {
    return this.y3j(_this__u8e3s4) / this.z3j(_this__u8e3s4);
  }
  b3k(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.l3j(_this__u8e3s4);
    var b = this.n3j(_this__u8e3s4);
    return Math.min(a, b);
  }
  c3k(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = this.m3j(_this__u8e3s4);
    var b = this.o3j(_this__u8e3s4);
    return Math.min(a, b);
  }
  d3k(_this__u8e3s4) {
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = this.m3j(_this__u8e3s4);
    var b = this.o3j(_this__u8e3s4);
    return Math.max(a, b);
  }
  e3k(_this__u8e3s4, y) {
    return this.l3j(_this__u8e3s4) + toIntRound((y - this.m3j(_this__u8e3s4) | 0) * this.a3k(_this__u8e3s4)) | 0;
  }
  f3k(_this__u8e3s4, y) {
    var containsLower = this.c3k(_this__u8e3s4);
    return y <= this.d3k(_this__u8e3s4) ? containsLower <= y : false;
  }
  g3k(_this__u8e3s4, other) {
    return Companion_instance_9.h3k(this.l3j(_this__u8e3s4), this.m3j(_this__u8e3s4), this.n3j(_this__u8e3s4), this.o3j(_this__u8e3s4), this.l3j(other), this.m3j(other), this.n3j(other), this.o3j(other));
  }
  p3j(x0, y0, x1, y1) {
    var index = this.e1();
    this.i3j_1.u2j(x0, y0, x1, y1);
    return _Item___init__impl__hhk1le_0(index);
  }
  i3k(v, segments) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.add.<anonymous>' call
    return this.p3j(segments.l3j(v), segments.m3j(v), segments.n3j(v), segments.o3j(v));
  }
}
class SegmentIntToTrapezoidIntList {
  j3k(segments, winding, trapezoids) {
    var _destruct__k2r9zo = segmentLookups(this, segments);
    var allY = _destruct__k2r9zo.fl();
    var allSegmentsInY = _destruct__k2r9zo.gl();
    var inductionVariable = 0;
    var last = allY.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y0 = allY[n];
        var y1 = allY[n + 1 | 0];
        var segs = allSegmentsInY.d1(n);
        // Inline function 'kotlin.collections.arrayListOf' call
        var chunks = ArrayList.h1();
        switch (winding.n3_1) {
          case 0:
            var progression = step(until(0, segs.e1()), 2);
            var inductionVariable_0 = progression.a2_1;
            var last_0 = progression.b2_1;
            var step_0 = progression.c2_1;
            if (step_0 > 0 && inductionVariable_0 <= last_0 || (step_0 < 0 && last_0 <= inductionVariable_0))
              $l$loop_1: do {
                var m = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + step_0 | 0;
                var tmp0_elvis_lhs = segs.t3j(m + 0 | 0);
                var tmp;
                var tmp_0 = tmp0_elvis_lhs;
                if ((tmp_0 == null ? null : new Item_0(tmp_0)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                var s0 = tmp;
                var tmp1_elvis_lhs = segs.t3j(m + 1 | 0);
                var tmp_1;
                var tmp_2 = tmp1_elvis_lhs;
                if ((tmp_2 == null ? null : new Item_0(tmp_2)) == null) {
                  continue $l$loop_1;
                } else {
                  tmp_1 = tmp1_elvis_lhs;
                }
                var s1 = tmp_1;
                var tmp_3;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                if (!segs.f3k(s0, y1)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                  tmp_3 = !segs.f3k(s1, y1);
                }
                if (tmp_3)
                  continue $l$loop_1;
                // Inline function 'kotlin.collections.plusAssign' call
                var element = new Pair(new Item_0(s0), new Item_0(s1));
                chunks.h(element);
              }
               while (!(m === last_0));
            break;
          case 1:
            var sign = 0;
            var inductionVariable_1 = 0;
            var last_1 = segs.e1();
            if (inductionVariable_1 < last_1)
              $l$loop_2: do {
                var m_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var seg = segs.k3j(m_0);
                if (!(sign === 0) && m_0 > 0) {
                  var s0_0 = segs.k3j(m_0 - 1 | 0);
                  var s1_0 = seg;
                  var tmp_4;
                  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                  // Inline function 'kotlin.run' call
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                  if (!segs.f3k(s0_0, y1)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                    // Inline function 'kotlin.run' call
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                    tmp_4 = !segs.f3k(s1_0, y1);
                  }
                  if (tmp_4)
                    continue $l$loop_2;
                  // Inline function 'kotlin.collections.plusAssign' call
                  var element_0 = new Pair(new Item_0(s0_0), new Item_0(s1_0));
                  chunks.h(element_0);
                }
                var tmp_5 = sign;
                // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
                // Inline function 'kotlin.run' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
                sign = tmp_5 + get_sign(segs.z3j(seg)) | 0;
              }
               while (inductionVariable_1 < last_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var _iterator__ex2g4s = chunks.a1();
        while (_iterator__ex2g4s.b1()) {
          var _destruct__k2r9zo_0 = _iterator__ex2g4s.c1();
          var s0_1 = _destruct__k2r9zo_0.fl().e3j_1;
          var s1_1 = _destruct__k2r9zo_0.gl().e3j_1;
          // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.invoke' call
          // Inline function 'kotlin.run' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.convert.<anonymous>' call
          var x0a = segs.e3k(s0_1, y0);
          var x0b = segs.e3k(s1_1, y0);
          var x1a = segs.e3k(s0_1, y1);
          var x1b = segs.e3k(s1_1, y1);
          var tmp_6;
          if (x1b < x1a) {
            var intersectY = segs.g3k(s0_1, s1_1);
            var intersectX = segs.e3k(s0_1, intersectY);
            trapezoids.d3j(x0a, x0b, y0, intersectX, intersectX, intersectY);
            tmp_6 = trapezoids.d3j(intersectX, intersectX, intersectY, x1a, x1b, y1);
          } else {
            tmp_6 = trapezoids.d3j(x0a, x0b, y0, x1a, x1b, y1);
          }
        }
      }
       while (inductionVariable < last);
    return trapezoids;
  }
  k3k(segments, winding, trapezoids, $super) {
    winding = winding === VOID ? Winding_EVEN_ODD_getInstance() : winding;
    trapezoids = trapezoids === VOID ? new FTrapezoidsInt() : trapezoids;
    return $super === VOID ? this.j3k(segments, winding, trapezoids) : $super.j3k.call(this, segments, winding, trapezoids);
  }
}
class Companion_8 {
  c3j(x0a, x0b, y0, x1a, x1b, y1, x, y) {
    if (y < y0 || y > y1)
      return false;
    if (x < x0a && x < x1a || (x > x0b && x > x1b))
      return false;
    var sign1 = get_sign(det(this, x1a - x | 0, y1 - y | 0, x0a - x | 0, y0 - y | 0));
    var sign2 = get_sign(det(this, x1b - x | 0, y1 - y | 0, x0b - x | 0, y0 - y | 0));
    return !(sign1 === sign2);
  }
}
class Companion_9 {
  h3k(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var outY = -2147483648;
    $l$block: {
      // Inline function 'korlibs.math.geom.trapezoid.Companion.getIntersectXY' call
      var a1 = By - Ay | 0;
      var b1 = Ax - Bx | 0;
      var c1 = imul(a1, Ax) + imul(b1, Ay) | 0;
      var a2 = Dy - Cy | 0;
      var b2 = Cx - Dx | 0;
      var c2 = imul(a2, Cx) + imul(b2, Cy) | 0;
      var determinant = imul(a1, b2) - imul(a2, b1) | 0;
      if (determinant === 0) {
        break $l$block;
      }
      var x = (imul(b2, c1) - imul(b1, c2) | 0) / determinant | 0;
      var y = (imul(a1, c2) - imul(a2, c1) | 0) / determinant | 0;
      // Inline function 'korlibs.math.geom.trapezoid.Companion.getIntersectY.<anonymous>' call
      outY = y;
    }
    return outY;
  }
}
class Bucket {
  constructor() {
    this.l3k_1 = FastArrayList.ny();
  }
  zg() {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.Bucket.clear.<anonymous>' call
    this.l3k_1.h3();
    return this;
  }
}
class Buckets {
  constructor(pool, ySize) {
    this.m3k_1 = pool;
    this.n3k_1 = ySize;
    this.o3k_1 = FastIntMap();
  }
  e1() {
    return get_size(this.o3k_1);
  }
  p3k(y) {
    return y / this.n3k_1 | 0;
  }
  q3k(index) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.o3k_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(index);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.math.geom.vector.Buckets.getForIndex.<anonymous>' call
      var out = this.m3k_1.m2p();
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(index, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  r3k(y) {
    // Inline function 'korlibs.datastructure.get' call
    var this_0 = this.o3k_1;
    var key = this.p3k(y);
    // Inline function 'kotlin.js.asDynamic' call
    return this_0.get(key);
  }
  h3() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.o3k_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.math.geom.vector.Buckets.clear.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this_0.get(it);
      var value = ensureNotNull(tmp$ret$2);
      this.m3k_1.n2p(value.zg());
    }
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.o3k_1.clear();
  }
  s3k(edge, threshold) {
    var min = this.p3k(edge.d3l());
    var max = this.p3k(edge.e3l());
    if ((max - min | 0) < threshold) {
      var inductionVariable = min;
      if (inductionVariable <= max)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.q3k(n).l3k_1.h(edge);
        }
         while (!(n === max));
      return true;
    }
    return false;
  }
  f3l(edge, threshold, $super) {
    threshold = threshold === VOID ? 2147483647 : threshold;
    return $super === VOID ? this.s3k(edge, threshold) : $super.s3k.call(this, edge, threshold);
  }
}
class AllBuckets {
  constructor() {
    var tmp = this;
    var tmp_0 = PolygonScanline$AllBuckets$pool$lambda;
    tmp.g3l_1 = Pool.j2p(tmp_0, VOID, PolygonScanline$AllBuckets$pool$lambda_0);
    this.h3l_1 = new Buckets(this.g3l_1, 80);
    this.i3l_1 = new Buckets(this.g3l_1, 320);
    this.j3l_1 = new Buckets(this.g3l_1, 1280);
  }
  k3l(edge) {
    if (this.h3l_1.s3k(edge, 4))
      return Unit_instance;
    if (this.i3l_1.s3k(edge, 4))
      return Unit_instance;
    this.j3l_1.f3l(edge);
  }
  h3() {
    this.h3l_1.h3();
    this.i3l_1.h3();
    this.j3l_1.h3();
  }
}
class XWithWind {
  constructor() {
    this.f3m_1 = IntArrayList.n2j(1024);
    this.g3m_1 = IntArrayList.n2j(1024);
  }
  e1() {
    return this.f3m_1.e1();
  }
  h3m(x, wind) {
    this.f3m_1.t2j(x);
    this.g3m_1.t2j(wind);
  }
  h3() {
    this.f3m_1.h3();
    this.g3m_1.h3();
  }
  toString() {
    return 'XWithWind(' + this.f3m_1.toString() + ', ' + this.g3m_1.toString() + ')';
  }
}
class IntArrayListSort extends SortOps {
  constructor() {
    IntArrayListSort_instance = null;
    super();
    IntArrayListSort_instance = this;
  }
  i3m(subject, l, r) {
    return compareTo(subject.f3m_1.qx(l), subject.f3m_1.qx(r));
  }
  z2k(subject, l, r) {
    return this.i3m(subject instanceof XWithWind ? subject : THROW_CCE(), l, r);
  }
  j3m(subject, indexL, indexR) {
    subject.f3m_1.e2k(indexL, indexR);
    subject.g3m_1.e2k(indexL, indexR);
  }
  b2l(subject, indexL, indexR) {
    return this.j3m(subject instanceof XWithWind ? subject : THROW_CCE(), indexL, indexR);
  }
}
class RastScale {
  v3m() {
    return 20;
  }
  w3m() {
    return 0;
  }
  d3m(_this__u8e3s4) {
    return numberToInt(_this__u8e3s4 * this.v3m()) + this.w3m() | 0;
  }
}
class PolygonScanline extends RastScale {
  constructor() {
    super();
    this.l3l_1 = -1;
    this.m3l_1 = Winding_NON_ZERO_getInstance();
    this.n3l_1 = Companion_getInstance_4().e26();
    var tmp = this;
    tmp.o3l_1 = Pool.k2p(VOID, PolygonScanline$edgesPool$lambda);
    this.p3l_1 = FastArrayList.ny();
    this.q3l_1 = FastArrayList.ny();
    this.r3l_1 = FastArrayList.ny();
    this.s3l_1 = new AllBuckets();
    this.t3l_1 = true;
    this.u3l_1 = new PointArrayList();
    this.v3l_1 = 0.0;
    this.w3l_1 = 0.0;
    this.x3l_1 = 0.0;
    this.y3l_1 = 0.0;
    this.z3l_1 = false;
    this.a3m_1 = new XWithWind();
    this.b3m_1 = 0;
    this.c3m_1 = new IntSegmentSet();
  }
  l3a() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.n3l_1);
  }
  c2q() {
    this.t3l_1 = true;
    this.n3l_1 = Companion_getInstance_4().z25_1;
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.p3l_1.ly_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.o3l_1.n2p(it);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.q3l_1.ly_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.math.geom.vector.PolygonScanline.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_0 = array_0[_unary__edvuaz_0];
      this.o3l_1.n2p(it_0);
    }
    this.p3l_1.h3();
    this.q3l_1.h3();
    this.r3l_1.h3();
    this.u3l_1.zg();
    this.s3l_1.h3();
    this.v3l_1 = 0.0;
    this.w3l_1 = 0.0;
    this.x3l_1 = 0.0;
    this.y3l_1 = 0.0;
    this.z3l_1 = false;
  }
  k3m() {
    return this.p3l_1.e1();
  }
  o27() {
    return this.k3m() > 0;
  }
  l3m(x, y) {
    this.x3l_1 = x;
    this.y3l_1 = y;
    this.v3l_1 = x;
    this.w3l_1 = y;
    this.z3l_1 = true;
  }
  m3m(x, y) {
    if (this.z3l_1) {
      addPoint(this, this.x3l_1, this.y3l_1);
    }
    addEdge(this, this.x3l_1, this.y3l_1, x, y);
    addPoint(this, x, y);
    this.x3l_1 = x;
    this.y3l_1 = y;
    this.z3l_1 = false;
  }
  u3d(p) {
    return this.l3m(p.e25_1, p.f25_1);
  }
  h3e(p) {
    return this.m3m(p.e25_1, p.f25_1);
  }
  n3m(path) {
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y27();
    var l = Vector2D.y27();
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.c6();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.o3m(it, true);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          this.o3m(it_0, false);
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance().q2g(l, c) + Companion_getInstance().q2g(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.y27()};
          var prevPos = {_v: Vector2D.y27()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().u3b(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().u3b(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.o3m(it_1, false);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().q2g(l, c0) + Companion_getInstance().q2g(c0, c1) + Companion_getInstance().q2g(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.y27()};
          var prevPos_0 = {_v: Vector2D.y27()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
              this.o3m(it_2, false);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          var p = i;
          this.o3m(p, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call

          if (true) {
            this.c6();
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.add.<anonymous>' call
    if (false) {
      this.c6();
    }
  }
  o3m(p, move) {
    var tmp;
    if (move) {
      this.u3d(p);
      tmp = Unit_instance;
    } else {
      this.h3e(p);
      tmp = Unit_instance;
    }
    return tmp;
  }
  p3m(x, y, move) {
    var tmp;
    if (move) {
      this.l3m(x, y);
      tmp = Unit_instance;
    } else {
      this.m3m(x, y);
      tmp = Unit_instance;
    }
    return tmp;
  }
  c6() {
    this.m3m(this.v3l_1, this.w3l_1);
  }
  q3m(y, winding, out) {
    this.b3m_1 = 0;
    this.a3m_1.h3();
    out.zg();
    var tmp = this;
    var tmp_0 = this.b3m_1;
    // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY' call
    var edgesChecked = 0;
    // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY' call
    var this_0 = this.s3l_1;
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_1 = this_0.h3l_1;
    if (this_1.e1() > 0) {
      var tmp47_safe_receiver = this_1.r3k(y);
      if (tmp47_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = tmp47_safe_receiver.l3k_1.ly_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge = array[_unary__edvuaz];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge.s3m(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge.a3l_1) {
              this.a3m_1.h3m(edge.r3m(y), edge.x3k_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_2 = this_0.i3l_1;
    if (this_2.e1() > 0) {
      var tmp47_safe_receiver_0 = this_2.r3k(y);
      if (tmp47_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp47_safe_receiver_0.l3k_1.ly_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_0 = array_0[_unary__edvuaz_0];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_0.s3m(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_0.a3l_1) {
              this.a3m_1.h3m(edge_0.r3m(y), edge_0.x3k_1);
            }
          }
        }
      }
    }
    // Inline function 'korlibs.math.geom.vector.Buckets.fastForEachY' call
    var this_3 = this_0.j3l_1;
    if (this_3.e1() > 0) {
      var tmp47_safe_receiver_1 = this_3.r3k(y);
      if (tmp47_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'korlibs.math.geom.vector.Bucket.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_1 = tmp47_safe_receiver_1.l3k_1.ly_1;
        var n_1 = 0;
        while (n_1 < array_1.length) {
          // Inline function 'korlibs.math.geom.vector.AllBuckets.fastForEachY.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'korlibs.math.geom.vector.PolygonScanline.forEachActiveEdgeAtY.<anonymous>' call
          var edge_1 = array_1[_unary__edvuaz_1];
          edgesChecked = edgesChecked + 1 | 0;
          if (edge_1.s3m(y)) {
            // Inline function 'korlibs.math.geom.vector.PolygonScanline.scanline.<anonymous>' call
            if (!edge_1.a3l_1) {
              this.a3m_1.h3m(edge_1.r3m(y), edge_1.x3k_1);
            }
          }
        }
      }
    }
    tmp.b3m_1 = tmp_0 + edgesChecked | 0;
    genericSort(this.a3m_1, 0, this.a3m_1.e1() - 1 | 0, IntArrayListSort_getInstance());
    var tempX = this.a3m_1.f3m_1;
    var tempW = this.a3m_1.g3m_1;
    if (this.a3m_1.e1() >= 2) {
      switch (winding.n3_1) {
        case 0:
          var progression = step(until(0, tempX.e1() - 1 | 0), 2);
          var inductionVariable = progression.a2_1;
          var last = progression.b2_1;
          var step_0 = progression.c2_1;
          if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + step_0 | 0;
              var a = tempX.qx(i);
              var b = tempX.qx(i + 1 | 0);
              out.x2r(a, b);
            }
             while (!(i === last));
          break;
        case 1:
          var count = 0;
          var startX = 0;
          var endX = 0;
          var pending = false;
          var inductionVariable_0 = 0;
          var last_0 = tempX.e1() - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var i_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var a_0 = tempX.qx(i_0);
              count = count + tempW.qx(i_0) | 0;
              var b_0 = tempX.qx(i_0 + 1 | 0);
              if (!(count === 0)) {
                if (pending && !(a_0 === endX)) {
                  out.x2r(startX, endX);
                  startX = a_0;
                  endX = b_0;
                } else {
                  if (!pending) {
                    startX = a_0;
                  }
                  endX = b_0;
                }
                pending = true;
              }
            }
             while (inductionVariable_0 < last_0);
          if (pending) {
            out.x2r(startX, endX);
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    return out;
  }
  t3m(x, y, winding) {
    return this.u3m(this.d3m(x), this.d3m(y), winding);
  }
  u3m(x, y, winding) {
    var ss = this.c3m_1;
    this.q3m(y, winding, ss.zg());
    return ss.cp(x);
  }
}
class Companion_10 {
  constructor() {
    this.x3m_1 = 20;
    this.y3m_1 = 0;
    this.z3m_1 = 80;
    this.a3n_1 = 320;
    this.b3n_1 = 1280;
  }
}
class Companion_11 {
  c3n(a, b) {
    // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY' call
    var Ax = a.t3k_1;
    var Ay = a.u3k_1;
    var Bx = a.v3k_1;
    var By = a.w3k_1;
    var Cx = b.t3k_1;
    var Cy = b.u3k_1;
    var Dx = b.v3k_1;
    var Dy = b.w3k_1;
    var tmp52_safe_receiver = this.d3n(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
    var tmp;
    if (tmp52_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion._getIntersectXY.<anonymous>' call
      tmp = Vector2I.g2f(numberToInt(floorCeil(tmp52_safe_receiver.e25_1)), numberToInt(floorCeil(tmp52_safe_receiver.f25_1)));
    }
    var tmp51_safe_receiver = tmp;
    var tmp_0;
    if (tmp51_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.vector.Companion.getIntersectXY.<anonymous>' call
      tmp_0 = Vector2D.a28(tmp51_safe_receiver.d2f_1, tmp51_safe_receiver.e2f_1);
    }
    return tmp_0;
  }
  e3n(a, b) {
    return Angle__minus_impl_xeau7k(b.f3n(), a.f3n());
  }
  d3n(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    return Companion_instance_19.d3n(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy);
  }
}
class MEdge {
  constructor() {
    this.t3k_1 = 0;
    this.u3k_1 = 0;
    this.v3k_1 = 0;
    this.w3k_1 = 0;
    this.x3k_1 = 0;
    this.y3k_1 = 0;
    this.z3k_1 = 0;
    this.a3l_1 = false;
    this.b3l_1 = false;
    this.c3l_1 = 0;
  }
  k27(n) {
    return n === 0 ? this.t3k_1 : this.v3k_1;
  }
  l27(n) {
    return n === 0 ? this.u3k_1 : this.w3k_1;
  }
  g3n(other) {
    return this.e3m(other.t3k_1, other.u3k_1, other.v3k_1, other.w3k_1, other.x3k_1);
  }
  e3m(ax, ay, bx, by, wind) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.MEdge.setTo.<anonymous>' call
    this.t3k_1 = ax;
    this.u3k_1 = ay;
    this.v3k_1 = bx;
    this.w3k_1 = by;
    this.z3k_1 = bx - ax | 0;
    this.y3k_1 = by - ay | 0;
    this.a3l_1 = ay === by;
    this.b3l_1 = ax === bx;
    this.x3k_1 = wind;
    this.c3l_1 = this.b3l_1 ? 0 : ay - (imul(ax, this.y3k_1) / this.z3k_1 | 0) | 0;
    return this;
  }
  d3l() {
    // Inline function 'kotlin.math.min' call
    var a = this.u3k_1;
    var b = this.w3k_1;
    return Math.min(a, b);
  }
  e3l() {
    // Inline function 'kotlin.math.max' call
    var a = this.u3k_1;
    var b = this.w3k_1;
    return Math.max(a, b);
  }
  s3m(y) {
    return y >= this.u3k_1 && y < this.w3k_1;
  }
  r3m(y) {
    return this.b3l_1 || this.y3k_1 === 0 ? this.t3k_1 : imul(y - this.c3l_1 | 0, this.z3k_1) / this.y3k_1 | 0;
  }
  f3n() {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = this.t3k_1;
    var y0 = this.u3k_1;
    var x1 = this.v3k_1;
    var y1 = this.w3k_1;
    // Inline function 'korlibs.math.geom.Companion.between' call
    var up = Companion_getInstance().k25_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  toString() {
    return 'Edge([' + this.t3k_1 + ',' + this.u3k_1 + ']-[' + this.v3k_1 + ',' + this.w3k_1 + '])';
  }
}
class EdgePoint extends Enum {
  constructor(name, ordinal, n) {
    super(name, ordinal);
    this.a3o_1 = n;
  }
}
class StrokeToFill {
  constructor() {
    this.h3n_1 = 1;
    this.j3n_1 = LineCap_BUTT_getInstance();
    this.k3n_1 = LineCap_BUTT_getInstance();
    this.l3n_1 = LineJoin_BEVEL_getInstance();
    this.m3n_1 = 4.0;
    this.n3n_1 = new PointIntArrayList(1024);
    this.o3n_1 = IntArrayList.n2j(1024);
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(2), null);
    while (tmp_0 < 2) {
      tmp_1[tmp_0] = new PointIntArrayList(1024);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.p3n_1 = tmp_1;
    this.q3n_1 = this.p3n_1[0];
    this.r3n_1 = this.p3n_1[1];
    this.s3n_1 = new MEdge();
    this.t3n_1 = new MEdge();
    this.u3n_1 = new MEdge();
    this.v3n_1 = new MEdge();
    this.w3n_1 = new MEdge();
    this.x3n_1 = new MEdge();
  }
  b3o(_this__u8e3s4, edge, width, angle) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.setEdgeDisplaced.<anonymous>' call
    var ldx = width * _Angle___get_cosine__impl__vprvmu(angle);
    var ldy = width * _Angle___get_sine__impl__15nmyi(angle);
    _this__u8e3s4.e3m(numberToInt(edge.t3k_1 + ldx), numberToInt(edge.u3k_1 + ldy), numberToInt(edge.v3k_1 + ldx), numberToInt(edge.w3k_1 + ldy), edge.x3k_1);
    return _this__u8e3s4;
  }
  c3o(_this__u8e3s4, e) {
    return _this__u8e3s4.x2r(e.t3k_1, e.u3k_1);
  }
  d3o(_this__u8e3s4, e) {
    return _this__u8e3s4.x2r(e.v3k_1, e.w3k_1);
  }
  e3o(_this__u8e3s4, e) {
    _this__u8e3s4.x2r(numberToInt(e.e25_1), numberToInt(e.f25_1));
  }
  f3o(out, mainPrev, mainCurr, prev, curr, join, miterLimit, scale, forcedMiter) {
    var rjoin = forcedMiter ? LineJoin_MITER_getInstance() : join;
    switch (rjoin.n3_1) {
      case 2:
        var intersection2 = Vector2D.a28(mainPrev.v3k_1, mainPrev.w3k_1);
        var intersection = Companion_instance_11.c3n(prev, curr);
        if (!(intersection == null)) {
          var dist = Companion_getInstance().q2g(intersection, intersection2);
          if (forcedMiter || dist <= miterLimit) {
            out.y2r(toInt(intersection));
          } else {
            this.d3o(out, prev);
            this.c3o(out, curr);
          }
        }

        break;
      case 0:
        this.d3o(out, prev);
        this.c3o(out, curr);
        break;
      case 1:
        var i = Companion_instance_11.c3n(prev, curr);
        if (!(i == null)) {
          var count = clamp_0(numberToInt(Companion_getInstance().p2g(prev.v3k_1, prev.w3k_1, curr.t3k_1, curr.u3k_1) * scale), 4, 64);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.e3o(out, Companion_getInstance_8().u3b(Vector2D.n27(prev.v3k_1, prev.w3k_1), Vector2D.n27(i.e25_1, i.f25_1), Vector2D.n27(curr.t3k_1, curr.u3k_1), _Ratio___init__impl__9mwvn2(n / count)));
            }
             while (!(n === count));
        } else {
          this.d3o(out, prev);
          this.c3o(out, curr);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  g3o(l, r, left, right, epoint, cap, scale) {
    var angle = epoint.equals(EdgePoint_A_getInstance()) ? Angle__unaryMinus_impl_7901fr(left.f3n()) : Angle__unaryPlus_impl_eyi5pl(left.f3n());
    var lx = left.k27(epoint.a3o_1);
    var ly = left.l27(epoint.a3o_1);
    var rx = right.k27(epoint.a3o_1);
    var ry = right.l27(epoint.a3o_1);
    switch (cap.n3_1) {
      case 0:
        l.x2r(lx, ly);
        r.x2r(rx, ry);
        break;
      case 2:
      case 1:
        var ax = numberToInt(_Angle___get_cosine__impl__vprvmu(angle) * this.h3n_1 / 2);
        var ay = numberToInt(_Angle___get_sine__impl__15nmyi(angle) * this.h3n_1 / 2);
        var lx2 = lx + ax | 0;
        var ly2 = ly + ay | 0;
        var rx2 = rx + ax | 0;
        var ry2 = ry + ay | 0;
        if (cap.equals(LineCap_SQUARE_getInstance())) {
          l.x2r(lx2, ly2);
          r.x2r(rx2, ry2);
        } else {
          var count = clamp_0(numberToInt(Companion_getInstance_26().p2g(lx, ly, rx, ry) * scale), 4, 64);
          l.x2r(lx, ly);
          var inductionVariable = 0;
          if (inductionVariable <= count)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var m = epoint.equals(EdgePoint_A_getInstance()) ? n : count - n | 0;
              var ratio = _Ratio___init__impl__9mwvn2(m / count);
              this.e3o(r, Companion_getInstance_8().t3b(Vector2D.n27(lx, ly), Vector2D.n27(lx2, ly2), Vector2D.n27(rx2, ry2), Vector2D.n27(rx, ry), ratio));
            }
             while (!(n === count));
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  o3o(scale, closed) {
    if (this.n3n_1.g1())
      return Unit_instance;
    var weightD2 = this.h3n_1 / 2 | 0;
    this.q3n_1.h3();
    this.r3n_1.h3();
    var sp = this.n3n_1;
    var nstrokePoints = sp.e1();
    var inductionVariable = 0;
    if (inductionVariable < nstrokePoints)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var isFirst = n === 0;
        var isLast = n === (nstrokePoints - 1 | 0);
        var isMiddle = !isFirst && (!isLast || closed);
        var n1 = isLast ? closed ? 1 : n : n + 1 | 0;
        this.s3n_1.g3n(this.v3n_1);
        this.t3n_1.g3n(this.w3n_1);
        this.u3n_1.g3n(this.x3n_1);
        var doJoin = !(this.o3n_1.qx(n) === 0);
        this.v3n_1.e3m(sp.k27(n), sp.l27(n), sp.k27(n1), sp.l27(n1), 1);
        this.b3o(this.w3n_1, this.v3n_1, weightD2, Angle__minus_impl_xeau7k(this.v3n_1.f3n(), get_degrees(90)));
        this.b3o(this.x3n_1, this.v3n_1, weightD2, Angle__plus_impl_26v37k(this.v3n_1.f3n(), get_degrees(90)));
        if (isFirst) {
          this.g3o(this.q3n_1, this.r3n_1, this.w3n_1, this.x3n_1, EdgePoint_A_getInstance(), closed ? LineCap_BUTT_getInstance() : this.j3n_1, scale);
        } else if (isMiddle) {
          var angle = Companion_instance_11.e3n(this.s3n_1, this.v3n_1);
          var leftAngle = Angle__compareTo_impl_a0hfds(angle, get_degrees(0)) > 0;
          if (doJoin) {
            this.f3o(this.q3n_1, this.s3n_1, this.v3n_1, this.t3n_1, this.w3n_1, this.l3n_1, this.m3n_1, scale, leftAngle);
            this.f3o(this.r3n_1, this.s3n_1, this.v3n_1, this.u3n_1, this.x3n_1, this.l3n_1, this.m3n_1, scale, !leftAngle);
          } else {
            this.c3o(this.q3n_1, this.w3n_1);
            this.c3o(this.r3n_1, this.x3n_1);
          }
        } else if (isLast) {
          if (closed) {
            this.g3o(this.q3n_1, this.r3n_1, this.w3n_1, this.x3n_1, EdgePoint_B_getInstance(), LineCap_BUTT_getInstance(), scale);
          } else {
            this.g3o(this.q3n_1, this.r3n_1, this.t3n_1, this.u3n_1, EdgePoint_B_getInstance(), this.k3n_1, scale);
          }
        }
      }
       while (inductionVariable < nstrokePoints);
    var inductionVariable_0 = 0;
    var last = this.q3n_1.e1();
    if (inductionVariable_0 < last)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var x = this.q3n_1.k27(n_0);
        var y = this.q3n_1.l27(n_0);
        if (n_0 === 0) {
          _get_outFill__zcv64g(this).u3d(Vector2D.n27(x * scale, y * scale));
        } else {
          _get_outFill__zcv64g(this).h3e(Vector2D.n27(x * scale, y * scale));
        }
      }
       while (inductionVariable_0 < last);
    var inductionVariable_1 = 0;
    var last_0 = this.r3n_1.e1();
    if (inductionVariable_1 < last_0)
      do {
        var n_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var m = (this.r3n_1.e1() - n_1 | 0) - 1 | 0;
        _get_outFill__zcv64g(this).h3e(Vector2D.n27(this.r3n_1.k27(m) * scale, this.r3n_1.l27(m) * scale));
      }
       while (inductionVariable_1 < last_0);
    _get_outFill__zcv64g(this).c6();
    _get_outFill__zcv64g(this).z3d_1 = Winding_NON_ZERO_getInstance();
    this.n3n_1.h3();
    this.o3n_1.h3();
  }
  p3o(outFill, weight, startCap, endCap, joins, miterLimit) {
    this.i3n_1 = outFill;
    this.h3n_1 = weight;
    this.j3n_1 = startCap;
    this.k3n_1 = endCap;
    this.l3n_1 = joins;
    this.m3n_1 = miterLimit * weight;
  }
  q3o(stroke, lineWidth, joins, startCap, endCap, miterLimit, outFill) {
    var scale = 20;
    var iscale = 1.0 / 20;
    this.p3o(outFill, numberToInt(lineWidth * scale), startCap, endCap, joins, miterLimit);
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.y27();
    var l = Vector2D.y27();
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.o3o(iscale, true);
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = stroke.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = stroke.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.n27(tmp, stroke.y3d_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.o3o(iscale, false);
          }

          this.n3n_1.x2r(numberToInt(it.e25_1 * scale), numberToInt(it.f25_1 * scale));
          this.o3n_1.t2j(0);
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = stroke.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.n27(tmp_0, stroke.y3d_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (false) {
            this.o3o(iscale, false);
          }

          this.n3n_1.x2r(numberToInt(it_0.e25_1 * scale), numberToInt(it_0.f25_1 * scale));
          this.o3n_1.t2j(0);
          l = it_0;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.o3n_1.a2k(this.o3n_1.e1() - 1 | 0, 1);
          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = stroke.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.n27(tmp_1, stroke.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = stroke.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.n27(tmp_2, stroke.y3d_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance().q2g(l, c) + Companion_getInstance().q2g(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos = {_v: Vector2D.y27()};
          var prevPos = {_v: Vector2D.y27()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_6().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos._v = Companion_getInstance_8().u3b(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_8().u3b(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.o3o(iscale, false);
              }
              this.n3n_1.x2r(numberToInt(it_1.e25_1 * scale), numberToInt(it_1.f25_1 * scale));
              this.o3n_1.t2j(0);
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.o3n_1.a2k(this.o3n_1.e1() - 1 | 0, 1);
          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = stroke.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.n27(tmp_3, stroke.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = stroke.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.n27(tmp_4, stroke.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = stroke.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.n27(tmp_5, stroke.y3d_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance().q2g(l, c0) + Companion_getInstance().q2g(c0, c1) + Companion_getInstance().q2g(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_0 = {_v: Vector2D.y27()};
          var prevPos_0 = {_v: Vector2D.y27()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_6().kx_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
              if (false) {
                this.o3o(iscale, false);
              }
              this.n3n_1.x2r(numberToInt(it_2.e25_1 * scale), numberToInt(it_2.f25_1 * scale));
              this.o3n_1.t2j(0);
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_0._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.o3n_1.a2k(this.o3n_1.e1() - 1 | 0, 1);
          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          var p = i;
          if (false) {
            this.o3o(iscale, false);
          }

          this.n3n_1.x2r(numberToInt(p.e25_1 * scale), numberToInt(p.f25_1 * scale));
          this.o3n_1.t2j(0);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          this.o3n_1.a2k(this.o3n_1.e1() - 1 | 0, 1);
          // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call

          if (true) {
            this.o3o(iscale, true);
          }

          break;
      }
    }
    // Inline function 'korlibs.math.geom.vector.StrokeToFill.strokeFill.<anonymous>' call
    if (false) {
      this.o3o(iscale, true);
    }
    this.o3o(iscale, false);
  }
}
class VectorBuilder {}
function quadTo(c, a) {
  // Inline function 'korlibs.math.geom.bezier.Companion.quadToCubic' call
  var this_0 = Companion_getInstance_8();
  var x0 = this.w3o().e25_1;
  var y0 = this.w3o().f25_1;
  var xc = c.e25_1;
  var yc = c.f25_1;
  var x1 = a.e25_1;
  var y1 = a.f25_1;
  var cx1 = this_0.v3b(x0, xc);
  var cy1 = this_0.v3b(y0, yc);
  var cx2 = this_0.w3b(xc, x1);
  var cy2 = this_0.w3b(yc, y1);
  this.v3d(Vector2D.n27(cx1, cy1), Vector2D.n27(cx2, cy2), Vector2D.n27(x1, y1));
}
function line(p0, p1) {
  this.u3d(p0);
  this.h3e(p1);
}
function isEmpty() {
  return this.v3o() === 0;
}
function isNotEmpty() {
  return !(this.v3o() === 0);
}
function rect(rect) {
  return this.a3p(rect.o25_1, rect.p25_1, rect.q25_1, rect.r25_1);
}
function rect_0(pos, size) {
  this.a3p(pos.e25_1, pos.f25_1, size.j26_1, size.k26_1);
}
function rect_1(x, y, width, height) {
  this.u3d(Vector2D.n27(x, y));
  this.h3e(Vector2D.n27(x + width, y));
  this.h3e(Vector2D.n27(x + width, y + height));
  this.h3e(Vector2D.n27(x, y + height));
  this.c6();
}
function arc(center, r, start, end, counterclockwise) {
  return Arc_instance.t3d(this, center, numberToDouble(r), start, end, counterclockwise);
}
function arc$default(center, r, start, end, counterclockwise, $super) {
  counterclockwise = counterclockwise === VOID ? false : counterclockwise;
  var tmp;
  if ($super === VOID) {
    this.b3p(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  } else {
    arc(center, r, start, end, counterclockwise);
    tmp = Unit_instance;
  }
  return tmp;
}
function circle(center, radius) {
  return this.c3p(center, radius, Companion_getInstance_0().v24_1, Companion_getInstance_0().z24_1);
}
function rMoveTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.w3o();
  var tmp$ret$0 = Vector2D.n27(this_0.e25_1 + delta.e25_1, this_0.f25_1 + delta.f25_1);
  return this.u3d(tmp$ret$0);
}
function rLineTo(delta) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.w3o();
  var tmp$ret$0 = Vector2D.n27(this_0.e25_1 + delta.e25_1, this_0.f25_1 + delta.f25_1);
  return this.h3e(tmp$ret$0);
}
function transformed(m) {
  var im = m.j2a();
  var parent = this;
  return new VectorBuilder$transformed$1(parent, im, m);
}
function transformed_0(m, block) {
  return block(this.x2e(m));
}
class VectorBuilder$transformed$1 {
  constructor($parent, $im, $m) {
    this.s3o_1 = $parent;
    this.t3o_1 = $im;
    this.u3o_1 = $m;
    this.r3o_1 = $parent.v3o();
  }
  w3o() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.t3o_1;
      var p = this.s3o_1.w3o();
      if (this_0.t25()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
    }
    return tmp$ret$0;
  }
  v3o() {
    return this.r3o_1;
  }
  c6() {
    return this.s3o_1.c6();
  }
  h3e(p) {
    return this.s3o_1.h3e(t(this, p));
  }
  u3d(p) {
    return this.s3o_1.h3e(t(this, p));
  }
  i3e(c, a) {
    return this.s3o_1.i3e(t(this, c), t(this, a));
  }
  v3d(c1, c2, a) {
    return this.s3o_1.v3d(t(this, c1), t(this, c2), t(this, a));
  }
}
class Companion_12 {}
class Visitor {}
function close() {
  return Unit_instance;
}
function moveTo(p) {
  return Unit_instance;
}
function lineTo(p) {
  return Unit_instance;
}
function quadTo_0(c, a) {
  return Unit_instance;
}
function cubicTo(c1, c2, a) {
  return Unit_instance;
}
class VectorPath extends AbstractShape2D {
  constructor(commands, data, winding, optimize) {
    commands = commands === VOID ? IntArrayList.n2j() : commands;
    data = data === VOID ? DoubleArrayList.j2k() : data;
    winding = winding === VOID ? Companion_instance_13.h3p() : winding;
    optimize = optimize === VOID ? true : optimize;
    super();
    this.w3d_1 = new Mixin();
    this.x3d_1 = commands;
    this.y3d_1 = data;
    this.z3d_1 = winding;
    this.a3e_1 = optimize;
    this.b3e_1 = false;
    this.c3e_1 = 0;
    this.d3e_1 = Vector2D.y27();
    this.e3e_1 = Vector2D.y27();
    this.f3e_1 = null;
    this.g3e_1 = null;
  }
  vx(_set____db54di) {
    this.w3d_1.vx(_set____db54di);
  }
  wx() {
    return this.w3d_1.wx();
  }
  sx() {
    return new VectorPath(IntArrayList.p2j(this.x3d_1), DoubleArrayList.k2k(this.y3d_1), this.z3d_1);
  }
  equals(other) {
    if (this === other)
      return true;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof VectorPath) {
      tmp_1 = this.x3d_1.equals(other.x3d_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.y3d_1.equals(other.y3d_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.z3d_1.equals(other.z3d_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return (this.x3d_1.hashCode() + imul(this.y3d_1.hashCode(), 13) | 0) + imul(this.z3d_1.n3_1, 111) | 0;
  }
  i3p(visitor) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.x3d_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.qx(_unary__edvuaz)) {
        case 0:
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var p0 = Vector2D.n27(tmp, this.y3d_1.d1(_unary__edvuaz_1));
          visitor.u3d(p0);
          break;
        case 1:
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var p0_0 = Vector2D.n27(tmp_0, this.y3d_1.d1(_unary__edvuaz_3));
          visitor.h3e(p0_0);
          break;
        case 2:
          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p0_1 = Vector2D.n27(tmp_1, this.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p1 = Vector2D.n27(tmp_2, this.y3d_1.d1(_unary__edvuaz_7));
          visitor.i3e(p0_1, p1);
          break;
        case 3:
          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p0_2 = Vector2D.n27(tmp_3, this.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p1_0 = Vector2D.n27(tmp_4, this.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p2 = Vector2D.n27(tmp_5, this.y3d_1.d1(_unary__edvuaz_13));
          visitor.v3d(p0_2, p1_0, p2);
          break;
        case 4:
          visitor.c6();
          break;
      }
    }
  }
  h3() {
    this.x3d_1.h3();
    this.y3d_1.h3();
    this.d3e_1 = Vector2D.y27();
    this.c3e_1 = 0;
    this.j3p().l3l_1 = this.c3e_1 - 1 | 0;
  }
  w3o() {
    return this.d3e_1;
  }
  u3d(p) {
    if (this.x3d_1.o27() && this.x3d_1.c2k() === 0) {
      if (this.d3e_1.equals(p))
        return Unit_instance;
    }
    this.x3d_1.t2j(0);
    this.y3d_1.o2k(p.e25_1, p.f25_1);
    this.d3e_1 = p;
    this.e3e_1 = p;
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  h3e(p) {
    if (ensureMoveTo(this, p) && this.a3e_1)
      return Unit_instance;
    if (p.equals(this.d3e_1) && this.a3e_1)
      return Unit_instance;
    this.x3d_1.t2j(1);
    this.y3d_1.o2k(p.e25_1, p.f25_1);
    this.d3e_1 = p;
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  i3e(c, a) {
    ensureMoveTo(this, c);
    this.x3d_1.t2j(2);
    this.y3d_1.p2k(c.e25_1, c.f25_1, a.e25_1, a.f25_1);
    this.d3e_1 = a;
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  v3d(c1, c2, a) {
    ensureMoveTo(this, c1);
    this.x3d_1.t2j(3);
    this.y3d_1.q2k(c1.e25_1, c1.f25_1, c2.e25_1, c2.f25_1, a.e25_1, a.f25_1);
    this.d3e_1 = a;
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  c6() {
    this.x3d_1.t2j(4);
    this.d3e_1 = this.e3e_1;
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  v3o() {
    return this.y3d_1.e1() / 2 | 0;
  }
  l3a() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(plus_0(Companion_getInstance_4().e26(), this));
  }
  k3p(x, y) {
    return this.l3p().t3m(x, y, this.z3d_1);
  }
  t3p(p) {
    return this.t3m(p.e25_1, p.f25_1, this.z3d_1);
  }
  l3p() {
    if (this.f3e_1 == null || !(ensureNotNull(this.f3e_1).m3p_1 === this.c3e_1)) {
      this.f3e_1 = new VectorPathTrapezoids(this.c3e_1, this);
    }
    return ensureNotNull(this.f3e_1);
  }
  j3p() {
    if (this.g3e_1 == null)
      this.g3e_1 = new PolygonScanline();
    var scanline = ensureNotNull(this.g3e_1);
    if (!(scanline.l3l_1 === this.c3e_1)) {
      scanline.c2q();
      scanline.n3m(this);
      scanline.l3l_1 = this.c3e_1;
    }
    return ensureNotNull(this.g3e_1);
  }
  t3m(x, y, winding) {
    return this.j3p().t3m(x, y, winding);
  }
  u3p(path, transform) {
    this.x3d_1.x2j(path.x3d_1);
    if (transform.m29()) {
      this.y3d_1.s2k(path.y3d_1);
      this.d3e_1 = path.d3e_1;
    } else {
      var progression = step(until(0, path.y3d_1.e1()), 2);
      var inductionVariable = progression.a2_1;
      var last = progression.b2_1;
      var step_0 = progression.c2_1;
      if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + step_0 | 0;
          var tmp$ret$0;
          $l$block: {
            // Inline function 'korlibs.math.geom.Matrix.transform' call
            var p = Vector2D.n27(path.y3d_1.d1(n + 0 | 0), path.y3d_1.d1(n + 1 | 0));
            if (transform.t25()) {
              tmp$ret$0 = p;
              break $l$block;
            }
            tmp$ret$0 = Vector2D.n27(transform.p29(p.e25_1, p.f25_1), transform.s29(p.e25_1, p.f25_1));
          }
          var p_0 = tmp$ret$0;
          this.y3d_1.o2k(p_0.e25_1, p_0.f25_1);
        }
         while (!(n === last));
      var tmp = this;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        var p_1 = path.d3e_1;
        if (transform.t25()) {
          tmp$ret$1 = p_1;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.n27(transform.p29(p_1.e25_1, p_1.f25_1), transform.s29(p_1.e25_1, p_1.f25_1));
      }
      tmp.d3e_1 = tmp$ret$1;
    }
    this.c3e_1 = this.c3e_1 + 1 | 0;
  }
  v3p(path, transform, $super) {
    transform = transform === VOID ? Companion_getInstance_2().x28_1 : transform;
    var tmp;
    if ($super === VOID) {
      this.u3p(path, transform);
      tmp = Unit_instance;
    } else {
      tmp = $super.u3p.call(this, path, transform);
    }
    return tmp;
  }
  w3p() {
    // Inline function 'kotlin.text.trimEnd' call
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.x3d_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = this.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.n27(tmp, this.y3d_1.d1(_unary__edvuaz_1));
          var x = destruct.fl();
          var y = destruct.gl();
          this_0.ob('M' + get_niceStr(x) + ',' + get_niceStr(y) + ' ');
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = this.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.n27(tmp_0, this.y3d_1.d1(_unary__edvuaz_3));
          var x_0 = destruct_0.fl();
          var y_0 = destruct_0.gl();
          this_0.ob('L' + get_niceStr(x_0) + ',' + get_niceStr(y_0) + ' ');
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = this.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.n27(tmp_1, this.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = this.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.n27(tmp_2, this.y3d_1.d1(_unary__edvuaz_7));
          var x1 = destruct_1.fl();
          var y1 = destruct_1.gl();
          var x2 = destruct_2.fl();
          var y2 = destruct_2.gl();
          this_0.ob('Q' + get_niceStr(x1) + ',' + get_niceStr(y1) + ',' + get_niceStr(x2) + ',' + get_niceStr(y2) + ' ');
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = this.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.n27(tmp_3, this.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = this.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.n27(tmp_4, this.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = this.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.n27(tmp_5, this.y3d_1.d1(_unary__edvuaz_13));
          var x1_0 = destruct_3.fl();
          var y1_0 = destruct_3.gl();
          var x2_0 = destruct_4.fl();
          var y2_0 = destruct_4.gl();
          var x3 = destruct_5.fl();
          var y3 = destruct_5.gl();
          this_0.ob('C' + get_niceStr(x1_0) + ',' + get_niceStr(y1_0) + ',' + get_niceStr(x2_0) + ',' + get_niceStr(y2_0) + ',' + get_niceStr(x3) + ',' + get_niceStr(y3) + ' ');
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.toSvgString.<anonymous>.<anonymous>' call

          this_0.ob('Z ');
          break;
      }
    }
    var this_2 = this_0.toString();
    return toString(trimEnd(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  }
  toString() {
    return 'VectorPath(' + this.w3p() + ')';
  }
  x3p(sx, sy) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, this.y3d_1.e1()), 2);
    var inductionVariable = progression.a2_1;
    var last = progression.b2_1;
    var step_0 = progression.c2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.VectorPath.scale.<anonymous>' call
        var it = Vector2D.n27(this.y3d_1.d1(n + 0 | 0), this.y3d_1.d1(n + 1 | 0));
        var p = Vector2D.n27(it.e25_1 * sx, it.f25_1 * sy);
        this.y3d_1.v2k(n + 0 | 0, p.e25_1);
        this.y3d_1.v2k(n + 1 | 0, p.f25_1);
      }
       while (!(n === last));
    this.c3e_1 = this.c3e_1 + 1 | 0;
    return this;
  }
}
class VectorPathTrapezoids {
  constructor(version, path, scale) {
    scale = scale === VOID ? 100 : scale;
    this.m3p_1 = version;
    this.n3p_1 = path;
    this.o3p_1 = scale;
    this.p3p_1 = imul(this.o3p_1, this.o3p_1);
    this.q3p_1 = toSegments(this.n3p_1, this.o3p_1);
    var tmp = this;
    tmp.r3p_1 = lazy(VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.s3p_1 = lazy(VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this));
  }
  y3p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r3p_1;
    trapezoidsEvenOdd$factory();
    return this_0.r1();
  }
  z3p() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s3p_1;
    trapezoidsNonZero$factory();
    return this_0.r1();
  }
  a3q(winding) {
    var tmp;
    switch (winding.n3_1) {
      case 0:
        tmp = this.y3p();
        break;
      case 1:
        tmp = this.z3p();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  t3m(x, y, winding) {
    return this.a3q(winding).x3i(toIntRound(x * this.o3p_1), toIntRound(y * this.o3p_1));
  }
}
class with$1 {
  constructor($bb) {
    this.b3q_1 = $bb;
  }
  u3d(p) {
    this.b3q_1._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x(this.b3q_1._v.r26_1, p));
  }
}
class Companion_13 {
  h3p() {
    return Winding_NON_ZERO_getInstance();
  }
}
class Winding extends Enum {
  constructor(name, ordinal, str) {
    super(name, ordinal);
    this.e3q_1 = str;
  }
}
class Companion_14 {}
class LineJoin extends Enum {}
class Companion_15 {}
class LineCap extends Enum {}
class LineScaleMode extends Enum {
  constructor(name, ordinal, hScale, vScale) {
    super(name, ordinal);
    this.h3q_1 = hScale;
    this.i3q_1 = vScale;
    this.j3q_1 = this.h3q_1 || this.i3q_1;
    this.k3q_1 = (this.h3q_1 && this.i3q_1);
  }
}
class Companion_16 {}
class StrokeInfo {
  constructor(thickness, pixelHinting, scaleMode, startCap, endCap, join, miterLimit, dash, dashOffset) {
    thickness = thickness === VOID ? 1.0 : thickness;
    pixelHinting = pixelHinting === VOID ? false : pixelHinting;
    scaleMode = scaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : scaleMode;
    startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
    endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
    join = join === VOID ? LineJoin_MITER_getInstance() : join;
    miterLimit = miterLimit === VOID ? 20.0 : miterLimit;
    dash = dash === VOID ? null : dash;
    dashOffset = dashOffset === VOID ? 0.0 : dashOffset;
    this.d38_1 = thickness;
    this.e38_1 = pixelHinting;
    this.f38_1 = scaleMode;
    this.g38_1 = startCap;
    this.h38_1 = endCap;
    this.i38_1 = join;
    this.j38_1 = miterLimit;
    this.k38_1 = dash;
    this.l38_1 = dashOffset;
  }
  toString() {
    return 'StrokeInfo(thickness=' + this.d38_1 + ', pixelHinting=' + this.e38_1 + ', scaleMode=' + this.f38_1.toString() + ', startCap=' + this.g38_1.toString() + ', endCap=' + this.h38_1.toString() + ', join=' + this.i38_1.toString() + ', miterLimit=' + this.j38_1 + ', dash=' + toString_0(this.k38_1) + ', dashOffset=' + this.l38_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.d38_1);
    result = imul(result, 31) + getBooleanHashCode(this.e38_1) | 0;
    result = imul(result, 31) + this.f38_1.hashCode() | 0;
    result = imul(result, 31) + this.g38_1.hashCode() | 0;
    result = imul(result, 31) + this.h38_1.hashCode() | 0;
    result = imul(result, 31) + this.i38_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.j38_1) | 0;
    result = imul(result, 31) + (this.k38_1 == null ? 0 : hashCode(this.k38_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l38_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof StrokeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof StrokeInfo ? other : THROW_CCE();
    if (!equals(this.d38_1, tmp0_other_with_cast.d38_1))
      return false;
    if (!(this.e38_1 === tmp0_other_with_cast.e38_1))
      return false;
    if (!this.f38_1.equals(tmp0_other_with_cast.f38_1))
      return false;
    if (!this.g38_1.equals(tmp0_other_with_cast.g38_1))
      return false;
    if (!this.h38_1.equals(tmp0_other_with_cast.h38_1))
      return false;
    if (!this.i38_1.equals(tmp0_other_with_cast.i38_1))
      return false;
    if (!equals(this.j38_1, tmp0_other_with_cast.j38_1))
      return false;
    if (!equals(this.k38_1, tmp0_other_with_cast.k38_1))
      return false;
    if (!equals(this.l38_1, tmp0_other_with_cast.l38_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    var tmp_0 = MPoint$Companion$POOL$lambda;
    tmp.h3o_1 = ConcurrentPool.w2p(tmp_0, VOID, MPoint$Companion$POOL$lambda_0);
    this.i3o_1 = new MPoint(0.0, 0.0);
    this.j3o_1 = new MPoint(1.0, 1.0);
    this.k3o_1 = new MPoint(0.0, -1.0);
    this.l3o_1 = new MPoint(0.0, +1.0);
    this.m3o_1 = new MPoint(-1.0, 0.0);
    this.n3o_1 = new MPoint(+1.0, 0.0);
  }
  a29() {
    return new MPoint(0.0, 0.0);
  }
  o3q(lx, ly, rx, ry) {
    var ret = compareTo(ly, ry);
    return ret === 0 ? compareTo(lx, rx) : ret;
  }
  a2f(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  p2g(x1, y1, x2, y2) {
    return this.a2f(x1, y1, x2, y2);
  }
  p3q(aX, aY, bX, bY) {
    return aX * bX + aY * bY;
  }
}
class MPoint {
  constructor(x, y) {
    Companion_getInstance_26();
    this.l3q_1 = x;
    this.m3q_1 = y;
  }
  q3q(other, epsilon) {
    return isAlmostEquals_0(this.l3q_1, other.l3q_1, epsilon) && isAlmostEquals_0(this.m3q_1, other.m3q_1, epsilon);
  }
  ax(other, epsilon) {
    return this.q3q(other instanceof MPoint ? other : THROW_CCE(), epsilon);
  }
  n3q(x, y) {
    this.l3q_1 = x;
    this.m3q_1 = y;
    return this;
  }
  r3q(other) {
    return Companion_getInstance_26().o3q(this.l3q_1, this.m3q_1, other.l3q_1, other.m3q_1);
  }
  d(other) {
    return this.r3q(other instanceof MPoint ? other : THROW_CCE());
  }
  toString() {
    return '(' + get_niceStr(this.l3q_1) + ', ' + get_niceStr(this.m3q_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.l3q_1);
    result = imul(result, 31) + getNumberHashCode(this.m3q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MPoint))
      return false;
    var tmp0_other_with_cast = other instanceof MPoint ? other : THROW_CCE();
    if (!equals(this.l3q_1, tmp0_other_with_cast.l3q_1))
      return false;
    if (!equals(this.m3q_1, tmp0_other_with_cast.m3q_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    var tmp_0 = MMatrix$Companion$POOL$lambda;
    tmp.z3q_1 = ConcurrentPool.w2p(tmp_0, VOID, MMatrix$Companion$POOL$lambda_0);
  }
}
class MMatrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_27();
    a = a === VOID ? 1.0 : a;
    b = b === VOID ? 0.0 : b;
    c = c === VOID ? 0.0 : c;
    d = d === VOID ? 1.0 : d;
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.s3q_1 = a;
    this.t3q_1 = b;
    this.u3q_1 = c;
    this.v3q_1 = d;
    this.w3q_1 = tx;
    this.x3q_1 = ty;
  }
  a2e() {
    return new Matrix(this.s3q_1, this.t3q_1, this.u3q_1, this.v3q_1, this.w3q_1, this.x3q_1);
  }
  a3r(a, b, c, d, tx, ty) {
    this.s3q_1 = a;
    this.t3q_1 = b;
    this.u3q_1 = c;
    this.v3q_1 = d;
    this.w3q_1 = tx;
    this.x3q_1 = ty;
    return this;
  }
  b3r(that) {
    return this.a3r(that.c29_1, that.d29_1, that.e29_1, that.f29_1, that.g29_1, that.h29_1);
  }
  c3r(dx, dy) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.MMatrix.pretranslate.<anonymous>' call
    this.w3q_1 = this.w3q_1 + (this.s3q_1 * dx + this.u3q_1 * dy);
    this.x3q_1 = this.x3q_1 + (this.t3q_1 * dx + this.v3q_1 * dy);
    return this;
  }
  y3q() {
    return this.a3r(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
  }
  toString() {
    return 'Matrix(a=' + this.s3q_1 + ', b=' + this.t3q_1 + ', c=' + this.u3q_1 + ', d=' + this.v3q_1 + ', tx=' + this.w3q_1 + ', ty=' + this.x3q_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.s3q_1);
    result = imul(result, 31) + getNumberHashCode(this.t3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3q_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x3q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MMatrix))
      return false;
    var tmp0_other_with_cast = other instanceof MMatrix ? other : THROW_CCE();
    if (!equals(this.s3q_1, tmp0_other_with_cast.s3q_1))
      return false;
    if (!equals(this.t3q_1, tmp0_other_with_cast.t3q_1))
      return false;
    if (!equals(this.u3q_1, tmp0_other_with_cast.u3q_1))
      return false;
    if (!equals(this.v3q_1, tmp0_other_with_cast.v3q_1))
      return false;
    if (!equals(this.w3q_1, tmp0_other_with_cast.w3q_1))
      return false;
    if (!equals(this.x3q_1, tmp0_other_with_cast.x3q_1))
      return false;
    return true;
  }
}
class Companion_19 {
  d3r(point, direction, scale, out) {
    return out.e3r(point.e25_1, point.f25_1, point.e25_1 + direction.e25_1 * scale, point.f25_1 + direction.f25_1 * scale);
  }
  e39(point, direction, scale, out, $super) {
    scale = scale === VOID ? 1.0 : scale;
    out = out === VOID ? MLine.f3r() : out;
    return $super === VOID ? this.d3r(point, direction, scale, out) : $super.d3r.call(this, point, direction, scale, out);
  }
  d3n(Ax, Ay, Bx, By, Cx, Cy, Dx, Dy) {
    var a1 = By - Ay;
    var b1 = Ax - Bx;
    var c1 = a1 * Ax + b1 * Ay;
    var a2 = Dy - Cy;
    var b2 = Cx - Dx;
    var c2 = a2 * Cx + b2 * Cy;
    var determinant = a1 * b2 - a2 * b1;
    if (isAlmostZero(determinant))
      return null;
    var x = (b2 * c1 - b1 * c2) / determinant;
    var y = (a1 * c2 - a2 * c1) / determinant;
    return Vector2D.n27(x, y);
  }
}
class MLine {
  static g3r(a, b) {
    var $this = createThis(this);
    $this.f39_1 = a;
    $this.g39_1 = b;
    return $this;
  }
  sx() {
    return MLine.g3r(this.f39_1, this.g39_1);
  }
  e3r(x0, y0, x1, y1) {
    this.f39_1 = Vector2D.n27(x0, y0);
    this.g39_1 = Vector2D.n27(x1, y1);
    return this;
  }
  h39(scale) {
    var tmp = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.f39_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = this.h3r();
    var that = Vector2D.n27(this_1.e25_1 * scale, this_1.f25_1 * scale);
    tmp.f39_1 = Vector2D.n27(this_0.e25_1 - that.e25_1, this_0.f25_1 - that.f25_1);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_2 = this.g39_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_3 = this.h3r();
    var that_0 = Vector2D.n27(this_3.e25_1 * scale, this_3.f25_1 * scale);
    tmp_0.g39_1 = Vector2D.n27(this_2.e25_1 - that_0.e25_1, this_2.f25_1 - that_0.f25_1);
    return this;
  }
  static f3r() {
    return this.g3r(Vector2D.y27(), Vector2D.y27());
  }
  b28() {
    return this.f39_1.e25_1;
  }
  c28() {
    return this.f39_1.f25_1;
  }
  d28() {
    return this.g39_1.e25_1;
  }
  e28() {
    return this.g39_1.f25_1;
  }
  h3r() {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this.g39_1;
    var that = this.f39_1;
    return Vector2D.n27(this_0.e25_1 - that.e25_1, this_0.f25_1 - that.f25_1);
  }
  toString() {
    return 'Line(' + this.f39_1.toString() + ', ' + this.g39_1.toString() + ')';
  }
  i3r(line) {
    return Companion_instance_19.d3n(this.b28(), this.c28(), this.d28(), this.e28(), line.b28(), line.c28(), line.d28(), line.e28());
  }
  hashCode() {
    var result = this.f39_1.hashCode();
    result = imul(result, 31) + this.g39_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MLine))
      return false;
    var tmp0_other_with_cast = other instanceof MLine ? other : THROW_CCE();
    if (!this.f39_1.equals(tmp0_other_with_cast.f39_1))
      return false;
    if (!this.g39_1.equals(tmp0_other_with_cast.g39_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    var tmp = this;
    var tmp_0 = MRectangle$Companion$POOL$lambda;
    tmp.n3r_1 = ConcurrentPool.w2p(tmp_0, VOID, MRectangle$Companion$POOL$lambda_0);
  }
  a29() {
    return new MRectangle(0.0, 0.0, 0.0, 0.0);
  }
}
class MRectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_29();
    this.j3r_1 = x;
    this.k3r_1 = y;
    this.l3r_1 = width;
    this.m3r_1 = height;
  }
  o3r(other, epsilon) {
    return isAlmostEquals_0(this.j3r_1, other.j3r_1, epsilon) && isAlmostEquals_0(this.k3r_1, other.k3r_1, epsilon) && isAlmostEquals_0(this.l3r_1, other.l3r_1, epsilon) && isAlmostEquals_0(this.m3r_1, other.m3r_1, epsilon);
  }
  ax(other, epsilon) {
    return this.o3r(other instanceof MRectangle ? other : THROW_CCE(), epsilon);
  }
  v25() {
    return this.j3r_1;
  }
  x25() {
    return this.k3r_1;
  }
  w25() {
    return this.j3r_1 + this.l3r_1;
  }
  y25() {
    return this.k3r_1 + this.m3r_1;
  }
  e3r(x, y, width, height) {
    this.j3r_1 = x;
    this.k3r_1 = y;
    this.l3r_1 = width;
    this.m3r_1 = height;
    return this;
  }
  p3r(left, top, right, bottom) {
    return this.e3r(left, top, right - left, bottom - top);
  }
  q3r(left, top, right, bottom) {
    return this.p3r(this.v25() - left, this.x25() - top, this.w25() + right, this.y25() + bottom);
  }
  r3r(left, top, right, bottom, $super) {
    top = top === VOID ? left : top;
    right = right === VOID ? left : right;
    bottom = bottom === VOID ? top : bottom;
    return $super === VOID ? this.q3r(left, top, right, bottom) : $super.q3r.call(this, left, top, right, bottom);
  }
  zg() {
    return this.e3r(0.0, 0.0, 0.0, 0.0);
  }
  toString() {
    return 'Rectangle(x=' + get_niceStr(this.j3r_1) + ', y=' + get_niceStr(this.k3r_1) + ', width=' + get_niceStr(this.l3r_1) + ', height=' + get_niceStr(this.m3r_1) + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof MRectangle) {
      tmp_2 = isAlmostEquals_0(this.j3r_1, other.j3r_1);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = isAlmostEquals_0(this.k3r_1, other.k3r_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = isAlmostEquals_0(this.l3r_1, other.l3r_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isAlmostEquals_0(this.m3r_1, other.m3r_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  a2e() {
    return new Rectangle(this.j3r_1, this.k3r_1, this.l3r_1, this.m3r_1);
  }
  hashCode() {
    var result = getNumberHashCode(this.j3r_1);
    result = imul(result, 31) + getNumberHashCode(this.k3r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l3r_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m3r_1) | 0;
    return result;
  }
}
class Easings extends Enum {
  toString() {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return replace(super.toString(), _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45)).toLowerCase();
  }
}
class Easings$SMOOTH extends Easings {
  constructor() {
    super('SMOOTH', 0);
    Easings_SMOOTH_instance = this;
  }
  dx(it) {
    return it * it * (3 - 2 * it);
  }
}
class Easings$EASE_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_ELASTIC', 1);
    Easings_EASE_IN_ELASTIC_instance = this;
  }
  dx(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        var inv = it - 1;
        var tmp_0 = -1.0;
        // Inline function 'kotlin.math.pow' call

        var x = 10.0 * inv;
        var tmp_1 = tmp_0 * Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (inv - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_1 * Math.sin(x_0);
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_ELASTIC', 2);
    Easings_EASE_OUT_ELASTIC_instance = this;
  }
  dx(it) {
    var tmp;
    switch (it) {
      case 0.0:
      case 1.0:
        tmp = it;
        break;
      default:
        var p = 0.3;
        var s = p / 4.0;
        // Inline function 'kotlin.math.pow' call

        var x = -10.0 * it;
        var tmp_0 = Math.pow(2.0, x);
        // Inline function 'kotlin.math.sin' call

        var x_0 = (it - s) * (2.0 * 3.141592653589793) / p;
        tmp = tmp_0 * Math.sin(x_0) + 1;
        break;
    }
    return tmp;
  }
}
class Easings$EASE_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_BOUNCE', 3);
    Easings_EASE_OUT_BOUNCE_instance = this;
  }
  dx(it) {
    var s = 7.5625;
    var p = 2.75;
    var tmp;
    if (it < 1.0 / p) {
      // Inline function 'kotlin.math.pow' call
      tmp = s * Math.pow(it, 2.0);
    } else if (it < 2.0 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = it - 1.5 / p;
      tmp = s * Math.pow(this_0, 2.0) + 0.75;
    } else if (it < 2.5 / p) {
      // Inline function 'kotlin.math.pow' call
      var this_1 = it - 2.25 / p;
      tmp = s * Math.pow(this_1, 2.0) + 0.9375;
    } else {
      // Inline function 'kotlin.math.pow' call
      var this_2 = it - 2.625 / p;
      tmp = s * Math.pow(this_2, 2.0) + 0.984375;
    }
    return tmp;
  }
}
class Easings$LINEAR extends Easings {
  constructor() {
    super('LINEAR', 4);
    Easings_LINEAR_instance = this;
  }
  dx(it) {
    return it;
  }
}
class Easings$EASE extends Easings {
  constructor() {
    super('EASE', 5);
    Easings_EASE_instance = this;
    this.e3s_1 = new EasingCubic(0.25, 0.1, 0.25, 1.0, 'ease');
  }
  dx(it) {
    return this.e3s_1.dx(it);
  }
}
class Easings$EASE_IN extends Easings {
  constructor() {
    super('EASE_IN', 6);
    Easings_EASE_IN_instance = this;
    this.n3s_1 = new EasingCubic(0.42, 0.0, 1.0, 1.0, 'ease-in');
  }
  dx(it) {
    return this.n3s_1.dx(it);
  }
}
class Easings$EASE_OUT extends Easings {
  constructor() {
    super('EASE_OUT', 7);
    Easings_EASE_OUT_instance = this;
    this.q3s_1 = new EasingCubic(0.0, 0.0, 0.58, 1.0, 'ease-out');
  }
  dx(it) {
    return this.q3s_1.dx(it);
  }
}
class Easings$EASE_IN_OUT extends Easings {
  constructor() {
    super('EASE_IN_OUT', 8);
    Easings_EASE_IN_OUT_instance = this;
    this.t3s_1 = new EasingCubic(0.42, 0.0, 0.58, 1.0, 'ease-in-out');
  }
  dx(it) {
    return this.t3s_1.dx(it);
  }
}
class Easings$EASE_IN_OLD extends Easings {
  constructor() {
    super('EASE_IN_OLD', 9);
    Easings_EASE_IN_OLD_instance = this;
  }
  dx(it) {
    return it * it * it;
  }
}
class Easings$EASE_OUT_OLD extends Easings {
  constructor() {
    super('EASE_OUT_OLD', 10);
    Easings_EASE_OUT_OLD_instance = this;
  }
  dx(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_OLD.invoke.<anonymous>' call
    var inv = it - 1.0;
    return inv * inv * inv + 1;
  }
}
class Easings$EASE_IN_OUT_OLD extends Easings {
  constructor() {
    super('EASE_IN_OUT_OLD', 11);
    Easings_EASE_IN_OUT_OLD_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_OLD_getInstance();
    var end = Easings_EASE_OUT_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_OLD extends Easings {
  constructor() {
    super('EASE_OUT_IN_OLD', 12);
    Easings_EASE_OUT_IN_OLD_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_OLD_getInstance();
    var end = Easings_EASE_IN_OLD_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BACK extends Easings {
  constructor() {
    super('EASE_IN_BACK', 13);
    Easings_EASE_IN_BACK_instance = this;
  }
  dx(it) {
    // Inline function 'kotlin.math.pow' call
    return Math.pow(it, 2.0) * ((1.70158 + 1.0) * it - 1.70158);
  }
}
class Easings$EASE_OUT_BACK extends Easings {
  constructor() {
    super('EASE_OUT_BACK', 14);
    Easings_EASE_OUT_BACK_instance = this;
  }
  dx(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_OUT_BACK.invoke.<anonymous>' call
    var inv = it - 1.0;
    // Inline function 'kotlin.math.pow' call
    return Math.pow(inv, 2.0) * ((1.70158 + 1.0) * inv + 1.70158) + 1.0;
  }
}
class Easings$EASE_IN_OUT_BACK extends Easings {
  constructor() {
    super('EASE_IN_OUT_BACK', 15);
    Easings_EASE_IN_OUT_BACK_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BACK_getInstance();
    var end = Easings_EASE_OUT_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BACK extends Easings {
  constructor() {
    super('EASE_OUT_IN_BACK', 16);
    Easings_EASE_OUT_IN_BACK_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BACK_getInstance();
    var end = Easings_EASE_IN_BACK_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_OUT_ELASTIC extends Easings {
  constructor() {
    super('EASE_IN_OUT_ELASTIC', 17);
    Easings_EASE_IN_OUT_ELASTIC_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_ELASTIC_getInstance();
    var end = Easings_EASE_OUT_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_ELASTIC extends Easings {
  constructor() {
    super('EASE_OUT_IN_ELASTIC', 18);
    Easings_EASE_OUT_IN_ELASTIC_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_ELASTIC_getInstance();
    var end = Easings_EASE_IN_ELASTIC_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_BOUNCE', 19);
    Easings_EASE_IN_BOUNCE_instance = this;
  }
  dx(it) {
    return 1.0 - Easings_EASE_OUT_BOUNCE_getInstance().dx(1.0 - it);
  }
}
class Easings$EASE_IN_OUT_BOUNCE extends Easings {
  constructor() {
    super('EASE_IN_OUT_BOUNCE', 20);
    Easings_EASE_IN_OUT_BOUNCE_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_IN_BOUNCE_getInstance();
    var end = Easings_EASE_OUT_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_OUT_IN_BOUNCE extends Easings {
  constructor() {
    super('EASE_OUT_IN_BOUNCE', 21);
    Easings_EASE_OUT_IN_BOUNCE_instance = this;
  }
  dx(it) {
    // Inline function 'korlibs.math.interpolation.Companion.combine' call
    Companion_getInstance_7();
    var start = Easings_EASE_OUT_BOUNCE_getInstance();
    var end = Easings_EASE_IN_BOUNCE_getInstance();
    return it < 0.5 ? 0.5 * start.dx(it * 2.0) : 0.5 * end.dx((it - 0.5) * 2.0) + 0.5;
  }
}
class Easings$EASE_IN_QUAD extends Easings {
  constructor() {
    super('EASE_IN_QUAD', 22);
    Easings_EASE_IN_QUAD_instance = this;
  }
  dx(it) {
    return 1.0 * it * it;
  }
}
class Easings$EASE_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_OUT_QUAD', 23);
    Easings_EASE_OUT_QUAD_instance = this;
  }
  dx(it) {
    return -1.0 * it * (it - 2);
  }
}
class Easings$EASE_IN_OUT_QUAD extends Easings {
  constructor() {
    super('EASE_IN_OUT_QUAD', 24);
    Easings_EASE_IN_OUT_QUAD_instance = this;
  }
  dx(it) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.interpolation.EASE_IN_OUT_QUAD.invoke.<anonymous>' call
    var t = it * 2.0;
    var tmp;
    if (t < 1) {
      tmp = +1.0 / 2 * t * t;
    } else {
      tmp = -1.0 / 2 * ((t - 1) * (t - 1 - 2) - 1);
    }
    return tmp;
  }
}
class Easings$EASE_SINE extends Easings {
  constructor() {
    super('EASE_SINE', 25);
    Easings_EASE_SINE_instance = this;
  }
  dx(it) {
    // Inline function 'kotlin.math.sin' call
    var x = it * 1.5707964;
    return Math.sin(x);
  }
}
class Easings$EASE_CLAMP_START extends Easings {
  constructor() {
    super('EASE_CLAMP_START', 26);
    Easings_EASE_CLAMP_START_instance = this;
  }
  dx(it) {
    return it <= 0.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_END extends Easings {
  constructor() {
    super('EASE_CLAMP_END', 27);
    Easings_EASE_CLAMP_END_instance = this;
  }
  dx(it) {
    return it < 1.0 ? 0.0 : 1.0;
  }
}
class Easings$EASE_CLAMP_MIDDLE extends Easings {
  constructor() {
    super('EASE_CLAMP_MIDDLE', 28);
    Easings_EASE_CLAMP_MIDDLE_instance = this;
  }
  dx(it) {
    return it < 0.5 ? 0.0 : 1.0;
  }
}
class P {
  static k3u(x, y) {
    var $this = createThis(this);
    $this.i3u_1 = x;
    $this.j3u_1 = y;
    return $this;
  }
  static l3u(x, y) {
    return this.k3u(x, y);
  }
  t2d(that) {
    return P.k3u(this.i3u_1 * that, this.j3u_1 * that);
  }
  m3u(that) {
    return P.k3u(this.i3u_1 + that.i3u_1, this.j3u_1 + that.j3u_1);
  }
  toString() {
    return 'P(x=' + this.i3u_1 + ', y=' + this.j3u_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.i3u_1);
    result = imul(result, 31) + getNumberHashCode(this.j3u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof P))
      return false;
    var tmp0_other_with_cast = other instanceof P ? other : THROW_CCE();
    if (!equals(this.i3u_1, tmp0_other_with_cast.i3u_1))
      return false;
    if (!equals(this.j3u_1, tmp0_other_with_cast.j3u_1))
      return false;
    return true;
  }
}
class EasingCubic {
  constructor(x1, y1, x2, y2, name) {
    name = name === VOID ? null : name;
    this.f3s_1 = x1;
    this.g3s_1 = y1;
    this.h3s_1 = x2;
    this.i3s_1 = y2;
    this.j3s_1 = name;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k3s_1 = [P.l3u(0.0, 0.0), P.l3u(clamp_1(this.f3s_1, 0.0, 1.0), this.g3s_1), P.l3u(clamp_1(this.h3s_1, 0.0, 1.0), this.i3s_1), P.l3u(1.0, 1.0)];
  }
  toString() {
    var tmp0_elvis_lhs = this.j3s_1;
    return tmp0_elvis_lhs == null ? 'cubic-bezier(' + this.f3s_1 + ', ' + this.g3s_1 + ', ' + this.h3s_1 + ', ' + this.i3s_1 + ')' : tmp0_elvis_lhs;
  }
  dx(it) {
    var pivotLeft = it < 0.0 ? it * 10.0 : 0.0;
    var pivotRight = it > 1.0 ? it * 10.0 : 1.0;
    var pivot = it;
    var lastX = 0.0;
    var lastY = 0.0;
    var steps = 0;
    var inductionVariable = 0;
    if (inductionVariable < 50)
      $l$loop_0: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        steps = steps + 1 | 0;
        var res = calc(this, pivot);
        lastX = res.i3u_1;
        lastY = res.j3u_1;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = lastX - it;
        if (Math.abs(this_0) < 0.001)
          break $l$loop_0;
        if (it < lastX) {
          pivotRight = pivot;
          pivot = (pivotLeft + pivot) * 0.5;
        } else if (it > lastX) {
          pivotLeft = pivot;
          pivot = (pivotRight + pivot) * 0.5;
        } else {
          break $l$loop_0;
        }
      }
       while (inductionVariable < 50);
    return lastY;
  }
}
//endregion
function insertAt($this, n, min, max) {
  $this.u37_1.d2k(n, min);
  $this.v37_1.d2k(n, max);
}
function removeAt($this, n, count) {
  $this.u37_1.f2k(n, count);
  $this.v37_1.f2k(n, count);
}
function toStrokePointsList(_this__u8e3s4, info, mode, generateDebug, forceClosed) {
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  return toStrokePointsList_0(_this__u8e3s4, info.d38_1, info.i38_1, info.g38_1, info.h38_1, info.j38_1, mode, info.k38_1, info.l38_1, generateDebug, forceClosed);
}
var StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
var StrokePointsMode_NON_SCALABLE_POS_instance;
var StrokePointsMode_entriesInitialized;
function StrokePointsMode_initEntries() {
  if (StrokePointsMode_entriesInitialized)
    return Unit_instance;
  StrokePointsMode_entriesInitialized = true;
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance = new StrokePointsMode('SCALABLE_POS_NORMAL_WIDTH', 0);
  StrokePointsMode_NON_SCALABLE_POS_instance = new StrokePointsMode('NON_SCALABLE_POS', 1);
}
function toStrokePointsList_0(_this__u8e3s4, width, join, startCap, endCap, miterLimit, mode, lineDash, lineDashOffset, generateDebug, forceClosed) {
  join = join === VOID ? LineJoin_MITER_getInstance() : join;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? LineCap_BUTT_getInstance() : endCap;
  miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
  mode = mode === VOID ? StrokePointsMode_NON_SCALABLE_POS_getInstance() : mode;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  generateDebug = generateDebug === VOID ? false : generateDebug;
  forceClosed = forceClosed === VOID ? null : forceClosed;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList.h1();
    var tmp0_iterator = _this__u8e3s4.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
      var list = toDashes(element, lineDash.rx(), lineDashOffset);
      addAll(destination, list);
    }
    tmp = destination;
  } else {
    tmp = _this__u8e3s4;
  }
  var curvesList = tmp;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator_0 = curvesList.a1();
  while (tmp0_iterator_0.b1()) {
    var item = tmp0_iterator_0.c1();
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_0 = new StrokePointsBuilder(width / 2.0, mode, generateDebug);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.bezier.toStrokePointsList.<anonymous>.<anonymous>' call
    this_0.t38(item, join, startCap, endCap, miterLimit, forceClosed);
    destination_0.h(this_0);
  }
  return destination_0;
}
function StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_instance;
}
function StrokePointsMode_NON_SCALABLE_POS_getInstance() {
  StrokePointsMode_initEntries();
  return StrokePointsMode_NON_SCALABLE_POS_instance;
}
function get_isConvex(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = isConvex$delegate;
    var property = isConvex$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var isConvex$delegate;
function Curves$contiguous$delegate$lambda(this$0) {
  return function () {
    var inductionVariable = 1;
    var last = this$0.o39_1.e1();
    var tmp;
    if (inductionVariable < last) {
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var curr = this$0.o39_1.d1(n - 1 | 0);
        var next = this$0.o39_1.d1(n);
        if (!curr.u39_1.s2l().bx(next.u39_1.r2l()))
          return false;
      }
       while (inductionVariable < last);
      tmp = Unit_instance;
    }
    return true;
  };
}
function Curves$infos$delegate$lambda(this$0) {
  return function () {
    var pos = 0.0;
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.o39_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.bezier.Curves.infos$delegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var start = pos;
      pos = pos + item.a();
      var tmp$ret$0 = new CurveInfo(index_0, item, start, pos, item.l3a());
      destination.h(tmp$ret$0);
    }
    return destination;
  };
}
function Curves$length$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var _iterator__ex2g4s = this$0.m3a().a1();
    while (_iterator__ex2g4s.b1()) {
      var element = _iterator__ex2g4s.c1();
      var tmp = sum;
      // Inline function 'korlibs.math.geom.bezier.Curves.length$delegate.<anonymous>.<anonymous>' call
      sum = tmp + element.a();
    }
    return sum;
  };
}
function Curves$findInfo$lambda($pos) {
  return function (it) {
    return it.w2k($pos) ? 0 : it.j3a_1 < $pos ? -1 : 1;
  };
}
function Curves$ratioFromLength$lambda($length) {
  return function (it) {
    return it.j3a_1 < $length ? -1 : it.i3a_1 > $length ? 1 : 0;
  };
}
function Bezier$Extrema$allt$delegate$lambda(this$0) {
  return function () {
    return combineSmallDistinctSorted(Companion_getInstance_8(), this$0.z3a_1, this$0.a3b_1);
  };
}
function Bezier$Extrema$xt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.z3a_1, new Float64Array([1.0])]);
  };
}
function Bezier$Extrema$yt01$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.doubleArrayOf' call
    return primitiveArrayConcat([new Float64Array([0.0]), this$0.a3b_1, new Float64Array([1.0])]);
  };
}
function map($this, v, ds, de, ts, te) {
  return convertRange(v, ds, de, ts, te);
}
function angle($this, o, v1, v2) {
  var dx1 = v1.e25_1 - o.e25_1;
  var dy1 = v1.f25_1 - o.f25_1;
  var dx2 = v2.e25_1 - o.e25_1;
  var dy2 = v2.f25_1 - o.f25_1;
  var cross = dx1 * dy2 - dy1 * dx2;
  var dot = dx1 * dx2 + dy1 * dy2;
  // Inline function 'kotlin.math.atan2' call
  return Math.atan2(cross, dot);
}
function compute($this, t, points) {
  var p = points;
  var order = p.e1() - 1 | 0;
  if (equals(t, Companion_getInstance_6().kx_1))
    return p.d1(0);
  if (equals(t, Companion_getInstance_6().nx_1))
    return p.d1(order);
  if (order === 0)
    return p.d1(0);
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().nx_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var tmp;
  switch (order) {
    case 1:
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_0 = p.d1(0);
      var this_1 = Vector2D.n27(this_0.e25_1 * mt, this_0.f25_1 * mt);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_2 = p.d1(1);
      var scale = Ratio__toDouble_impl_o7epze(t);
      var that = Vector2D.n27(this_2.e25_1 * scale, this_2.f25_1 * scale);
      tmp = Vector2D.n27(this_1.e25_1 + that.e25_1, this_1.f25_1 + that.f25_1);
      break;
    case 2:
      var a = mt2;
      // Inline function 'korlibs.math.interpolation.times' call

      var b = mt * _Ratio___get_value__impl__57cli6(t) * 2;
      var c = t2;
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_3 = p.d1(0);
      var this_4 = Vector2D.n27(this_3.e25_1 * a, this_3.f25_1 * a);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_5 = p.d1(1);
      var that_0 = Vector2D.n27(this_5.e25_1 * b, this_5.f25_1 * b);
      var this_6 = Vector2D.n27(this_4.e25_1 + that_0.e25_1, this_4.f25_1 + that_0.f25_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_7 = p.d1(2);
      var that_1 = Vector2D.n27(this_7.e25_1 * c, this_7.f25_1 * c);
      tmp = Vector2D.n27(this_6.e25_1 + that_1.e25_1, this_6.f25_1 + that_1.f25_1);
      break;
    case 3:
      var a_0 = mt2 * mt;
      // Inline function 'korlibs.math.interpolation.times' call

      var b_0 = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
      var c_0 = mt * t2 * 3;
      var d = Ratio__times_impl_ucdh7y(t, t2);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.plus' call

      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_8 = p.d1(0);
      var this_9 = Vector2D.n27(this_8.e25_1 * a_0, this_8.f25_1 * a_0);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_10 = p.d1(1);
      var that_2 = Vector2D.n27(this_10.e25_1 * b_0, this_10.f25_1 * b_0);
      var this_11 = Vector2D.n27(this_9.e25_1 + that_2.e25_1, this_9.f25_1 + that_2.f25_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_12 = p.d1(2);
      var that_3 = Vector2D.n27(this_12.e25_1 * c_0, this_12.f25_1 * c_0);
      var this_13 = Vector2D.n27(this_11.e25_1 + that_3.e25_1, this_11.f25_1 + that_3.f25_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call

      var this_14 = p.d1(3);
      var that_4 = Vector2D.n27(this_14.e25_1 * d, this_14.f25_1 * d);
      tmp = Vector2D.n27(this_13.e25_1 + that_4.e25_1, this_13.f25_1 + that_4.f25_1);
      break;
    default:
      var reason = 'higher order curves';
      throw NotImplementedError.od('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function derive($this, points) {
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.h1();
  var current = points;
  while (current.e1() >= 2) {
    var new_0 = new PointArrayList(current.e1() - 1 | 0);
    var c = current.e1() - 1 | 0;
    var inductionVariable = 0;
    var last = current.e1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.Vector2D.times' call
        // Inline function 'korlibs.math.geom.Vector2D.minus' call
        var this_0 = current.d1(n + 1 | 0);
        var that = current.d1(n);
        var this_1 = Vector2D.n27(this_0.e25_1 - that.e25_1, this_0.f25_1 - that.f25_1);
        var tmp$ret$2 = Vector2D.n27(this_1.e25_1 * c, this_1.f25_1 * c);
        new_0.i2r(tmp$ret$2);
      }
       while (inductionVariable < last);
    out.h(new_0);
    current = new_0;
  }
  return out;
}
function align($this, points, line, out) {
  var p1 = line.u27_1;
  var p2 = line.v27_1;
  var tx = p1.e25_1;
  var ty = p1.f25_1;
  // Inline function 'kotlin.math.atan2' call
  var y = p2.f25_1 - ty;
  var x = p2.e25_1 - tx;
  var a = -Math.atan2(y, x);
  // Inline function 'korlibs.math.geom.fastForEach' call
  var inductionVariable = 0;
  var last = points.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.Companion.align.<anonymous>' call
      var destruct = points.d1(n);
      var x_0 = destruct.fl();
      var y_0 = destruct.gl();
      var tmp = x_0 - tx;
      // Inline function 'kotlin.math.cos' call
      var tmp_0 = tmp * Math.cos(a);
      var tmp_1 = y_0 - ty;
      // Inline function 'kotlin.math.sin' call
      var tmp_2 = tmp_0 - tmp_1 * Math.sin(a);
      var tmp_3 = x_0 - tx;
      // Inline function 'kotlin.math.sin' call
      var tmp_4 = tmp_3 * Math.sin(a);
      var tmp_5 = y_0 - ty;
      // Inline function 'kotlin.math.cos' call
      var tmp$ret$4 = Math.cos(a);
      out.h2r(tmp_2, tmp_4 + tmp_5 * tmp$ret$4);
    }
     while (inductionVariable < last);
  return out;
}
function align$default($this, points, line, out, $super) {
  out = out === VOID ? new PointArrayList() : out;
  return align($this, points, line, out);
}
function droots($this, p) {
  switch (p.length) {
    case 3:
      var a = p[0];
      var b = p[1];
      var c = p[2];
      var d = a - 2 * b + c;
      if (!(d === 0.0)) {
        // Inline function 'kotlin.math.sqrt' call
        var x = b * b - a * c;
        var m1 = -Math.sqrt(x);
        var m2 = -a + b;
        var v1 = -(m1 + m2) / d;
        var v2 = -(-m1 + m2) / d;
        return doubleArrayOfValid01$default($this, v1, v2);
      } else if (!(b === c) && d === 0.0) {
        return doubleArrayOfValid01$default($this, (2.0 * b - c) / (2.0 * (b - c)));
      }

      break;
    case 2:
      var a_0 = p[0];
      var b_0 = p[1];
      if (!(a_0 === b_0))
        return doubleArrayOfValid01$default($this, a_0 / (a_0 - b_0));
      break;
    default:
      break;
  }
  return doubleArrayOfValid01$default($this);
}
function doubleArrayOfValid01($this, v1, v2, v3) {
  var v1Valid = 0.0 <= v1 ? v1 <= 1.0 : false;
  var v2Valid = 0.0 <= v2 ? v2 <= 1.0 : false;
  var v3Valid = 0.0 <= v3 ? v3 <= 1.0 : false;
  var validCount = 0;
  if (v1Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v2Valid) {
    validCount = validCount + 1 | 0;
  }
  if (v3Valid) {
    validCount = validCount + 1 | 0;
  }
  if (validCount === 0)
    return $this.i3b_1;
  var index = 0;
  var out = new Float64Array(validCount);
  if (v1Valid) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    out[_unary__edvuaz] = normalizeZero(v1);
  }
  if (v2Valid) {
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    out[_unary__edvuaz_0] = normalizeZero(v2);
  }
  if (v3Valid) {
    var _unary__edvuaz_1 = index;
    index = _unary__edvuaz_1 + 1 | 0;
    out[_unary__edvuaz_1] = normalizeZero(v3);
  }
  return out;
}
function doubleArrayOfValid01$default($this, v1, v2, v3, $super) {
  v1 = v1 === VOID ? NaN : v1;
  v2 = v2 === VOID ? NaN : v2;
  v3 = v3 === VOID ? NaN : v3;
  return doubleArrayOfValid01($this, v1, v2, v3);
}
function combineSmallDistinctSorted($this, a, b) {
  var out = DoubleArrayList.j2k(a.length + b.length | 0);
  out.n2k(a);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < b.length) {
    // Inline function 'korlibs.math.geom.bezier.Companion.combineSmallDistinctSorted.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = b[_unary__edvuaz];
    if (!out.w2k(it)) {
      out.nz(it);
    }
  }
  sort(out);
  return out.rx();
}
function _get_aligned__7fjidv($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.v39_1;
  aligned$factory();
  return this_0.r1();
}
function _getBoundingBox($this, m) {
  var xmin = 0.0;
  var ymin = 0.0;
  var xmax = 0.0;
  var ymax = 0.0;
  var inductionVariable = 0;
  if (inductionVariable <= 1)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ext = $this.j3b().k3b(n);
      var min = Infinity;
      var max = -Infinity;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < ext.length) {
        // Inline function 'korlibs.math.geom.bezier.Bezier._getBoundingBox.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        var t = ext[_unary__edvuaz];
        var p = $this.l3b(_Ratio___init__impl__9mwvn2(t));
        var value = n === 0 ? transformX(p, m) : transformY(p, m);
        // Inline function 'kotlin.math.min' call
        var a = min;
        min = Math.min(a, value);
        // Inline function 'kotlin.math.max' call
        var a_0 = max;
        max = Math.max(a_0, value);
      }
      if (n === 0) {
        xmin = min;
        xmax = max;
      } else {
        ymin = min;
        ymax = max;
      }
    }
     while (inductionVariable <= 1);
  return Companion_getInstance_1().x2d(xmin, ymin, xmax, ymax);
}
function findNearestLine($this, pX, pY, aX, aY, bX, bY, out) {
  out.p3b_1 = $this;
  var atobX = bX - aX;
  var atobY = bY - aY;
  var atopX = pX - aX;
  var atopY = pY - aY;
  var len = atobX * atobX + atobY * atobY;
  var dot = atopX * atobX + atopY * atobY;
  // Inline function 'kotlin.math.min' call
  // Inline function 'kotlin.math.max' call
  var b = dot / len;
  var b_0 = Math.max(0.0, b);
  var tmp$ret$1 = Math.min(1.0, b_0);
  var t = toRatio_0(tmp$ret$1);
  var tmp = out;
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp_0 = aX + atobX * _Ratio___get_value__impl__57cli6(t);
  // Inline function 'korlibs.math.interpolation.times' call
  var tmp$ret$3 = atobY * _Ratio___get_value__impl__57cli6(t);
  tmp.m3b_1 = Vector2D.n27(tmp_0, aY + tmp$ret$3);
  out.n3b_1 = t;
  out.o3b_1 = Companion_getInstance().r2g(out.m3b_1.e25_1, out.m3b_1.f25_1, pX, pY);
  return out;
}
var Companion_instance;
function Companion_getInstance_8() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function Bezier$aligned$delegate$lambda(this$0) {
  return function () {
    return align$default(Companion_getInstance_8(), this$0.u39_1, Line2D.w27(this$0.u39_1.r2l(), this$0.u39_1.s2l()));
  };
}
function Bezier$dpoints$delegate$lambda(this$0) {
  return function () {
    return derive(Companion_getInstance_8(), this$0.u39_1);
  };
}
function Bezier$direction$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var p0 = this$0.u39_1.d1(0);
    var p1 = this$0.u39_1.d1(this$0.f3a());
    var up = this$0.u39_1.d1(1);
    // Inline function 'korlibs.math.geom.Companion.between' call
    var x0 = p0.e25_1;
    var y0 = p0.f25_1;
    var x1 = p1.e25_1;
    var y1 = p1.f25_1;
    var tmp$ret$1 = Angle_between(x0, y0, x1, y1, up);
    return new Angle(tmp$ret$1);
  };
}
function Bezier$extrema$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.x3b());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.a2_1;
    var last = this_0.b2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>' call
        var dim = item;
        var tmp = Companion_getInstance_8();
        // Inline function 'korlibs.datastructure.mapDouble' call
        var this_1 = this$0.y3b().d1(0).a2r(dim);
        // Inline function 'kotlin.also' call
        var this_2 = new Float64Array(this_1.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
        var inductionVariable_0 = 0;
        var last_0 = this_1.length;
        if (inductionVariable_0 < last_0)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.math.geom.bezier.Bezier.extrema$delegate.<anonymous>.<anonymous>.<anonymous>' call
            this_2[n] = this_1[n];
          }
           while (inductionVariable_0 < last_0);
        var out = droots(tmp, this_2);
        if (this$0.f3a() === 3)
          out = combineSmallDistinctSorted(Companion_getInstance_8(), out, droots(Companion_getInstance_8(), this$0.y3b().d1(1).a2r(dim)));
        var tmp$ret$3 = out;
        destination.h(tmp$ret$3);
      }
       while (!(item === last));
    var out_0 = destination;
    return new Extrema(out_0.d1(0), out_0.d1(1));
  };
}
function Bezier$outerCircle$delegate$lambda(this$0) {
  return function () {
    return outerCircle(this$0.z3b());
  };
}
function Bezier$boundingBox$delegate$lambda(this$0) {
  return function () {
    return _getBoundingBox(this$0, Companion_getInstance_2().y28_1);
  };
}
function Bezier$length$delegate$lambda(this$0) {
  return function () {
    var z = 0.5;
    var sum = 0.0;
    var inductionVariable = 0;
    var last = Companion_getInstance_8().e3b_1.length - 1 | 0;
    var tmp;
    if (inductionVariable <= last) {
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = _Ratio___init__impl__9mwvn2(z * Companion_getInstance_8().e3b_1[i] + z);
        var temp = this$0.a3c(t);
        sum = sum + Companion_getInstance_8().f3b_1[i] * temp.a();
      }
       while (inductionVariable <= last);
      tmp = Unit_instance;
    }
    return z * sum;
  };
}
function Bezier$lut$delegate$lambda(this$0) {
  return function () {
    return this$0.b3c();
  };
}
function Bezier$isLinear$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var this_0 = this$0.u39_1.d1(this$0.f3a());
    var that = this$0.u39_1.d1(0);
    var baseLength = Vector2D.n27(this_0.e25_1 - that.e25_1, this_0.f25_1 - that.f25_1).a();
    // Inline function 'korlibs.datastructure.sumOfDouble' call
    var sum = 0.0;
    var progression = until(0, _get_aligned__7fjidv(this$0).e1());
    var inductionVariable = progression.a2_1;
    var last = progression.b2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = sum;
        // Inline function 'korlibs.math.geom.bezier.Bezier.isLinear$delegate.<anonymous>.<anonymous>' call
        var it = element;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = _get_aligned__7fjidv(this$0).l27(it);
        sum = tmp + Math.abs(this_1);
      }
       while (!(element === last));
    return sum < baseLength / 50.0;
  };
}
function Bezier$isSimple$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.f3a() === 3) {
      var a1 = angle(Companion_getInstance_8(), this$0.u39_1.d1(0), this$0.u39_1.d1(3), this$0.u39_1.d1(1));
      var a2 = angle(Companion_getInstance_8(), this$0.u39_1.d1(0), this$0.u39_1.d1(3), this$0.u39_1.d1(2));
      var tmp_0;
      if (a1 > 0.0 && a2 < 0.0 || (a1 < 0.0 && a2 > 0.0)) {
        return false;
      }
      tmp = tmp_0;
    }
    var n1 = this$0.d39(Companion_getInstance_6().kx_1);
    var n2 = this$0.d39(Companion_getInstance_6().nx_1);
    var s = n1.e25_1 * n2.e25_1 + n1.f25_1 * n2.f25_1;
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.acos' call
    var x = Math.acos(s);
    return Math.abs(x) < 3.141592653589793 / 3.0;
  };
}
function BezierCurveFromIndices($this, indices, points) {
  var p = new PointArrayList(indices.length);
  var inductionVariable = 0;
  var last = indices.length;
  while (inductionVariable < last) {
    var index = indices[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    p.l2r(points, index);
  }
  return Bezier.h3c(p);
}
var Companion_instance_0;
function Companion_getInstance_9() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function _split($this, t, hull, left) {
  var rt = convertRange(t, Companion_getInstance_6().kx_1, Companion_getInstance_6().nx_1, $this.u3a_1, $this.v3a_1);
  var rt1 = left ? $this.u3a_1 : rt;
  var rt2 = left ? rt : $this.v3a_1;
  var tmp;
  if ($this.t3a_1.f3a() < 2) {
    var p1 = $this.b39(rt1);
    var p2 = $this.b39(rt2);
    tmp = Bezier.e3c(p1, p2);
  } else {
    var indices = left ? Companion_getInstance_9().l3d_1 : Companion_getInstance_9().m3d_1;
    tmp = BezierCurveFromIndices(Companion_getInstance_9(), ensureNotNull(indices.d1($this.t3a_1.f3a())), ensureNotNull(hull));
  }
  var curve = tmp;
  return SubBezier.i3d(curve, rt1, rt2, $this.w3a_1);
}
function _splitLeft($this, t, hull) {
  return _split($this, t, hull, true);
}
function _splitLeft$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.t3a_1.h3d(t) : hull;
  return _splitLeft($this, t, hull);
}
function _splitRight($this, t, hull) {
  return _split($this, t, hull, false);
}
function _splitRight$default($this, t, hull, $super) {
  hull = hull === VOID ? $this.t3a_1.h3d(t) : hull;
  return _splitRight($this, t, hull);
}
function estimateAt($this, values, value, out) {
  var result = binarySearch_0(values, value);
  if (_BSearchResult___get_found__impl__om04iz(result))
    return $this.n3d(out, _BSearchResult___get_index__impl__b5kraz(result), 0.0);
  var index = _BSearchResult___get_nearIndex__impl__s8nq43(result);
  if (value <= 0.0)
    return $this.n3d(out, 0, 0.0);
  if (index >= (values.e1() - 1 | 0))
    return $this.n3d(out, $this.r3c_1.e1() - 1 | 0, 0.0);
  var ratio0 = values.d1(index);
  var ratio1 = values.d1(index + 1 | 0);
  var ratio = convertRange_0(value, ratio0, ratio1, 0.0, 1.0);
  return $this.n3d(out, index, ratio);
}
function CurveLUT$toString$lambda(this$0) {
  return function (it) {
    return '' + this$0.s3c_1.d1(it) + ',len=' + this$0.o3d().d1(it) + ': ' + this$0.r3c_1.d1(it).toString();
  };
}
function toCurves(_this__u8e3s4, closed) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return new Curves(_this__u8e3s4, closed);
}
function toNonCurveSimplePointList(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var curves = _this__u8e3s4;
  var beziers = curves.o39_1;
  var epsilon = 1.0E-5;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < beziers.e1()) {
    // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var bezier = beziers.d1(_unary__edvuaz);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(bezier.d3d().length === 0))
      return null;
    var points = bezier.u39_1;
    // Inline function 'korlibs.math.geom.fastForEach' call
    var inductionVariable = 0;
    var last = points.e1();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.math.geom.bezier.toNonCurveSimplePointList.<anonymous>.<anonymous>' call
        var p = points.d1(n_0);
        if (out.g1() || !out.s2l().a2h(p, epsilon)) {
          out.i2r(p);
        }
      }
       while (inductionVariable < last);
  }
  if (out.s2l().a2h(out.r2l(), epsilon)) {
    out.m2r(out.e1() - 1 | 0);
  }
  return out;
}
var Arc_instance;
function Arc_getInstance() {
  return Arc_instance;
}
function toVectorPath(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  var first = {_v: true};
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.e1()) {
    // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var curves = _this__u8e3s4.d1(_unary__edvuaz);
    if (curves instanceof Curves) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = curves.o39_1;
      var n_0 = 0;
      while (n_0 < this_0.e1()) {
        // Inline function 'korlibs.math.geom.bezier.toVectorPath.<anonymous>.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_0.d1(_unary__edvuaz_0);
        toVectorPath$bezier(first, out, it);
      }
      if (curves.p39_1) {
        out.c6();
      }
    } else {
      if (curves instanceof Bezier) {
        toVectorPath$bezier(first, out, curves);
      } else {
        throw NotImplementedError.od();
      }
    }
  }
  return out;
}
function toVectorPath_0(_this__u8e3s4, out) {
  out = out === VOID ? new VectorPath() : out;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return toVectorPath(listOf(_this__u8e3s4), out);
}
function toBezier(_this__u8e3s4) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return Bezier.e3c(Vector2D.n27(_this__u8e3s4.b28(), _this__u8e3s4.c28()), Vector2D.n27(_this__u8e3s4.d28(), _this__u8e3s4.e28()));
}
function toDashes(_this__u8e3s4, pattern, offset) {
  offset = offset === VOID ? 0.0 : offset;
  _init_properties__MathGeom_bezier_kt__br5r2i();
  if (pattern == null)
    return listOf(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.all' call
    var inductionVariable = 0;
    var last = pattern.length;
    while (inductionVariable < last) {
      var element = pattern[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.bezier.toDashes.<anonymous>' call
      if (!(element <= 0.0)) {
        tmp$ret$1 = false;
        break $l$block;
      }
    }
    tmp$ret$1 = true;
  }
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.check' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!tmp$ret$1) {
    // Inline function 'kotlin.check.<anonymous>' call
    var message = 'Check failed.';
    throw IllegalStateException.w4(toString(message));
  }
  var length = _this__u8e3s4.a();
  var current = offset;
  var dashNow = true;
  var index = 0;
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.h1();
  while (current < length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var len = getCyclic_0(pattern, _unary__edvuaz);
    if (dashNow) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_0 = _this__u8e3s4.r3a(current, current + len);
      out.h(element_0);
    }
    current = current + len;
    dashNow = !dashNow;
  }
  return out;
}
function toVectorPath$bezier(first, $out, bezier) {
  var points = bezier.u39_1;
  if (first._v) {
    $out.u3d(points.r2l());
    first._v = false;
  }
  switch (bezier.f3a()) {
    case 1:
      $out.h3e(points.d1(1));
      break;
    case 2:
      $out.i3e(points.d1(1), points.d1(2));
      break;
    case 3:
      $out.v3d(points.d1(1), points.d1(2), points.d1(3));
      break;
    default:
      // Inline function 'kotlin.TODO' call

      throw NotImplementedError.od();
  }
}
function isConvex$delegate$lambda($this$extraPropertyThis) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return $this$extraPropertyThis.q39_1 || Convex_instance.j3e($this$extraPropertyThis);
}
function isConvex$delegate$lambda_0(_this__u8e3s4, it) {
  _init_properties__MathGeom_bezier_kt__br5r2i();
  return it;
}
function isConvex$factory() {
  return getPropertyCallableRef('isConvex', 1, KProperty1, function (receiver) {
    return get_isConvex(receiver);
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.m3a();
  }, null);
}
function length$factory() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function aligned$factory() {
  return getPropertyCallableRef('aligned', 1, KProperty1, function (receiver) {
    return _get_aligned__7fjidv(receiver);
  }, null);
}
function dpoints$factory() {
  return getPropertyCallableRef('dpoints', 1, KProperty1, function (receiver) {
    return receiver.y3b();
  }, null);
}
function extrema$factory() {
  return getPropertyCallableRef('extrema', 1, KProperty1, function (receiver) {
    return receiver.j3b();
  }, null);
}
function outerCircle$factory() {
  return getPropertyCallableRef('outerCircle', 1, KProperty1, function (receiver) {
    return receiver.l3c();
  }, null);
}
function boundingBox$factory() {
  return getPropertyCallableRef('boundingBox', 1, KProperty1, function (receiver) {
    return receiver.z3b();
  }, null);
}
function length$factory_0() {
  return getPropertyCallableRef('length', 1, KProperty1, function (receiver) {
    return receiver.a();
  }, null);
}
function lut$factory() {
  return getPropertyCallableRef('lut', 1, KProperty1, function (receiver) {
    return receiver.m3c();
  }, null);
}
function xt01$factory() {
  return getPropertyCallableRef('xt01', 1, KProperty1, function (receiver) {
    return receiver.r3b();
  }, null);
}
function yt01$factory() {
  return getPropertyCallableRef('yt01', 1, KProperty1, function (receiver) {
    return receiver.s3b();
  }, null);
}
var properties_initialized__MathGeom_bezier_kt_sxrpnw;
function _init_properties__MathGeom_bezier_kt__br5r2i() {
  if (!properties_initialized__MathGeom_bezier_kt_sxrpnw) {
    properties_initialized__MathGeom_bezier_kt_sxrpnw = true;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = isConvex$delegate$lambda;
    var transform = isConvex$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.by_1 = transform;
    isConvex$delegate = this_0;
  }
}
var Companion_instance_1;
function Companion_getInstance_10() {
  return Companion_instance_1;
}
function quickFindPositionForNewNodeBestAreaFit($this, width, height) {
  var score = 1.7976931348623157E308;
  var areaFit;
  var bestNode = Companion_getInstance_1().a29();
  var _iterator__ex2g4s = $this.n3e_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var r = _iterator__ex2g4s.c1();
    if (r.q25_1 >= width && r.r25_1 >= height) {
      areaFit = r.q25_1 * r.r25_1 - width * height;
      if (areaFit < score) {
        bestNode = new Rectangle(r.o25_1, r.p25_1, width, height);
        score = areaFit;
      }
    }
  }
  return bestNode;
}
function splitFreeNode($this, freeNode, usedNode) {
  var newNode;
  if (usedNode.v25() >= freeNode.w25() || usedNode.w25() <= freeNode.o25_1 || usedNode.x25() >= freeNode.y25() || usedNode.y25() <= freeNode.x25()) {
    return false;
  }
  if (usedNode.o25_1 < freeNode.w25() && usedNode.w25() > freeNode.o25_1) {
    if (usedNode.p25_1 > freeNode.p25_1 && usedNode.p25_1 < freeNode.y25()) {
      newNode = freeNode.w2e(VOID, VOID, VOID, usedNode.p25_1 - freeNode.p25_1);
      $this.n3e_1.h(newNode);
    }
    if (usedNode.y25() < freeNode.y25()) {
      newNode = freeNode.w2e(VOID, usedNode.y25(), VOID, freeNode.y25() - usedNode.y25());
      $this.n3e_1.h(newNode);
    }
  }
  if (usedNode.p25_1 < freeNode.y25() && usedNode.y25() > freeNode.p25_1) {
    if (usedNode.o25_1 > freeNode.o25_1 && usedNode.o25_1 < freeNode.w25()) {
      newNode = freeNode.w2e(VOID, VOID, usedNode.o25_1 - freeNode.o25_1);
      $this.n3e_1.h(newNode);
    }
    if (usedNode.w25() < freeNode.w25()) {
      newNode = freeNode.w2e(usedNode.w25(), VOID, freeNode.w25() - usedNode.w25());
      $this.n3e_1.h(newNode);
    }
  }
  return true;
}
function pruneFreeList($this) {
  var len = $this.n3e_1.e1();
  var i = 0;
  while (i < len) {
    var j = i + 1 | 0;
    var tmpRect = $this.n3e_1.d1(i);
    $l$loop: while (j < len) {
      var tmpRect2 = $this.n3e_1.d1(j);
      if (Companion_getInstance_1().z2d(tmpRect, tmpRect2)) {
        $this.n3e_1.l3(i);
        i = i - 1 | 0;
        len = len - 1 | 0;
        break $l$loop;
      }
      if (Companion_getInstance_1().z2d(tmpRect2, tmpRect)) {
        $this.n3e_1.l3(j);
        len = len - 1 | 0;
        j = j - 1 | 0;
      }
      j = j + 1 | 0;
    }
    i = i + 1 | 0;
  }
}
var HitTestDirection_ANY_instance;
var HitTestDirection_UP_instance;
var HitTestDirection_RIGHT_instance;
var HitTestDirection_DOWN_instance;
var HitTestDirection_LEFT_instance;
var Companion_instance_2;
function Companion_getInstance_11() {
  return Companion_instance_2;
}
var HitTestDirection_entriesInitialized;
function HitTestDirection_initEntries() {
  if (HitTestDirection_entriesInitialized)
    return Unit_instance;
  HitTestDirection_entriesInitialized = true;
  HitTestDirection_ANY_instance = new HitTestDirection('ANY', 0);
  HitTestDirection_UP_instance = new HitTestDirection('UP', 1);
  HitTestDirection_RIGHT_instance = new HitTestDirection('RIGHT', 2);
  HitTestDirection_DOWN_instance = new HitTestDirection('DOWN', 3);
  HitTestDirection_LEFT_instance = new HitTestDirection('LEFT', 4);
}
function HitTestDirection_ANY_getInstance() {
  HitTestDirection_initEntries();
  return HitTestDirection_ANY_instance;
}
var Convex_instance;
function Convex_getInstance() {
  return Convex_instance;
}
function get_cachedPoints(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = cachedPoints$delegate;
    var property = cachedPoints$factory();
    var tmp0_elvis_lhs = this_0.zx_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.ay_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.zx_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cachedPoints$delegate;
function getPoints2(_this__u8e3s4, out) {
  out = out === VOID ? new PointArrayList() : out;
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.y27();
  var l = Vector2D.y27();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.x3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.n27(tmp, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.i2r(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.n27(tmp_0, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        out.i2r(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.n27(tmp_1, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.n27(tmp_2, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_7));
        var sum = Companion_getInstance().q2g(l, c) + Companion_getInstance().q2g(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.y27()};
        var prevPos = {_v: Vector2D.y27()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().kx_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().u3b(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().u3b(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.i2r(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.n27(tmp_3, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.n27(tmp_4, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.n27(tmp_5, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().q2g(l, c0) + Companion_getInstance().q2g(c0, c1) + Companion_getInstance().q2g(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.y27()};
        var prevPos_0 = {_v: Vector2D.y27()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().kx_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call
            out.i2r(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2.<anonymous>' call

        var p = i;
        out.i2r(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  return out;
}
function getPoints2List(_this__u8e3s4) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  // Inline function 'kotlin.collections.arrayListOf' call
  var out = ArrayList.h1();
  var current = {_v: new PointArrayList()};
  // Inline function 'korlibs.math.geom.shape.emitPoints2' call
  var i = Vector2D.y27();
  var l = Vector2D.y27();
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.x3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.n27(tmp, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_1));
        i = it;
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (true) {
          getPoints2List$flush(current, out);
        }

        current._v.i2r(it);
        l = it;
        break;
      case 1:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.n27(tmp_0, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.i2r(it_0);
        l = it_0;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 2:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.n27(tmp_1, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.n27(tmp_2, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_7));
        var sum = Companion_getInstance().q2g(l, c) + Companion_getInstance().q2g(c, a);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_0 = numberToInt(sum);
        var rcurveSteps = Math.max(a_0, 20);
        var dt = 1.0 / rcurveSteps;
        var lastPos = {_v: Vector2D.y27()};
        var prevPos = {_v: Vector2D.y27()};
        var emittedCount = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio = Companion_getInstance_6().kx_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos._v = Companion_getInstance_8().u3b(l, c, a, ratio);
        var nStart = false ? 0 : 1;
        var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
        var inductionVariable = nStart;
        if (inductionVariable <= nEnd)
          do {
            var n_1 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_1 = Companion_getInstance_8().u3b(l, c, a, ratio_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.i2r(it_1);
            emittedCount._v = emittedCount._v + 1 | 0;
            lastPos._v = prevPos._v;
            prevPos._v = it_1;
          }
           while (!(n_1 === nEnd));
        l = a;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 3:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c0 = Vector2D.n27(tmp_3, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c1 = Vector2D.n27(tmp_4, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_1 = Vector2D.n27(tmp_5, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_13));
        var sum_0 = Companion_getInstance().q2g(l, c0) + Companion_getInstance().q2g(c0, c1) + Companion_getInstance().q2g(c1, a_1);
        // Inline function 'korlibs.math.geom.shape.approximateCurve' call

        // Inline function 'kotlin.math.max' call

        var a_2 = numberToInt(sum_0);
        var rcurveSteps_0 = Math.max(a_2, 20);
        var dt_0 = 1.0 / rcurveSteps_0;
        var lastPos_0 = {_v: Vector2D.y27()};
        var prevPos_0 = {_v: Vector2D.y27()};
        var emittedCount_0 = {_v: 0};
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

        var ratio_1 = Companion_getInstance_6().kx_1;
        // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

        lastPos_0._v = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_1);
        var nStart_0 = false ? 0 : 1;
        var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
        var inductionVariable_0 = nStart_0;
        if (inductionVariable_0 <= nEnd_0)
          do {
            var n_2 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
            var it_2 = Companion_getInstance_8().t3b(l, c0, c1, a_1, ratio_2);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
            // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call
            if (false) {
              getPoints2List$flush(current, out);
            }
            current._v.i2r(it_2);
            emittedCount_0._v = emittedCount_0._v + 1 | 0;
            lastPos_0._v = prevPos_0._v;
            prevPos_0._v = it_2;
          }
           while (!(n_2 === nEnd_0));
        l = a_1;
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
      case 4:
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.getPoints2List.<anonymous>' call

        var p = i;
        if (false) {
          getPoints2List$flush(current, out);
        }

        current._v.i2r(p);
        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

        break;
    }
  }
  // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  getPoints2List$flush(current, out);
  return out;
}
function getPoints2List$flush(current, out) {
  if (!current._v.o27())
    return Unit_instance;
  out.h(current._v);
  current._v = new PointArrayList();
}
function cachedPoints$delegate$lambda($this$PropertyThis) {
  _init_properties__MathGeom_shape_kt__uqeev8();
  return getPoints2($this$PropertyThis);
}
function cachedPoints$factory() {
  return getPropertyCallableRef('cachedPoints', 1, KProperty1, function (receiver) {
    return get_cachedPoints(receiver);
  }, null);
}
var properties_initialized__MathGeom_shape_kt_lonmli;
function _init_properties__MathGeom_shape_kt__uqeev8() {
  if (!properties_initialized__MathGeom_shape_kt_lonmli) {
    properties_initialized__MathGeom_shape_kt_lonmli = true;
    cachedPoints$delegate = new PropertyThis(VOID, cachedPoints$delegate$lambda);
  }
}
var SliceRotation_R0_instance;
var SliceRotation_R90_instance;
var SliceRotation_R180_instance;
var SliceRotation_R270_instance;
var Companion_instance_3;
function Companion_getInstance_12() {
  SliceRotation_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_3();
  return Companion_instance_3;
}
function values() {
  return [SliceRotation_R0_getInstance(), SliceRotation_R90_getInstance(), SliceRotation_R180_getInstance(), SliceRotation_R270_getInstance()];
}
var SliceRotation_entriesInitialized;
function SliceRotation_initEntries() {
  if (SliceRotation_entriesInitialized)
    return Unit_instance;
  SliceRotation_entriesInitialized = true;
  SliceRotation_R0_instance = new SliceRotation('R0', 0);
  SliceRotation_R90_instance = new SliceRotation('R90', 1);
  SliceRotation_R180_instance = new SliceRotation('R180', 2);
  SliceRotation_R270_instance = new SliceRotation('R270', 3);
  Companion_getInstance_12();
}
function _SliceOrientation___init__impl__ewylib(raw) {
  return raw;
}
function _SliceOrientation___get_raw__impl__tj3u8w($this) {
  return $this;
}
function _SliceOrientation___get_rotation__impl__m65r0o($this) {
  return Companion_getInstance_12().d1(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 2));
}
function _SliceOrientation___get_flipX__impl__lgb7bx($this) {
  return !(extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 2, 1) === 0);
}
function _SliceOrientation___init__impl__ewylib_0(rotation, flipX) {
  rotation = rotation === VOID ? SliceRotation_R0_getInstance() : rotation;
  flipX = flipX === VOID ? false : flipX;
  return _SliceOrientation___init__impl__ewylib(insert_0(insert(0, rotation.n3_1, 0, 2), flipX, 2));
}
function _SliceOrientation___get_indices__impl__km5on3($this) {
  return Companion_getInstance_13().g3f_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
function _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq($this) {
  return _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R90_getInstance()) || _SliceOrientation___get_rotation__impl__m65r0o($this).equals(SliceRotation_R270_getInstance());
}
function SliceOrientation__toString_impl_tdph6r($this) {
  return Companion_getInstance_13().h3f_1[extract(_SliceOrientation___get_raw__impl__tj3u8w($this), 0, 3)];
}
var Companion_instance_4;
function Companion_getInstance_13() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
function SliceOrientation__hashCode_impl_7mjkdw($this) {
  return $this;
}
function SliceOrientation__equals_impl_h4gywg($this, other) {
  if (!(other instanceof SliceOrientation))
    return false;
  if (!($this === (other instanceof SliceOrientation ? other.r3f_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_5;
function Companion_getInstance_14() {
  return Companion_instance_5;
}
function transformed_1(_this__u8e3s4, orientation) {
  var i = _SliceOrientation___get_indices__impl__km5on3(orientation);
  return new RectCoords(_this__u8e3s4.w3h(i[0]), _this__u8e3s4.x3h(i[0]), _this__u8e3s4.w3h(i[1]), _this__u8e3s4.x3h(i[1]), _this__u8e3s4.w3h(i[2]), _this__u8e3s4.x3h(i[2]), _this__u8e3s4.w3h(i[3]), _this__u8e3s4.x3h(i[3]));
}
function SliceRotation_R0_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R0_instance;
}
function SliceRotation_R90_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R90_instance;
}
function SliceRotation_R180_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R180_instance;
}
function SliceRotation_R270_getInstance() {
  SliceRotation_initEntries();
  return SliceRotation_R270_instance;
}
function _Item___init__impl__hhk1le(index) {
  return index;
}
function _Item___get_index__impl__lpanhd($this) {
  return $this;
}
function Item__toString_impl_d711m6($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p($this) {
  return $this;
}
function Item__equals_impl_qczid($this, other) {
  if (!(other instanceof Item))
    return false;
  if (!($this === (other instanceof Item ? other.l3i_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_6;
function Companion_getInstance_15() {
  return Companion_instance_6;
}
function _Item___init__impl__hhk1le_0(index) {
  return index;
}
function _Item___get_index__impl__lpanhd_0($this) {
  return $this;
}
function Item__toString_impl_d711m6_0($this) {
  return 'Item(index=' + $this + ')';
}
function Item__hashCode_impl_8k4v6p_0($this) {
  return $this;
}
function Item__equals_impl_qczid_0($this, other) {
  if (!(other instanceof Item_0))
    return false;
  if (!($this === (other instanceof Item_0 ? other.e3j_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_7;
function Companion_getInstance_16() {
  return Companion_instance_7;
}
function toSegments(_this__u8e3s4, scale) {
  scale = scale === VOID ? 1 : scale;
  var segments = new FSegmentsInt();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
  var m = Vector2D.y27();
  var l = Vector2D.y27();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = _this__u8e3s4.x3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.n27(tmp, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_1));
        m = it;
        l = it;
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.n27(tmp_0, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_3));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0 = l;
        toSegments$emit(segments, scale, p0, it_0);
        l = it_0;
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.n27(tmp_1, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.n27(tmp_2, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_7));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0_0 = l;
        toSegments$emit_0(segments, scale, Bezier.f3c(p0_0, p1, p2));
        l = p2;
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.n27(tmp_3, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.n27(tmp_4, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.n27(tmp_5, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_13));
        // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call

        var p0_1 = l;
        toSegments$emit_0(segments, scale, Bezier.g3c(p0_1, p1_0, p2_0, p3));
        l = p3;
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        var equal = false ? l.bx(m) : l.equals(m);
        if (!equal) {
          // Inline function 'korlibs.math.geom.trapezoid.toSegments.<anonymous>' call
          var p0_2 = l;
          var p1_1 = m;
          toSegments$emit(segments, scale, p0_2, p1_1);
        }

        // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

        break;
    }
  }
  return segments;
}
function segmentLookups($this, segments) {
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter' call
  var this_0 = segments.q3j(SegmentIntToTrapezoidIntList$segmentLookups$lambda);
  // Inline function 'kotlin.also' call
  var this_1 = new FSegmentsInt();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable = 0;
  var last = this_0.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.filter.<anonymous>.<anonymous>' call
      var it = this_0.k3j(n);
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      if (!(this_0.z3j(it) === 0)) {
        this_1.i3k(it, this_0);
      }
    }
     while (inductionVariable < last);
  var list = this_1;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_2 = fastArrayListOf([]);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_0 = 0;
  var last_0 = list.e1();
  if (inductionVariable_0 < last_0)
    do {
      var n_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      var it_0 = list.k3j(n_0);
      var tmp$ret$3 = list.c3k(it_0);
      this_2.h(tmp$ret$3);
    }
     while (inductionVariable_0 < last_0);
  var tmp = this_2;
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map' call
  // Inline function 'kotlin.also' call
  var this_3 = fastArrayListOf([]);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>' call
  // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
  var inductionVariable_1 = 0;
  var last_1 = list.e1();
  if (inductionVariable_1 < last_1)
    do {
      var n_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.map.<anonymous>.<anonymous>' call
      // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
      var it_1 = list.k3j(n_1);
      var tmp$ret$6 = list.d3k(it_1);
      this_3.h(tmp$ret$6);
    }
     while (inductionVariable_1 < last_1);
  var allY = sortedArray(toIntArray(distinct(plus(tmp, this_3))));
  var tmp_0 = 0;
  var tmp_1 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_2 = fillArrayVal(Array(tmp_1), null);
  while (tmp_0 < tmp_1) {
    tmp_2[tmp_0] = new FSegmentsInt();
    tmp_0 = tmp_0 + 1 | 0;
  }
  var initialSegmentsInY = toList(tmp_2);
  var tmp_3 = 0;
  var tmp_4 = allY.length;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_5 = fillArrayVal(Array(tmp_4), null);
  while (tmp_3 < tmp_4) {
    tmp_5[tmp_3] = new FSegmentsInt();
    tmp_3 = tmp_3 + 1 | 0;
  }
  var allSegmentsInY = toList(tmp_5);
  var listPivot = 0;
  var yPivot = 0;
  while (yPivot < allY.length && listPivot < list.e1()) {
    var currentY = allY[yPivot];
    var currentItem = list.k3j(listPivot);
    // Inline function 'korlibs.math.geom.trapezoid.Item.use' call
    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
    if (list.c3k(currentItem) === currentY) {
      initialSegmentsInY.d1(yPivot).i3k(currentItem, list);
      listPivot = listPivot + 1 | 0;
    } else {
      yPivot = yPivot + 1 | 0;
    }
  }
  var inductionVariable_2 = 0;
  var last_2 = allY.length - 1 | 0;
  if (inductionVariable_2 <= last_2)
    do {
      var n_2 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_4 = initialSegmentsInY.d1(n_2);
      var inductionVariable_3 = 0;
      var last_3 = this_4.e1();
      if (inductionVariable_3 < last_3)
        do {
          var n_3 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
          var segment = this_4.k3j(n_3);
          var inductionVariable_4 = n_2;
          var last_4 = allY.length;
          if (inductionVariable_4 < last_4)
            $l$loop: do {
              var m = inductionVariable_4;
              inductionVariable_4 = inductionVariable_4 + 1 | 0;
              var y = allY[m];
              if (!this_4.f3k(segment, y) || this_4.d3k(segment) === y)
                break $l$loop;
              allSegmentsInY.d1(m).i3k(segment, this_4);
            }
             while (inductionVariable_4 < last_4);
        }
         while (inductionVariable_3 < last_3);
    }
     while (inductionVariable_2 <= last_2);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n_4 = 0;
  while (n_4 < allSegmentsInY.e1()) {
    // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
    var _unary__edvuaz = n_4;
    n_4 = _unary__edvuaz + 1 | 0;
    allSegmentsInY.d1(_unary__edvuaz).r3j(SegmentIntToTrapezoidIntList$segmentLookups$lambda_0);
  }
  var inductionVariable_5 = 0;
  var last_5 = allY.length - 1 | 0;
  if (inductionVariable_5 <= last_5)
    do {
      var n_5 = inductionVariable_5;
      inductionVariable_5 = inductionVariable_5 + 1 | 0;
      // Inline function 'korlibs.math.geom.trapezoid.FSegmentsInt.fastForEach' call
      var this_5 = allSegmentsInY.d1(n_5);
      var inductionVariable_6 = 0;
      var last_6 = this_5.e1();
      if (inductionVariable_6 < last_6)
        do {
          var n_6 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          // Inline function 'korlibs.math.geom.trapezoid.SegmentIntToTrapezoidIntList.segmentLookups.<anonymous>' call
          var segment_0 = this_5.k3j(n_6);
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!this_5.f3k(segment_0, allY[n_5])) {
            // Inline function 'kotlin.check.<anonymous>' call
            var message = 'Check failed.';
            throw IllegalStateException.w4(toString(message));
          }
        }
         while (inductionVariable_6 < last_6);
    }
     while (inductionVariable_5 <= last_5);
  return new Pair(allY, allSegmentsInY);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda($this$sortedBy, it) {
  return $this$sortedBy.c3k(it.e3j_1);
}
function SegmentIntToTrapezoidIntList$segmentLookups$lambda_0($this$sortBy, it) {
  return $this$sortBy.b3k(it.e3j_1);
}
var SegmentIntToTrapezoidIntList_instance;
function SegmentIntToTrapezoidIntList_getInstance() {
  return SegmentIntToTrapezoidIntList_instance;
}
function det($this, x0, y0, x1, y1) {
  return imul(x0, y1) - imul(x1, y0) | 0;
}
var Companion_instance_8;
function Companion_getInstance_17() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_18() {
  return Companion_instance_9;
}
function toSegments$emit(segments, $scale, p0, p1) {
  segments.p3j(toIntRound(p0.e25_1 * $scale), toIntRound(p0.f25_1 * $scale), toIntRound(p1.e25_1 * $scale), toIntRound(p1.f25_1 * $scale));
}
function toSegments$emit_0(segments, $scale, bezier) {
  var len = coerceIn(toIntRound(bezier.a()), 2, 20);
  var oldPos = Vector2D.y27();
  // Inline function 'korlibs.math.interpolation.Companion.forEachRatio' call
  Companion_getInstance_6();
  var NS = len - 1 | 0;
  var NSd = NS;
  var start = true ? 0 : 1;
  var end = true ? NS : NS - 1 | 0;
  var inductionVariable = start;
  if (inductionVariable <= end)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ratio = n / NSd;
      // Inline function 'korlibs.math.geom.trapezoid.toSegments.emit.<anonymous>' call
      var ratio_0 = toRatio_0(ratio);
      var p = bezier.b39(ratio_0);
      if (Ratio__compareTo_impl_z2ienc(ratio_0, Companion_getInstance_6().kx_1) > 0) {
        toSegments$emit(segments, $scale, oldPos, p);
      }
      oldPos = p;
    }
     while (!(n === end));
}
function PolygonScanline$AllBuckets$pool$lambda(it) {
  it.zg();
  return Unit_instance;
}
function PolygonScanline$AllBuckets$pool$lambda_0(it) {
  return new Bucket();
}
function addPoint($this, x, y) {
  $this.u3l_1.h2r(x, y);
}
function addEdge($this, ax, ay, bx, by) {
  if (ax === bx && ay === by)
    return Unit_instance;
  var isHorizontal = ay === by;
  var iax = $this.d3m(ax);
  var ibx = $this.d3m(bx);
  var iay = $this.d3m(ay);
  var iby = $this.d3m(by);
  var edge = ay < by ? $this.o3l_1.m2p().e3m(iax, iay, ibx, iby, 1) : $this.o3l_1.m2p().e3m(ibx, iby, iax, iay, -1);
  $this.r3l_1.h(edge);
  if (isHorizontal) {
    $this.q3l_1.h(edge);
  } else {
    $this.p3l_1.h(edge);
    $this.s3l_1.k3l(edge);
  }
  $this.n3l_1 = BoundsBuilder__plus_impl_cz7f7x($this.n3l_1, Vector2D.n27(ax, ay));
  $this.n3l_1 = BoundsBuilder__plus_impl_cz7f7x($this.n3l_1, Vector2D.n27(bx, by));
}
var IntArrayListSort_instance;
function IntArrayListSort_getInstance() {
  if (IntArrayListSort_instance === VOID)
    new IntArrayListSort();
  return IntArrayListSort_instance;
}
function PolygonScanline$edgesPool$lambda(it) {
  return new MEdge();
}
var Companion_instance_10;
function Companion_getInstance_19() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_20() {
  return Companion_instance_11;
}
var EdgePoint_A_instance;
var EdgePoint_B_instance;
var EdgePoint_entriesInitialized;
function EdgePoint_initEntries() {
  if (EdgePoint_entriesInitialized)
    return Unit_instance;
  EdgePoint_entriesInitialized = true;
  EdgePoint_A_instance = new EdgePoint('A', 0, 0);
  EdgePoint_B_instance = new EdgePoint('B', 1, 1);
}
function _get_outFill__zcv64g($this) {
  var tmp = $this.i3n_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('outFill');
  }
}
function EdgePoint_A_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_A_instance;
}
function EdgePoint_B_getInstance() {
  EdgePoint_initEntries();
  return EdgePoint_B_instance;
}
function strokeToFill(_this__u8e3s4, lineWidth, joins, startCap, endCap, miterLimit, lineDash, lineDashOffset, temp, outFill) {
  joins = joins === VOID ? LineJoin_MITER_getInstance() : joins;
  startCap = startCap === VOID ? LineCap_BUTT_getInstance() : startCap;
  endCap = endCap === VOID ? startCap : endCap;
  miterLimit = miterLimit === VOID ? 4.0 : miterLimit;
  lineDash = lineDash === VOID ? null : lineDash;
  lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  var tmp;
  if (!(lineDash == null)) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = toCurvesList(_this__u8e3s4);
    var destination = ArrayList.h1();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var list = toDashes(element, lineDash.rx(), lineDashOffset);
      addAll(destination, list);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
      var tmp$ret$3 = toVectorPath_0(item);
      destination_0.h(tmp$ret$3);
    }
    tmp = destination_0;
  } else {
    tmp = listOf(_this__u8e3s4);
  }
  var strokePaths = tmp;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < strokePaths.e1()) {
    // Inline function 'korlibs.math.geom.vector.strokeToFill.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var strokePath = strokePaths.d1(_unary__edvuaz);
    temp.q3o(strokePath, lineWidth, joins, startCap, endCap, miterLimit, outFill);
  }
  return outFill;
}
function strokeToFill_0(_this__u8e3s4, info, temp, outFill) {
  temp = temp === VOID ? new StrokeToFill() : temp;
  outFill = outFill === VOID ? new VectorPath(VOID, VOID, Winding_NON_ZERO_getInstance()) : outFill;
  return strokeToFill(_this__u8e3s4, info.d38_1, info.i38_1, info.g38_1, info.h38_1, info.j38_1, info.k38_1, info.l38_1, temp, outFill);
}
function t($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.u3o_1;
    if (this_0.t25()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.n27(this_0.p29(p.e25_1, p.f25_1), this_0.s29(p.e25_1, p.f25_1));
  }
  return tmp$ret$0;
}
var _bvhCurvesCacheVersion$delegate;
var _bvhCurvesCache$delegate;
function set__curvesCacheVersion(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCacheVersion$delegate;
  var property = _curvesCacheVersion$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCacheVersion(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCacheVersion$delegate;
    var property = _curvesCacheVersion$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCacheVersion$delegate;
function set__curvesCache(_this__u8e3s4, _set____db54di) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var this_0 = _curvesCache$delegate;
  var property = _curvesCache$factory();
  var tmp0_elvis_lhs = this_0.xx_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__curvesCache(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = _curvesCache$delegate;
    var property = _curvesCache$factory_0();
    var tmp = _this__u8e3s4.wx();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.xx_1;
      tmp_0 = tmp0_safe_receiver.c3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.yx_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.xx_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.xx_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _curvesCache$delegate;
var Companion_instance_12;
function Companion_getInstance_21() {
  return Companion_instance_12;
}
function ensureMoveTo($this, p) {
  if ($this.o27())
    return false;
  $this.u3d(p);
  return true;
}
function getCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  if (!(get__curvesCacheVersion(_this__u8e3s4) === _this__u8e3s4.c3e_1)) {
    set__curvesCacheVersion(_this__u8e3s4, _this__u8e3s4.c3e_1);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var this_0 = ArrayList.h1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>' call
    var currentClosed = {_v: false};
    // Inline function 'kotlin.collections.arrayListOf' call
    var current = {_v: ArrayList.h1()};
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges' call
    var m = Vector2D.y27();
    var l = Vector2D.y27();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = _this__u8e3s4.x3d_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_1.qx(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.n27(tmp, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_1));
          m = it;
          l = it;
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
        case 1:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.n27(tmp_0, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_2 = current._v;
          var element = Bezier.e3c(p1, it_0);
          this_2.h(element);
          l = it_0;
          break;
        case 2:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var p1_0 = Vector2D.n27(tmp_1, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var p2 = Vector2D.n27(tmp_2, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_7));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_1 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_3 = current._v;
          var element_0 = Bezier.f3c(p1_1, p1_0, p2);
          this_3.h(element_0);
          l = p2;
          break;
        case 3:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var p1_2 = Vector2D.n27(tmp_3, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var p2_0 = Vector2D.n27(tmp_4, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = _this__u8e3s4.y3d_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var p3 = Vector2D.n27(tmp_5, _this__u8e3s4.y3d_1.d1(_unary__edvuaz_13));
          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          var p1_3 = l;
          // Inline function 'kotlin.collections.plusAssign' call

          var this_4 = current._v;
          var element_1 = Bezier.g3c(p1_3, p1_2, p2_0, p3);
          this_4.h(element_1);
          l = p3;
          break;
        case 4:
          // Inline function 'korlibs.math.geom.vector.VectorPath.visitEdges.<anonymous>' call

          var equal = true ? l.bx(m) : l.equals(m);
          if (!equal) {
            // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call
            var p1_4 = l;
            var p2_1 = m;
            // Inline function 'kotlin.collections.plusAssign' call
            var this_5 = current._v;
            var element_2 = Bezier.e3c(p1_4, p2_1);
            this_5.h(element_2);
          }

          // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>.<anonymous>' call

          currentClosed._v = true;
          getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
          break;
      }
    }
    getCurvesList$_anonymous_$flush_1e57i7(current, this_0, currentClosed, _this__u8e3s4);
    set__curvesCache(_this__u8e3s4, this_0);
  }
  return ensureNotNull(get__curvesCache(_this__u8e3s4));
}
function plus_0(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return with_0(_this__u8e3s4, path);
}
function VectorPathTrapezoids$trapezoidsEvenOdd$delegate$lambda(this$0) {
  return function () {
    return SegmentIntToTrapezoidIntList_instance.k3k(this$0.q3p_1, Winding_EVEN_ODD_getInstance());
  };
}
function VectorPathTrapezoids$trapezoidsNonZero$delegate$lambda(this$0) {
  return function () {
    return SegmentIntToTrapezoidIntList_instance.k3k(this$0.q3p_1, Winding_NON_ZERO_getInstance());
  };
}
function with_0(_this__u8e3s4, path, transform) {
  transform = transform === VOID ? Companion_getInstance_2().y28_1 : transform;
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var bb = {_v: new BoundsBuilder(_this__u8e3s4)};
  var curvesList = getCurvesList(path);
  if (curvesList.g1() && path.o27()) {
    path.i3p(new with$1(bb));
  }
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < curvesList.e1()) {
    // Inline function 'korlibs.math.geom.vector.with.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = curvesList.d1(_unary__edvuaz).o39_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.with.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var bezier = this_0.d1(_unary__edvuaz_0);
      bb._v = new BoundsBuilder(BoundsBuilder__plus_impl_cz7f7x_0(bb._v.r26_1, bezier.k3c(transform)));
    }
  }
  return bb._v.r26_1;
}
function write(_this__u8e3s4, path) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.x3d_1;
  var n_0 = 0;
  while (n_0 < this_0.e1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.qx(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.y3d_1.d1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.n27(tmp, path.y3d_1.d1(_unary__edvuaz_1));
        _this__u8e3s4.u3d(it);
        break;
      case 1:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.y3d_1.d1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.n27(tmp_0, path.y3d_1.d1(_unary__edvuaz_3));
        _this__u8e3s4.h3e(it_0);
        break;
      case 2:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.y3d_1.d1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var p1 = Vector2D.n27(tmp_1, path.y3d_1.d1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.y3d_1.d1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var p2 = Vector2D.n27(tmp_2, path.y3d_1.d1(_unary__edvuaz_7));
        _this__u8e3s4.i3e(p1, p2);
        break;
      case 3:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.y3d_1.d1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var p1_0 = Vector2D.n27(tmp_3, path.y3d_1.d1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.y3d_1.d1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var p2_0 = Vector2D.n27(tmp_4, path.y3d_1.d1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.y3d_1.d1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var p3 = Vector2D.n27(tmp_5, path.y3d_1.d1(_unary__edvuaz_13));
        _this__u8e3s4.v3d(p1_0, p2_0, p3);
        break;
      case 4:
        // Inline function 'korlibs.math.geom.vector.write.<anonymous>' call

        _this__u8e3s4.c6();
        break;
    }
  }
}
function getCurves(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var curvesList = getCurvesList(_this__u8e3s4);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.h1();
  var tmp0_iterator = curvesList.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.math.geom.vector.getCurves.<anonymous>' call
    var list = element.o39_1;
    addAll(destination, list);
  }
  var tmp = destination;
  var tmp59_safe_receiver = lastOrNull(curvesList);
  var tmp0_elvis_lhs = tmp59_safe_receiver == null ? null : tmp59_safe_receiver.p39_1;
  return toCurves(tmp, tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs);
}
function toCurvesList(_this__u8e3s4) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return getCurvesList(_this__u8e3s4);
}
function applyTransform(_this__u8e3s4, m) {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  var tmp;
  if (m.u25()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.transformPoints' call
    var progression = step(until(0, _this__u8e3s4.y3d_1.e1()), 2);
    var inductionVariable = progression.a2_1;
    var last = progression.b2_1;
    var step_0 = progression.c2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        // Inline function 'korlibs.math.geom.vector.applyTransform.<anonymous>' call
        var it = Vector2D.n27(_this__u8e3s4.y3d_1.d1(n + 0 | 0), _this__u8e3s4.y3d_1.d1(n + 1 | 0));
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          if (m.t25()) {
            tmp$ret$0 = it;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.n27(m.p29(it.e25_1, it.f25_1), m.s29(it.e25_1, it.f25_1));
        }
        var p = tmp$ret$0;
        _this__u8e3s4.y3d_1.v2k(n + 0 | 0, p.e25_1);
        _this__u8e3s4.y3d_1.v2k(n + 1 | 0, p.f25_1);
      }
       while (!(n === last));
    _this__u8e3s4.c3e_1 = _this__u8e3s4.c3e_1 + 1 | 0;
    tmp = _this__u8e3s4;
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function getCurvesList$_anonymous_$flush_1e57i7(current, $out, currentClosed, $this_getCurvesList) {
  if (current._v.g1())
    return Unit_instance;
  // Inline function 'kotlin.also' call
  var this_0 = new Curves(current._v, currentClosed._v);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.math.geom.vector.getCurvesList.<anonymous>$flush.<anonymous>' call
  this_0.q39_1 = $this_getCurvesList.b3e_1;
  $out.h(this_0);
  currentClosed._v = false;
  // Inline function 'kotlin.collections.arrayListOf' call
  current._v = ArrayList.h1();
}
function _bvhCurvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _bvhCurvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return -1;
}
function _curvesCache$delegate$lambda() {
  _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe();
  return null;
}
function _curvesCacheVersion$factory() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCacheVersion$factory_0() {
  return getPropertyCallableRef('_curvesCacheVersion', 1, KMutableProperty1, function (receiver) {
    return get__curvesCacheVersion(receiver);
  }, function (receiver, value) {
    return set__curvesCacheVersion(receiver, value);
  });
}
function _curvesCache$factory() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function _curvesCache$factory_0() {
  return getPropertyCallableRef('_curvesCache', 1, KMutableProperty1, function (receiver) {
    return get__curvesCache(receiver);
  }, function (receiver, value) {
    return set__curvesCache(receiver, value);
  });
}
function trapezoidsEvenOdd$factory() {
  return getPropertyCallableRef('trapezoidsEvenOdd', 1, KProperty1, function (receiver) {
    return receiver.y3p();
  }, null);
}
function trapezoidsNonZero$factory() {
  return getPropertyCallableRef('trapezoidsNonZero', 1, KProperty1, function (receiver) {
    return receiver.z3p();
  }, null);
}
var properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk;
function _init_properties__MathGeom_vector_VectorPath_kt__cc0pbe() {
  if (!properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk) {
    properties_initialized__MathGeom_vector_VectorPath_kt_i91mdk = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _bvhCurvesCacheVersion$delegate$lambda;
    _bvhCurvesCacheVersion$delegate = new Property(null, default_0);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_1 = _bvhCurvesCache$delegate$lambda;
    _bvhCurvesCache$delegate = new Property(null, default_1);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_2 = _curvesCacheVersion$delegate$lambda;
    _curvesCacheVersion$delegate = new Property(null, default_2);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_3 = _curvesCache$delegate$lambda;
    _curvesCache$delegate = new Property(null, default_3);
  }
}
var Winding_EVEN_ODD_instance;
var Winding_NON_ZERO_instance;
var Companion_instance_13;
function Companion_getInstance_22() {
  return Companion_instance_13;
}
var Winding_entriesInitialized;
function Winding_initEntries() {
  if (Winding_entriesInitialized)
    return Unit_instance;
  Winding_entriesInitialized = true;
  Winding_EVEN_ODD_instance = new Winding('EVEN_ODD', 0, 'evenOdd');
  Winding_NON_ZERO_instance = new Winding('NON_ZERO', 1, 'nonZero');
}
var LineJoin_BEVEL_instance;
var LineJoin_ROUND_instance;
var LineJoin_MITER_instance;
var Companion_instance_14;
function Companion_getInstance_23() {
  return Companion_instance_14;
}
var LineJoin_entriesInitialized;
function LineJoin_initEntries() {
  if (LineJoin_entriesInitialized)
    return Unit_instance;
  LineJoin_entriesInitialized = true;
  LineJoin_BEVEL_instance = new LineJoin('BEVEL', 0);
  LineJoin_ROUND_instance = new LineJoin('ROUND', 1);
  LineJoin_MITER_instance = new LineJoin('MITER', 2);
}
var LineCap_BUTT_instance;
var LineCap_SQUARE_instance;
var LineCap_ROUND_instance;
var Companion_instance_15;
function Companion_getInstance_24() {
  return Companion_instance_15;
}
var LineCap_entriesInitialized;
function LineCap_initEntries() {
  if (LineCap_entriesInitialized)
    return Unit_instance;
  LineCap_entriesInitialized = true;
  LineCap_BUTT_instance = new LineCap('BUTT', 0);
  LineCap_SQUARE_instance = new LineCap('SQUARE', 1);
  LineCap_ROUND_instance = new LineCap('ROUND', 2);
}
var LineScaleMode_NONE_instance;
var LineScaleMode_HORIZONTAL_instance;
var LineScaleMode_VERTICAL_instance;
var LineScaleMode_NORMAL_instance;
var LineScaleMode_entriesInitialized;
function LineScaleMode_initEntries() {
  if (LineScaleMode_entriesInitialized)
    return Unit_instance;
  LineScaleMode_entriesInitialized = true;
  LineScaleMode_NONE_instance = new LineScaleMode('NONE', 0, false, false);
  LineScaleMode_HORIZONTAL_instance = new LineScaleMode('HORIZONTAL', 1, true, false);
  LineScaleMode_VERTICAL_instance = new LineScaleMode('VERTICAL', 2, false, true);
  LineScaleMode_NORMAL_instance = new LineScaleMode('NORMAL', 3, true, true);
}
var Companion_instance_16;
function Companion_getInstance_25() {
  return Companion_instance_16;
}
function Winding_EVEN_ODD_getInstance() {
  Winding_initEntries();
  return Winding_EVEN_ODD_instance;
}
function Winding_NON_ZERO_getInstance() {
  Winding_initEntries();
  return Winding_NON_ZERO_instance;
}
function LineJoin_BEVEL_getInstance() {
  LineJoin_initEntries();
  return LineJoin_BEVEL_instance;
}
function LineJoin_MITER_getInstance() {
  LineJoin_initEntries();
  return LineJoin_MITER_instance;
}
function LineCap_BUTT_getInstance() {
  LineCap_initEntries();
  return LineCap_BUTT_instance;
}
function LineCap_SQUARE_getInstance() {
  LineCap_initEntries();
  return LineCap_SQUARE_instance;
}
function LineScaleMode_NONE_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NONE_instance;
}
function LineScaleMode_NORMAL_getInstance() {
  LineScaleMode_initEntries();
  return LineScaleMode_NORMAL_instance;
}
function MPoint$Companion$POOL$lambda(it) {
  it.n3q(0.0, 0.0);
  return Unit_instance;
}
function MPoint$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_26().a29();
}
var Companion_instance_17;
function Companion_getInstance_26() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function MMatrix$Companion$POOL$lambda(it) {
  it.y3q();
  return Unit_instance;
}
function MMatrix$Companion$POOL$lambda_0(it) {
  return new MMatrix();
}
var Companion_instance_18;
function Companion_getInstance_27() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_28() {
  return Companion_instance_19;
}
function MRectangle$Companion$POOL$lambda(it) {
  it.zg();
  return Unit_instance;
}
function MRectangle$Companion$POOL$lambda_0(it) {
  return Companion_getInstance_29().a29();
}
var Companion_instance_20;
function Companion_getInstance_29() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function get_immutable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get_mutable(_this__u8e3s4) {
  return new MRectangle(_this__u8e3s4.o25_1, _this__u8e3s4.p25_1, _this__u8e3s4.q25_1, _this__u8e3s4.r25_1);
}
function toMatrix4(_this__u8e3s4) {
  if (_this__u8e3s4.t25())
    return Companion_getInstance_5().d2c_1;
  return Companion_getInstance_5().g2c(_this__u8e3s4.c29_1, _this__u8e3s4.e29_1, 0.0, _this__u8e3s4.g29_1, _this__u8e3s4.d29_1, _this__u8e3s4.f29_1, 0.0, _this__u8e3s4.h29_1, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
}
function lineIntersectionPoint(_this__u8e3s4, l1, l2) {
  return l1.i3r(l2);
}
function projectedPoint(_this__u8e3s4, point) {
  return projectedPoint_0(Companion_instance_19, _this__u8e3s4.f39_1, _this__u8e3s4.g39_1, point);
}
function projectedPoint_0(_this__u8e3s4, v1, v2, point) {
  return projectedPoint_1(_this__u8e3s4, v1.e25_1, v1.f25_1, v2.e25_1, v2.f25_1, point.e25_1, point.f25_1);
}
function projectedPoint_1(_this__u8e3s4, v1x, v1y, v2x, v2y, px, py) {
  var e1x = v2x - v1x;
  var e1y = v2y - v1y;
  var e2x = px - v1x;
  var e2y = py - v1y;
  var valDp = Companion_getInstance_26().p3q(e1x, e1y, e2x, e2y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE1 = hypot(e1x, e1y);
  // Inline function 'kotlin.math.hypot' call
  var lenLineE2 = hypot(e2x, e2y);
  if (lenLineE1 === 0.0 || lenLineE2 === 0.0) {
    return Vector2D.n27(px, py);
  }
  var cos = valDp / (lenLineE1 * lenLineE2);
  var projLenOfLine = cos * lenLineE2;
  return Vector2D.n27(v1x + projLenOfLine * e1x / lenLineE1, v1y + projLenOfLine * e1y / lenLineE1);
}
function floorCeil(v) {
  var tmp;
  if (v < 0.0) {
    // Inline function 'kotlin.math.ceil' call
    tmp = Math.ceil(v);
  } else {
    // Inline function 'kotlin.math.floor' call
    tmp = Math.floor(v);
  }
  return tmp;
}
function get__ALL_LIST() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.getValue' call
  var this_0 = _ALL_LIST$delegate;
  _ALL_LIST$factory();
  return this_0.r1();
}
var _ALL_LIST$delegate;
var _ALL$delegate;
var Easings_SMOOTH_instance;
var Easings_EASE_IN_ELASTIC_instance;
var Easings_EASE_OUT_ELASTIC_instance;
var Easings_EASE_OUT_BOUNCE_instance;
var Easings_LINEAR_instance;
var Easings_EASE_instance;
var Easings_EASE_IN_instance;
var Easings_EASE_OUT_instance;
var Easings_EASE_IN_OUT_instance;
var Easings_EASE_IN_OLD_instance;
var Easings_EASE_OUT_OLD_instance;
var Easings_EASE_IN_OUT_OLD_instance;
var Easings_EASE_OUT_IN_OLD_instance;
var Easings_EASE_IN_BACK_instance;
var Easings_EASE_OUT_BACK_instance;
var Easings_EASE_IN_OUT_BACK_instance;
var Easings_EASE_OUT_IN_BACK_instance;
var Easings_EASE_IN_OUT_ELASTIC_instance;
var Easings_EASE_OUT_IN_ELASTIC_instance;
var Easings_EASE_IN_BOUNCE_instance;
var Easings_EASE_IN_OUT_BOUNCE_instance;
var Easings_EASE_OUT_IN_BOUNCE_instance;
var Easings_EASE_IN_QUAD_instance;
var Easings_EASE_OUT_QUAD_instance;
var Easings_EASE_IN_OUT_QUAD_instance;
var Easings_EASE_SINE_instance;
var Easings_EASE_CLAMP_START_instance;
var Easings_EASE_CLAMP_END_instance;
var Easings_EASE_CLAMP_MIDDLE_instance;
function values_0() {
  return [Easings_SMOOTH_getInstance(), Easings_EASE_IN_ELASTIC_getInstance(), Easings_EASE_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_BOUNCE_getInstance(), Easings_LINEAR_getInstance(), Easings_EASE_getInstance(), Easings_EASE_IN_getInstance(), Easings_EASE_OUT_getInstance(), Easings_EASE_IN_OUT_getInstance(), Easings_EASE_IN_OLD_getInstance(), Easings_EASE_OUT_OLD_getInstance(), Easings_EASE_IN_OUT_OLD_getInstance(), Easings_EASE_OUT_IN_OLD_getInstance(), Easings_EASE_IN_BACK_getInstance(), Easings_EASE_OUT_BACK_getInstance(), Easings_EASE_IN_OUT_BACK_getInstance(), Easings_EASE_OUT_IN_BACK_getInstance(), Easings_EASE_IN_OUT_ELASTIC_getInstance(), Easings_EASE_OUT_IN_ELASTIC_getInstance(), Easings_EASE_IN_BOUNCE_getInstance(), Easings_EASE_IN_OUT_BOUNCE_getInstance(), Easings_EASE_OUT_IN_BOUNCE_getInstance(), Easings_EASE_IN_QUAD_getInstance(), Easings_EASE_OUT_QUAD_getInstance(), Easings_EASE_IN_OUT_QUAD_getInstance(), Easings_EASE_SINE_getInstance(), Easings_EASE_CLAMP_START_getInstance(), Easings_EASE_CLAMP_END_getInstance(), Easings_EASE_CLAMP_MIDDLE_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values_0());
  return $ENTRIES;
}
var Easings_entriesInitialized;
function Easings_initEntries() {
  if (Easings_entriesInitialized)
    return Unit_instance;
  Easings_entriesInitialized = true;
  Easings_SMOOTH_instance = new Easings$SMOOTH();
  Easings_EASE_IN_ELASTIC_instance = new Easings$EASE_IN_ELASTIC();
  Easings_EASE_OUT_ELASTIC_instance = new Easings$EASE_OUT_ELASTIC();
  Easings_EASE_OUT_BOUNCE_instance = new Easings$EASE_OUT_BOUNCE();
  Easings_LINEAR_instance = new Easings$LINEAR();
  Easings_EASE_instance = new Easings$EASE();
  Easings_EASE_IN_instance = new Easings$EASE_IN();
  Easings_EASE_OUT_instance = new Easings$EASE_OUT();
  Easings_EASE_IN_OUT_instance = new Easings$EASE_IN_OUT();
  Easings_EASE_IN_OLD_instance = new Easings$EASE_IN_OLD();
  Easings_EASE_OUT_OLD_instance = new Easings$EASE_OUT_OLD();
  Easings_EASE_IN_OUT_OLD_instance = new Easings$EASE_IN_OUT_OLD();
  Easings_EASE_OUT_IN_OLD_instance = new Easings$EASE_OUT_IN_OLD();
  Easings_EASE_IN_BACK_instance = new Easings$EASE_IN_BACK();
  Easings_EASE_OUT_BACK_instance = new Easings$EASE_OUT_BACK();
  Easings_EASE_IN_OUT_BACK_instance = new Easings$EASE_IN_OUT_BACK();
  Easings_EASE_OUT_IN_BACK_instance = new Easings$EASE_OUT_IN_BACK();
  Easings_EASE_IN_OUT_ELASTIC_instance = new Easings$EASE_IN_OUT_ELASTIC();
  Easings_EASE_OUT_IN_ELASTIC_instance = new Easings$EASE_OUT_IN_ELASTIC();
  Easings_EASE_IN_BOUNCE_instance = new Easings$EASE_IN_BOUNCE();
  Easings_EASE_IN_OUT_BOUNCE_instance = new Easings$EASE_IN_OUT_BOUNCE();
  Easings_EASE_OUT_IN_BOUNCE_instance = new Easings$EASE_OUT_IN_BOUNCE();
  Easings_EASE_IN_QUAD_instance = new Easings$EASE_IN_QUAD();
  Easings_EASE_OUT_QUAD_instance = new Easings$EASE_OUT_QUAD();
  Easings_EASE_IN_OUT_QUAD_instance = new Easings$EASE_IN_OUT_QUAD();
  Easings_EASE_SINE_instance = new Easings$EASE_SINE();
  Easings_EASE_CLAMP_START_instance = new Easings$EASE_CLAMP_START();
  Easings_EASE_CLAMP_END_instance = new Easings$EASE_CLAMP_END();
  Easings_EASE_CLAMP_MIDDLE_instance = new Easings$EASE_CLAMP_MIDDLE();
}
var $ENTRIES;
function calc($this, it) {
  var t = toRatio_1(it);
  var p = $this.k3s_1;
  var order = p.length - 1 | 0;
  if (equals(t, Companion_getInstance_6().kx_1))
    return p[0];
  if (equals(t, Companion_getInstance_6().nx_1))
    return p[order];
  if (order === 0)
    return p[0];
  var mt = Ratio__toDouble_impl_o7epze(Ratio__minus_impl_s1uwyg(Companion_getInstance_6().nx_1, t));
  var mt2 = mt * mt;
  var t2 = Ratio__toDouble_impl_o7epze(Ratio__times_impl_ucdh7y_0(t, t));
  var a = mt2 * mt;
  // Inline function 'korlibs.math.interpolation.times' call
  var b = mt2 * _Ratio___get_value__impl__57cli6(t) * 3;
  var c = mt * t2 * 3;
  var d = Ratio__times_impl_ucdh7y(t, t2);
  return p[0].t2d(a).m3u(p[1].t2d(b)).m3u(p[2].t2d(c)).m3u(p[3].t2d(d));
}
function get_EASE(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_getInstance();
}
function get_EASE_IN_OUT_QUAD(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_OUT_QUAD_getInstance();
}
function get_EASE_IN(_this__u8e3s4) {
  _init_properties_Easings_kt__swvzhy();
  return Easings_EASE_IN_getInstance();
}
function _ALL_LIST$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  return get_entries();
}
function _ALL$delegate$lambda() {
  _init_properties_Easings_kt__swvzhy();
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get__ALL_LIST();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.cc(capacity);
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'korlibs.math.interpolation._ALL$delegate.<anonymous>.<anonymous>' call
    var tmp$ret$0 = element.m3_1;
    destination.e3(tmp$ret$0, element);
  }
  return destination;
}
function Easings_SMOOTH_getInstance() {
  Easings_initEntries();
  return Easings_SMOOTH_instance;
}
function Easings_EASE_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_ELASTIC_instance;
}
function Easings_EASE_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BOUNCE_instance;
}
function Easings_LINEAR_getInstance() {
  Easings_initEntries();
  return Easings_LINEAR_instance;
}
function Easings_EASE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_instance;
}
function Easings_EASE_IN_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_instance;
}
function Easings_EASE_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_instance;
}
function Easings_EASE_IN_OUT_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_instance;
}
function Easings_EASE_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OLD_instance;
}
function Easings_EASE_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_OLD_instance;
}
function Easings_EASE_IN_OUT_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_OLD_instance;
}
function Easings_EASE_OUT_IN_OLD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_OLD_instance;
}
function Easings_EASE_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BACK_instance;
}
function Easings_EASE_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_BACK_instance;
}
function Easings_EASE_IN_OUT_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BACK_instance;
}
function Easings_EASE_OUT_IN_BACK_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BACK_instance;
}
function Easings_EASE_IN_OUT_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_ELASTIC_instance;
}
function Easings_EASE_OUT_IN_ELASTIC_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_ELASTIC_instance;
}
function Easings_EASE_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_BOUNCE_instance;
}
function Easings_EASE_IN_OUT_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_BOUNCE_instance;
}
function Easings_EASE_OUT_IN_BOUNCE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_IN_BOUNCE_instance;
}
function Easings_EASE_IN_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_QUAD_instance;
}
function Easings_EASE_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_OUT_QUAD_instance;
}
function Easings_EASE_IN_OUT_QUAD_getInstance() {
  Easings_initEntries();
  return Easings_EASE_IN_OUT_QUAD_instance;
}
function Easings_EASE_SINE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_SINE_instance;
}
function Easings_EASE_CLAMP_START_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_START_instance;
}
function Easings_EASE_CLAMP_END_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_END_instance;
}
function Easings_EASE_CLAMP_MIDDLE_getInstance() {
  Easings_initEntries();
  return Easings_EASE_CLAMP_MIDDLE_instance;
}
function _ALL_LIST$factory() {
  return getPropertyCallableRef('_ALL_LIST', 0, KProperty0, function () {
    return get__ALL_LIST();
  }, null);
}
var properties_initialized_Easings_kt_w5y1uw;
function _init_properties_Easings_kt__swvzhy() {
  if (!properties_initialized_Easings_kt_w5y1uw) {
    properties_initialized_Easings_kt_w5y1uw = true;
    var tmp = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL_LIST$delegate = lazy_0(tmp, _ALL_LIST$delegate$lambda);
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    _ALL$delegate = lazy_0(tmp_0, _ALL$delegate$lambda);
  }
}
function get_niceStr_0(_this__u8e3s4) {
  return get_niceStr(Ratio__toDouble_impl_o7epze(_this__u8e3s4));
}
//region block: post-declaration
initMetadataForClass(IntSegmentSet, 'IntSegmentSet', IntSegmentSet);
initMetadataForClass(StrokePointsMode, 'StrokePointsMode');
initMetadataForClass(StrokePointsBuilder, 'StrokePointsBuilder');
initMetadataForClass(CurveInfo, 'CurveInfo');
initMetadataForClass(Curves, 'Curves');
protoOf(ProjectedPoint).bx = isAlmostEquals$default;
initMetadataForClass(ProjectedPoint, 'ProjectedPoint', ProjectedPoint, VOID, [IsAlmostEquals]);
initMetadataForClass(Extrema, 'Extrema');
initMetadataForCompanion(Companion);
protoOf(Bezier).bx = isAlmostEquals$default;
initMetadataForClass(Bezier, 'Bezier', Bezier.d3c, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(SubBezier, 'SubBezier');
initMetadataForClass(ClosestResult, 'ClosestResult');
initMetadataForClass(Estimation, 'Estimation', Estimation);
initMetadataForClass(CurveLUT, 'CurveLUT');
initMetadataForObject(Arc, 'Arc');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ImageDoNotFitException, 'ImageDoNotFitException');
initMetadataForClass(BinPacker, 'BinPacker');
initMetadataForClass(MaxRects, 'MaxRects');
initMetadataForCompanion(Companion_2);
initMetadataForClass(HitTestDirection, 'HitTestDirection');
initMetadataForObject(Convex, 'Convex');
initMetadataForClass(AbstractShape2D, 'AbstractShape2D');
initMetadataForCompanion(Companion_3);
initMetadataForClass(SliceRotation, 'SliceRotation');
initMetadataForCompanion(Companion_4);
initMetadataForClass(SliceOrientation, 'SliceOrientation');
initMetadataForInterface(SliceCoords, 'SliceCoords');
initMetadataForInterface(SliceCoordsWithBase, 'SliceCoordsWithBase', VOID, VOID, [SliceCoords]);
initMetadataForInterface(SliceCoordsWithBaseAndRect, 'SliceCoordsWithBaseAndRect', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectSlice).v25 = get_left;
protoOf(RectSlice).x25 = get_top;
protoOf(RectSlice).w25 = get_right;
protoOf(RectSlice).y25 = get_bottom;
protoOf(RectSlice).i2f = get_area;
protoOf(RectSlice).u3h = get_frameOffsetX;
protoOf(RectSlice).v3h = get_frameOffsetY;
protoOf(RectSlice).w3h = x;
protoOf(RectSlice).x3h = y;
initMetadataForClass(RectSlice, 'RectSlice', VOID, VOID, [SliceCoordsWithBaseAndRect]);
initMetadataForCompanion(Companion_5);
protoOf(SliceCoordsImpl).u3h = get_frameOffsetX;
protoOf(SliceCoordsImpl).v3h = get_frameOffsetY;
protoOf(SliceCoordsImpl).w3h = x;
protoOf(SliceCoordsImpl).x3h = y;
initMetadataForClass(SliceCoordsImpl, 'SliceCoordsImpl', VOID, VOID, [SliceCoordsWithBase]);
protoOf(RectCoords).w3h = x;
protoOf(RectCoords).x3h = y;
initMetadataForClass(RectCoords, 'RectCoords', VOID, VOID, [SliceCoords]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(Item, 'Item');
initMetadataForClass(FTrapezoidsInt, 'FTrapezoidsInt', FTrapezoidsInt);
initMetadataForCompanion(Companion_7);
initMetadataForClass(SortOps_0, 'SortOps');
initMetadataForClass(Item_0, 'Item');
initMetadataForClass(FSegmentsInt, 'FSegmentsInt', FSegmentsInt);
initMetadataForObject(SegmentIntToTrapezoidIntList, 'SegmentIntToTrapezoidIntList');
initMetadataForCompanion(Companion_8);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Bucket, 'Bucket', Bucket);
initMetadataForClass(Buckets, 'Buckets');
initMetadataForClass(AllBuckets, 'AllBuckets', AllBuckets);
initMetadataForClass(XWithWind, 'XWithWind', XWithWind);
initMetadataForObject(IntArrayListSort, 'IntArrayListSort');
initMetadataForClass(RastScale, 'RastScale', RastScale);
initMetadataForClass(PolygonScanline, 'PolygonScanline', PolygonScanline);
initMetadataForCompanion(Companion_10);
initMetadataForCompanion(Companion_11);
initMetadataForClass(MEdge, 'MEdge', MEdge);
initMetadataForClass(EdgePoint, 'EdgePoint');
initMetadataForClass(StrokeToFill, 'StrokeToFill', StrokeToFill);
initMetadataForInterface(VectorBuilder, 'VectorBuilder');
protoOf(VectorBuilder$transformed$1).x3o = line;
protoOf(VectorBuilder$transformed$1).y3o = rect;
protoOf(VectorBuilder$transformed$1).z3o = rect_0;
protoOf(VectorBuilder$transformed$1).a3p = rect_1;
protoOf(VectorBuilder$transformed$1).b3p = arc;
protoOf(VectorBuilder$transformed$1).c3p = arc$default;
protoOf(VectorBuilder$transformed$1).d3p = circle;
protoOf(VectorBuilder$transformed$1).e3p = rMoveTo;
protoOf(VectorBuilder$transformed$1).f3p = rLineTo;
protoOf(VectorBuilder$transformed$1).x2e = transformed;
initMetadataForClass(VectorBuilder$transformed$1, VOID, VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_12);
initMetadataForInterface(Visitor, 'Visitor');
protoOf(VectorPath).x3o = line;
protoOf(VectorPath).g1 = isEmpty;
protoOf(VectorPath).o27 = isNotEmpty;
protoOf(VectorPath).y3o = rect;
protoOf(VectorPath).z3o = rect_0;
protoOf(VectorPath).a3p = rect_1;
protoOf(VectorPath).b3p = arc;
protoOf(VectorPath).c3p = arc$default;
protoOf(VectorPath).d3p = circle;
protoOf(VectorPath).e3p = rMoveTo;
protoOf(VectorPath).f3p = rLineTo;
protoOf(VectorPath).x2e = transformed;
protoOf(VectorPath).g3p = transformed_0;
initMetadataForClass(VectorPath, 'VectorPath', VectorPath, VOID, [AbstractShape2D, VectorBuilder]);
initMetadataForClass(VectorPathTrapezoids, 'VectorPathTrapezoids');
protoOf(with$1).c6 = close;
protoOf(with$1).h3e = lineTo;
protoOf(with$1).i3e = quadTo_0;
protoOf(with$1).v3d = cubicTo;
initMetadataForClass(with$1, VOID, VOID, VOID, [Visitor]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Winding, 'Winding');
initMetadataForCompanion(Companion_14);
initMetadataForClass(LineJoin, 'LineJoin');
initMetadataForCompanion(Companion_15);
initMetadataForClass(LineCap, 'LineCap');
initMetadataForClass(LineScaleMode, 'LineScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(StrokeInfo, 'StrokeInfo', StrokeInfo);
initMetadataForCompanion(Companion_17);
protoOf(MPoint).bx = isAlmostEquals$default;
initMetadataForClass(MPoint, 'MPoint', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(MMatrix, 'MMatrix', MMatrix);
initMetadataForCompanion(Companion_19);
initMetadataForClass(MLine, 'MLine', MLine.f3r);
initMetadataForCompanion(Companion_20);
protoOf(MRectangle).bx = isAlmostEquals$default;
initMetadataForClass(MRectangle, 'MRectangle', VOID, VOID, [IsAlmostEquals]);
protoOf(Easings).ex = invoke;
protoOf(Easings).fx = invoke_0;
initMetadataForClass(Easings, 'Easings', VOID, VOID, [Easing, Enum]);
initMetadataForClass(Easings$SMOOTH, 'SMOOTH');
initMetadataForClass(Easings$EASE_IN_ELASTIC, 'EASE_IN_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_ELASTIC, 'EASE_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_BOUNCE, 'EASE_OUT_BOUNCE');
initMetadataForClass(Easings$LINEAR, 'LINEAR');
initMetadataForClass(Easings$EASE, 'EASE');
initMetadataForClass(Easings$EASE_IN, 'EASE_IN');
initMetadataForClass(Easings$EASE_OUT, 'EASE_OUT');
initMetadataForClass(Easings$EASE_IN_OUT, 'EASE_IN_OUT');
initMetadataForClass(Easings$EASE_IN_OLD, 'EASE_IN_OLD');
initMetadataForClass(Easings$EASE_OUT_OLD, 'EASE_OUT_OLD');
initMetadataForClass(Easings$EASE_IN_OUT_OLD, 'EASE_IN_OUT_OLD');
initMetadataForClass(Easings$EASE_OUT_IN_OLD, 'EASE_OUT_IN_OLD');
initMetadataForClass(Easings$EASE_IN_BACK, 'EASE_IN_BACK');
initMetadataForClass(Easings$EASE_OUT_BACK, 'EASE_OUT_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_BACK, 'EASE_IN_OUT_BACK');
initMetadataForClass(Easings$EASE_OUT_IN_BACK, 'EASE_OUT_IN_BACK');
initMetadataForClass(Easings$EASE_IN_OUT_ELASTIC, 'EASE_IN_OUT_ELASTIC');
initMetadataForClass(Easings$EASE_OUT_IN_ELASTIC, 'EASE_OUT_IN_ELASTIC');
initMetadataForClass(Easings$EASE_IN_BOUNCE, 'EASE_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_OUT_BOUNCE, 'EASE_IN_OUT_BOUNCE');
initMetadataForClass(Easings$EASE_OUT_IN_BOUNCE, 'EASE_OUT_IN_BOUNCE');
initMetadataForClass(Easings$EASE_IN_QUAD, 'EASE_IN_QUAD');
initMetadataForClass(Easings$EASE_OUT_QUAD, 'EASE_OUT_QUAD');
initMetadataForClass(Easings$EASE_IN_OUT_QUAD, 'EASE_IN_OUT_QUAD');
initMetadataForClass(Easings$EASE_SINE, 'EASE_SINE');
initMetadataForClass(Easings$EASE_CLAMP_START, 'EASE_CLAMP_START');
initMetadataForClass(Easings$EASE_CLAMP_END, 'EASE_CLAMP_END');
initMetadataForClass(Easings$EASE_CLAMP_MIDDLE, 'EASE_CLAMP_MIDDLE');
initMetadataForClass(P, 'P');
protoOf(EasingCubic).ex = invoke;
protoOf(EasingCubic).fx = invoke_0;
initMetadataForClass(EasingCubic, 'EasingCubic', VOID, VOID, [Easing]);
//endregion
//region block: init
Arc_instance = new Arc();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Convex_instance = new Convex();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
SegmentIntToTrapezoidIntList_instance = new SegmentIntToTrapezoidIntList();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
Companion_instance_14 = new Companion_14();
Companion_instance_15 = new Companion_15();
Companion_instance_16 = new Companion_16();
Companion_instance_19 = new Companion_19();
//endregion
//region block: exports
export {
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance3u9930f4wm838,
  HitTestDirection_ANY_getInstance as HitTestDirection_ANY_getInstance1hlnrhgqmsigf,
  LineCap_BUTT_getInstance as LineCap_BUTT_getInstancetv7srcehoz43,
  LineJoin_MITER_getInstance as LineJoin_MITER_getInstance35lw9h64apo2h,
  LineScaleMode_NONE_getInstance as LineScaleMode_NONE_getInstance2mlqkio15xcm4,
  LineScaleMode_NORMAL_getInstance as LineScaleMode_NORMAL_getInstance1wxue9rdh6hry,
  Winding_EVEN_ODD_getInstance as Winding_EVEN_ODD_getInstancemyc10vdu2m52,
  Winding_NON_ZERO_getInstance as Winding_NON_ZERO_getInstance38kh1ikwl48ly,
  arc$default as arc$default4sjbw0e0mkug,
  _SliceOrientation___get_flipX__impl__lgb7bx as _SliceOrientation___get_flipX__impl__lgb7bx2vjjbyotgryi3,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2n27zigfr3r41,
  _SliceOrientation___get_rotation__impl__m65r0o as _SliceOrientation___get_rotation__impl__m65r0o2xos42p9chv89,
  Companion_getInstance_8 as Companion_getInstance154uzbkgf0e3s,
  Companion_instance_1 as Companion_instanceeeaudfwfrq87,
  Companion_instance_5 as Companion_instance2i0t7ux7bzoqc,
  Companion_getInstance_13 as Companion_getInstance2kfoysd3on6as,
  Companion_getInstance_26 as Companion_getInstance3d17rumlj92i7,
  ProjectedPoint as ProjectedPoint37gr1oedqap6n,
  Bezier as Bezier1nrnsph9esuxa,
  get_isConvex as get_isConvex3nm4n5empqw0n,
  toBezier as toBezier1cphbqwqpx0d3,
  toStrokePointsList as toStrokePointsList2dojuc3rfktd4,
  ImageDoNotFitException as ImageDoNotFitException2gm4q4wt4lh58,
  get_cachedPoints as get_cachedPoints16ehjcv6uuio1,
  getPoints2List as getPoints2List1zux0vi6zk0wt,
  RectSlice as RectSlicec5msorw5q4el,
  SliceOrientation as SliceOrientation5szkqzxt7oev,
  PolygonScanline as PolygonScanline1ccjpk6mqxyxd,
  RastScale as RastScale3rcmuinujik1d,
  StrokeInfo as StrokeInfo1cunqczl43ffk,
  StrokeToFill as StrokeToFill127v8ehrppf9e,
  arc as arc1vjl2w7wqv39k,
  circle as circle1t8rrxfrm1ku9,
  isEmpty as isEmpty3b7xkdp0by4c8,
  line as line3u2mk0n2uhnlh,
  rLineTo as rLineTo1671hm1vy9pme,
  rMoveTo as rMoveTo38ittbd8h3wn5,
  rect as rect1tyihxx4629c2,
  rect_0 as rect31bppuugx2wch,
  rect_1 as rect3nqbmqh4a4l2a,
  transformed as transformed2t6vo3srmaaf9,
  VectorBuilder as VectorBuilder2g8a28qau4ty9,
  VectorPath as VectorPath1chx1oqdw6sb9,
  applyTransform as applyTransform1vhqlmleb4dce,
  getCurves as getCurves2yjahbp68cxj3,
  plus_0 as plus1r33v70e4ipd7,
  strokeToFill_0 as strokeToFill34bvxzbc34djp,
  strokeToFill as strokeToFill2j5wye7yyxd99,
  toCurvesList as toCurvesList2ibv2opnrpohn,
  write as write11msa0gyjblqp,
  MMatrix as MMatrix1y71lv7vv6y8t,
  get_immutable as get_immutablepxpdoj6e54ll,
  get_mutable as get_mutableqzgwrema46rx,
  toMatrix4 as toMatrix42ci5k1es0x1v1,
  get_EASE as get_EASElq2v0gsk9fz7,
  get_EASE_IN as get_EASE_IN3dgilxucimnao,
  get_EASE_IN_OUT_QUAD as get_EASE_IN_OUT_QUAD21w3u6e1aoexb,
  IntSegmentSet as IntSegmentSet3br6yjcm9q2bd,
};
//endregion
